var $u = Object.defineProperty;
var zu = (t, e, r) => e in t ? $u(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var Qe = (t, e, r) => (zu(t, typeof e != "symbol" ? e + "" : e, r), r);
import { jsx as q, jsxs as je, Fragment as ni } from "react/jsx-runtime";
import Uu, { createContext as it, useContext as Ce, createElement as He, forwardRef as uo, memo as Yu, useDebugValue as Fn, useMemo as Le, useEffect as oe, useLayoutEffect as Bu, useRef as re, useState as de, useCallback as F, useReducer as Ln, cloneElement as hr, Suspense as qu } from "react";
import * as Ku from "@tanstack/react-query";
import { useSuspenseQuery as Xu, dehydrate as Vu, hydrate as Qu, QueryClientProvider as Gu, QueryClient as Ju } from "@tanstack/react-query";
import { I18nextProvider as Zu, useTranslation as el } from "react-i18next";
import "i18next";
import { createPortal as tl } from "react-dom";
var Te = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function pe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var lo = { exports: {} };
(function(t, e) {
  (function(a, n) {
    t.exports = n(Uu);
  })(Te, (r) => (
    /******/
    (() => {
      var a = {
        /***/
        "./node_modules/css-mediaquery/index.js": (
          /*!**********************************************!*\
            !*** ./node_modules/css-mediaquery/index.js ***!
            \**********************************************/
          /***/
          (u, i) => {
            i.match = p, i.parse = g;
            var d = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, s = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, m = /^(?:(min|max)-)?(.+)/, y = /(em|rem|px|cm|mm|in|pt|pc)?$/, v = /(dpi|dpcm|dppx)?$/;
            function p(h, f) {
              return g(h).some(function(w) {
                var _ = w.inverse, x = w.type === "all" || f.type === w.type;
                if (x && _ || !(x || _))
                  return !1;
                var T = w.expressions.every(function(O) {
                  var P = O.feature, R = O.modifier, D = O.value, S = f[P];
                  if (!S)
                    return !1;
                  switch (P) {
                    case "orientation":
                    case "scan":
                      return S.toLowerCase() === D.toLowerCase();
                    case "width":
                    case "height":
                    case "device-width":
                    case "device-height":
                      D = M(D), S = M(S);
                      break;
                    case "resolution":
                      D = b(D), S = b(S);
                      break;
                    case "aspect-ratio":
                    case "device-aspect-ratio":
                    case /* Deprecated */
                    "device-pixel-ratio":
                      D = c(D), S = c(S);
                      break;
                    case "grid":
                    case "color":
                    case "color-index":
                    case "monochrome":
                      D = parseInt(D, 10) || 1, S = parseInt(S, 10) || 0;
                      break;
                  }
                  switch (R) {
                    case "min":
                      return S >= D;
                    case "max":
                      return S <= D;
                    default:
                      return S === D;
                  }
                });
                return T && !_ || !T && _;
              });
            }
            function g(h) {
              return h.split(",").map(function(f) {
                f = f.trim();
                var w = f.match(d), _ = w[1], x = w[2], T = w[3] || "", O = {};
                return O.inverse = !!_ && _.toLowerCase() === "not", O.type = x ? x.toLowerCase() : "all", T = T.match(/\([^\)]+\)/g) || [], O.expressions = T.map(function(P) {
                  var R = P.match(s), D = R[1].toLowerCase().match(m);
                  return {
                    modifier: D[1],
                    feature: D[2],
                    value: R[2]
                  };
                }), O;
              });
            }
            function c(h) {
              var f = Number(h), w;
              return f || (w = h.match(/^(\d+)\s*\/\s*(\d+)$/), f = w[1] / w[2]), f;
            }
            function b(h) {
              var f = parseFloat(h), w = String(h).match(v)[1];
              switch (w) {
                case "dpcm":
                  return f / 2.54;
                case "dppx":
                  return f * 96;
                default:
                  return f;
              }
            }
            function M(h) {
              var f = parseFloat(h), w = String(h).match(y)[1];
              switch (w) {
                case "em":
                  return f * 16;
                case "rem":
                  return f * 16;
                case "cm":
                  return f * 96 / 2.54;
                case "mm":
                  return f * 96 / 2.54 / 10;
                case "in":
                  return f * 96;
                case "pt":
                  return f * 72;
                case "pc":
                  return f * 72 / 12;
                default:
                  return f;
              }
            }
          }
        ),
        /***/
        "./node_modules/hyphenate-style-name/index.js": (
          /*!****************************************************!*\
            !*** ./node_modules/hyphenate-style-name/index.js ***!
            \****************************************************/
          /***/
          (u, i, d) => {
            d.r(i), d.d(i, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var s = /[A-Z]/g, m = /^ms-/, y = {};
            function v(c) {
              return "-" + c.toLowerCase();
            }
            function p(c) {
              if (y.hasOwnProperty(c))
                return y[c];
              var b = c.replace(s, v);
              return y[c] = m.test(b) ? "-" + b : b;
            }
            const g = p;
          }
        ),
        /***/
        "./node_modules/matchmediaquery/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/matchmediaquery/index.js ***!
            \***********************************************/
          /***/
          (u, i, d) => {
            var s = d(
              /*! css-mediaquery */
              "./node_modules/css-mediaquery/index.js"
            ).match, m = typeof window < "u" ? window.matchMedia : null;
            function y(p, g, c) {
              var b = this;
              if (m && !c) {
                var M = m.call(window, p);
                this.matches = M.matches, this.media = M.media, M.addListener(w);
              } else
                this.matches = s(p, g), this.media = p;
              this.addListener = h, this.removeListener = f, this.dispose = _;
              function h(x) {
                M && M.addListener(x);
              }
              function f(x) {
                M && M.removeListener(x);
              }
              function w(x) {
                b.matches = x.matches, b.media = x.media;
              }
              function _() {
                M && M.removeListener(w);
              }
            }
            function v(p, g, c) {
              return new y(p, g, c);
            }
            u.exports = v;
          }
        ),
        /***/
        "./node_modules/object-assign/index.js": (
          /*!*********************************************!*\
            !*** ./node_modules/object-assign/index.js ***!
            \*********************************************/
          /***/
          (u) => {
            /*
            object-assign
            (c) Sindre Sorhus
            @license MIT
            */
            var i = Object.getOwnPropertySymbols, d = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
            function m(v) {
              if (v == null)
                throw new TypeError("Object.assign cannot be called with null or undefined");
              return Object(v);
            }
            function y() {
              try {
                if (!Object.assign)
                  return !1;
                var v = new String("abc");
                if (v[5] = "de", Object.getOwnPropertyNames(v)[0] === "5")
                  return !1;
                for (var p = {}, g = 0; g < 10; g++)
                  p["_" + String.fromCharCode(g)] = g;
                var c = Object.getOwnPropertyNames(p).map(function(M) {
                  return p[M];
                });
                if (c.join("") !== "0123456789")
                  return !1;
                var b = {};
                return "abcdefghijklmnopqrst".split("").forEach(function(M) {
                  b[M] = M;
                }), Object.keys(Object.assign({}, b)).join("") === "abcdefghijklmnopqrst";
              } catch {
                return !1;
              }
            }
            u.exports = y() ? Object.assign : function(v, p) {
              for (var g, c = m(v), b, M = 1; M < arguments.length; M++) {
                g = Object(arguments[M]);
                for (var h in g)
                  d.call(g, h) && (c[h] = g[h]);
                if (i) {
                  b = i(g);
                  for (var f = 0; f < b.length; f++)
                    s.call(g, b[f]) && (c[b[f]] = g[b[f]]);
                }
              }
              return c;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/checkPropTypes.js": (
          /*!***************************************************!*\
            !*** ./node_modules/prop-types/checkPropTypes.js ***!
            \***************************************************/
          /***/
          (u, i, d) => {
            var s = function() {
            };
            {
              var m = d(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), y = {}, v = d(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              );
              s = function(g) {
                var c = "Warning: " + g;
                typeof console < "u" && console.error(c);
                try {
                  throw new Error(c);
                } catch {
                }
              };
            }
            function p(g, c, b, M, h) {
              for (var f in g)
                if (v(g, f)) {
                  var w;
                  try {
                    if (typeof g[f] != "function") {
                      var _ = Error(
                        (M || "React class") + ": " + b + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                      );
                      throw _.name = "Invariant Violation", _;
                    }
                    w = g[f](c, f, M, b, null, m);
                  } catch (T) {
                    w = T;
                  }
                  if (w && !(w instanceof Error) && s(
                    (M || "React class") + ": type specification of " + b + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof w + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                  ), w instanceof Error && !(w.message in y)) {
                    y[w.message] = !0;
                    var x = h ? h() : "";
                    s(
                      "Failed " + b + " type: " + w.message + (x ?? "")
                    );
                  }
                }
            }
            p.resetWarningCache = function() {
              y = {};
            }, u.exports = p;
          }
        ),
        /***/
        "./node_modules/prop-types/factoryWithTypeCheckers.js": (
          /*!************************************************************!*\
            !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
            \************************************************************/
          /***/
          (u, i, d) => {
            var s = d(
              /*! react-is */
              "./node_modules/react-is/index.js"
            ), m = d(
              /*! object-assign */
              "./node_modules/object-assign/index.js"
            ), y = d(
              /*! ./lib/ReactPropTypesSecret */
              "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
            ), v = d(
              /*! ./lib/has */
              "./node_modules/prop-types/lib/has.js"
            ), p = d(
              /*! ./checkPropTypes */
              "./node_modules/prop-types/checkPropTypes.js"
            ), g = function() {
            };
            g = function(b) {
              var M = "Warning: " + b;
              typeof console < "u" && console.error(M);
              try {
                throw new Error(M);
              } catch {
              }
            };
            function c() {
              return null;
            }
            u.exports = function(b, M) {
              var h = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
              function w(k) {
                var W = k && (h && k[h] || k[f]);
                if (typeof W == "function")
                  return W;
              }
              var _ = "<<anonymous>>", x = {
                array: R("array"),
                bigint: R("bigint"),
                bool: R("boolean"),
                func: R("function"),
                number: R("number"),
                object: R("object"),
                string: R("string"),
                symbol: R("symbol"),
                any: D(),
                arrayOf: S,
                element: N(),
                elementType: C(),
                instanceOf: A,
                node: ue(),
                objectOf: Q,
                oneOf: V,
                oneOfType: G,
                shape: te,
                exact: ve
              };
              function T(k, W) {
                return k === W ? k !== 0 || 1 / k === 1 / W : k !== k && W !== W;
              }
              function O(k, W) {
                this.message = k, this.data = W && typeof W == "object" ? W : {}, this.stack = "";
              }
              O.prototype = Error.prototype;
              function P(k) {
                var W = {}, K = 0;
                function Y(Z, H, $, B, ie, X, j) {
                  if (B = B || _, X = X || $, j !== y) {
                    if (M) {
                      var le = new Error(
                        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                      );
                      throw le.name = "Invariant Violation", le;
                    } else if (typeof console < "u") {
                      var we = B + ":" + $;
                      !W[we] && // Avoid spamming the console because they are often not actionable except for lib authors
                      K < 3 && (g(
                        "You are manually calling a React.PropTypes validation function for the `" + X + "` prop on `" + B + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                      ), W[we] = !0, K++);
                    }
                  }
                  return H[$] == null ? Z ? H[$] === null ? new O("The " + ie + " `" + X + "` is marked as required " + ("in `" + B + "`, but its value is `null`.")) : new O("The " + ie + " `" + X + "` is marked as required in " + ("`" + B + "`, but its value is `undefined`.")) : null : k(H, $, B, ie, X);
                }
                var z = Y.bind(null, !1);
                return z.isRequired = Y.bind(null, !0), z;
              }
              function R(k) {
                function W(K, Y, z, Z, H, $) {
                  var B = K[Y], ie = J(B);
                  if (ie !== k) {
                    var X = se(B);
                    return new O(
                      "Invalid " + Z + " `" + H + "` of type " + ("`" + X + "` supplied to `" + z + "`, expected ") + ("`" + k + "`."),
                      { expectedType: k }
                    );
                  }
                  return null;
                }
                return P(W);
              }
              function D() {
                return P(c);
              }
              function S(k) {
                function W(K, Y, z, Z, H) {
                  if (typeof k != "function")
                    return new O("Property `" + H + "` of component `" + z + "` has invalid PropType notation inside arrayOf.");
                  var $ = K[Y];
                  if (!Array.isArray($)) {
                    var B = J($);
                    return new O("Invalid " + Z + " `" + H + "` of type " + ("`" + B + "` supplied to `" + z + "`, expected an array."));
                  }
                  for (var ie = 0; ie < $.length; ie++) {
                    var X = k($, ie, z, Z, H + "[" + ie + "]", y);
                    if (X instanceof Error)
                      return X;
                  }
                  return null;
                }
                return P(W);
              }
              function N() {
                function k(W, K, Y, z, Z) {
                  var H = W[K];
                  if (!b(H)) {
                    var $ = J(H);
                    return new O("Invalid " + z + " `" + Z + "` of type " + ("`" + $ + "` supplied to `" + Y + "`, expected a single ReactElement."));
                  }
                  return null;
                }
                return P(k);
              }
              function C() {
                function k(W, K, Y, z, Z) {
                  var H = W[K];
                  if (!s.isValidElementType(H)) {
                    var $ = J(H);
                    return new O("Invalid " + z + " `" + Z + "` of type " + ("`" + $ + "` supplied to `" + Y + "`, expected a single ReactElement type."));
                  }
                  return null;
                }
                return P(k);
              }
              function A(k) {
                function W(K, Y, z, Z, H) {
                  if (!(K[Y] instanceof k)) {
                    var $ = k.name || _, B = be(K[Y]);
                    return new O("Invalid " + Z + " `" + H + "` of type " + ("`" + B + "` supplied to `" + z + "`, expected ") + ("instance of `" + $ + "`."));
                  }
                  return null;
                }
                return P(W);
              }
              function V(k) {
                if (!Array.isArray(k))
                  return arguments.length > 1 ? g(
                    "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                  ) : g("Invalid argument supplied to oneOf, expected an array."), c;
                function W(K, Y, z, Z, H) {
                  for (var $ = K[Y], B = 0; B < k.length; B++)
                    if (T($, k[B]))
                      return null;
                  var ie = JSON.stringify(k, function(j, le) {
                    var we = se(le);
                    return we === "symbol" ? String(le) : le;
                  });
                  return new O("Invalid " + Z + " `" + H + "` of value `" + String($) + "` " + ("supplied to `" + z + "`, expected one of " + ie + "."));
                }
                return P(W);
              }
              function Q(k) {
                function W(K, Y, z, Z, H) {
                  if (typeof k != "function")
                    return new O("Property `" + H + "` of component `" + z + "` has invalid PropType notation inside objectOf.");
                  var $ = K[Y], B = J($);
                  if (B !== "object")
                    return new O("Invalid " + Z + " `" + H + "` of type " + ("`" + B + "` supplied to `" + z + "`, expected an object."));
                  for (var ie in $)
                    if (v($, ie)) {
                      var X = k($, ie, z, Z, H + "." + ie, y);
                      if (X instanceof Error)
                        return X;
                    }
                  return null;
                }
                return P(W);
              }
              function G(k) {
                if (!Array.isArray(k))
                  return g("Invalid argument supplied to oneOfType, expected an instance of array."), c;
                for (var W = 0; W < k.length; W++) {
                  var K = k[W];
                  if (typeof K != "function")
                    return g(
                      "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + fe(K) + " at index " + W + "."
                    ), c;
                }
                function Y(z, Z, H, $, B) {
                  for (var ie = [], X = 0; X < k.length; X++) {
                    var j = k[X], le = j(z, Z, H, $, B, y);
                    if (le == null)
                      return null;
                    le.data && v(le.data, "expectedType") && ie.push(le.data.expectedType);
                  }
                  var we = ie.length > 0 ? ", expected one of type [" + ie.join(", ") + "]" : "";
                  return new O("Invalid " + $ + " `" + B + "` supplied to " + ("`" + H + "`" + we + "."));
                }
                return P(Y);
              }
              function ue() {
                function k(W, K, Y, z, Z) {
                  return L(W[K]) ? null : new O("Invalid " + z + " `" + Z + "` supplied to " + ("`" + Y + "`, expected a ReactNode."));
                }
                return P(k);
              }
              function ee(k, W, K, Y, z) {
                return new O(
                  (k || "React class") + ": " + W + " type `" + K + "." + Y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + z + "`."
                );
              }
              function te(k) {
                function W(K, Y, z, Z, H) {
                  var $ = K[Y], B = J($);
                  if (B !== "object")
                    return new O("Invalid " + Z + " `" + H + "` of type `" + B + "` " + ("supplied to `" + z + "`, expected `object`."));
                  for (var ie in k) {
                    var X = k[ie];
                    if (typeof X != "function")
                      return ee(z, Z, H, ie, se(X));
                    var j = X($, ie, z, Z, H + "." + ie, y);
                    if (j)
                      return j;
                  }
                  return null;
                }
                return P(W);
              }
              function ve(k) {
                function W(K, Y, z, Z, H) {
                  var $ = K[Y], B = J($);
                  if (B !== "object")
                    return new O("Invalid " + Z + " `" + H + "` of type `" + B + "` " + ("supplied to `" + z + "`, expected `object`."));
                  var ie = m({}, K[Y], k);
                  for (var X in ie) {
                    var j = k[X];
                    if (v(k, X) && typeof j != "function")
                      return ee(z, Z, H, X, se(j));
                    if (!j)
                      return new O(
                        "Invalid " + Z + " `" + H + "` key `" + X + "` supplied to `" + z + "`.\nBad object: " + JSON.stringify(K[Y], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(k), null, "  ")
                      );
                    var le = j($, X, z, Z, H + "." + X, y);
                    if (le)
                      return le;
                  }
                  return null;
                }
                return P(W);
              }
              function L(k) {
                switch (typeof k) {
                  case "number":
                  case "string":
                  case "undefined":
                    return !0;
                  case "boolean":
                    return !k;
                  case "object":
                    if (Array.isArray(k))
                      return k.every(L);
                    if (k === null || b(k))
                      return !0;
                    var W = w(k);
                    if (W) {
                      var K = W.call(k), Y;
                      if (W !== k.entries) {
                        for (; !(Y = K.next()).done; )
                          if (!L(Y.value))
                            return !1;
                      } else
                        for (; !(Y = K.next()).done; ) {
                          var z = Y.value;
                          if (z && !L(z[1]))
                            return !1;
                        }
                    } else
                      return !1;
                    return !0;
                  default:
                    return !1;
                }
              }
              function U(k, W) {
                return k === "symbol" ? !0 : W ? W["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && W instanceof Symbol : !1;
              }
              function J(k) {
                var W = typeof k;
                return Array.isArray(k) ? "array" : k instanceof RegExp ? "object" : U(W, k) ? "symbol" : W;
              }
              function se(k) {
                if (typeof k > "u" || k === null)
                  return "" + k;
                var W = J(k);
                if (W === "object") {
                  if (k instanceof Date)
                    return "date";
                  if (k instanceof RegExp)
                    return "regexp";
                }
                return W;
              }
              function fe(k) {
                var W = se(k);
                switch (W) {
                  case "array":
                  case "object":
                    return "an " + W;
                  case "boolean":
                  case "date":
                  case "regexp":
                    return "a " + W;
                  default:
                    return W;
                }
              }
              function be(k) {
                return !k.constructor || !k.constructor.name ? _ : k.constructor.name;
              }
              return x.checkPropTypes = p, x.resetWarningCache = p.resetWarningCache, x.PropTypes = x, x;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/index.js": (
          /*!******************************************!*\
            !*** ./node_modules/prop-types/index.js ***!
            \******************************************/
          /***/
          (u, i, d) => {
            {
              var s = d(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), m = !0;
              u.exports = d(
                /*! ./factoryWithTypeCheckers */
                "./node_modules/prop-types/factoryWithTypeCheckers.js"
              )(s.isElement, m);
            }
          }
        ),
        /***/
        "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
            \*************************************************************/
          /***/
          (u) => {
            var i = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            u.exports = i;
          }
        ),
        /***/
        "./node_modules/prop-types/lib/has.js": (
          /*!********************************************!*\
            !*** ./node_modules/prop-types/lib/has.js ***!
            \********************************************/
          /***/
          (u) => {
            u.exports = Function.call.bind(Object.prototype.hasOwnProperty);
          }
        ),
        /***/
        "./node_modules/react-is/cjs/react-is.development.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/react-is/cjs/react-is.development.js ***!
            \***********************************************************/
          /***/
          (u, i) => {
            /** @license React v16.13.1
             * react-is.development.js
             *
             * Copyright (c) Facebook, Inc. and its affiliates.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */
            (function() {
              var d = typeof Symbol == "function" && Symbol.for, s = d ? Symbol.for("react.element") : 60103, m = d ? Symbol.for("react.portal") : 60106, y = d ? Symbol.for("react.fragment") : 60107, v = d ? Symbol.for("react.strict_mode") : 60108, p = d ? Symbol.for("react.profiler") : 60114, g = d ? Symbol.for("react.provider") : 60109, c = d ? Symbol.for("react.context") : 60110, b = d ? Symbol.for("react.async_mode") : 60111, M = d ? Symbol.for("react.concurrent_mode") : 60111, h = d ? Symbol.for("react.forward_ref") : 60112, f = d ? Symbol.for("react.suspense") : 60113, w = d ? Symbol.for("react.suspense_list") : 60120, _ = d ? Symbol.for("react.memo") : 60115, x = d ? Symbol.for("react.lazy") : 60116, T = d ? Symbol.for("react.block") : 60121, O = d ? Symbol.for("react.fundamental") : 60117, P = d ? Symbol.for("react.responder") : 60118, R = d ? Symbol.for("react.scope") : 60119;
              function D(j) {
                return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                j === y || j === M || j === p || j === v || j === f || j === w || typeof j == "object" && j !== null && (j.$$typeof === x || j.$$typeof === _ || j.$$typeof === g || j.$$typeof === c || j.$$typeof === h || j.$$typeof === O || j.$$typeof === P || j.$$typeof === R || j.$$typeof === T);
              }
              function S(j) {
                if (typeof j == "object" && j !== null) {
                  var le = j.$$typeof;
                  switch (le) {
                    case s:
                      var we = j.type;
                      switch (we) {
                        case b:
                        case M:
                        case y:
                        case p:
                        case v:
                        case f:
                          return we;
                        default:
                          var Ne = we && we.$$typeof;
                          switch (Ne) {
                            case c:
                            case h:
                            case x:
                            case _:
                            case g:
                              return Ne;
                            default:
                              return le;
                          }
                      }
                    case m:
                      return le;
                  }
                }
              }
              var N = b, C = M, A = c, V = g, Q = s, G = h, ue = y, ee = x, te = _, ve = m, L = p, U = v, J = f, se = !1;
              function fe(j) {
                return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), be(j) || S(j) === b;
              }
              function be(j) {
                return S(j) === M;
              }
              function k(j) {
                return S(j) === c;
              }
              function W(j) {
                return S(j) === g;
              }
              function K(j) {
                return typeof j == "object" && j !== null && j.$$typeof === s;
              }
              function Y(j) {
                return S(j) === h;
              }
              function z(j) {
                return S(j) === y;
              }
              function Z(j) {
                return S(j) === x;
              }
              function H(j) {
                return S(j) === _;
              }
              function $(j) {
                return S(j) === m;
              }
              function B(j) {
                return S(j) === p;
              }
              function ie(j) {
                return S(j) === v;
              }
              function X(j) {
                return S(j) === f;
              }
              i.AsyncMode = N, i.ConcurrentMode = C, i.ContextConsumer = A, i.ContextProvider = V, i.Element = Q, i.ForwardRef = G, i.Fragment = ue, i.Lazy = ee, i.Memo = te, i.Portal = ve, i.Profiler = L, i.StrictMode = U, i.Suspense = J, i.isAsyncMode = fe, i.isConcurrentMode = be, i.isContextConsumer = k, i.isContextProvider = W, i.isElement = K, i.isForwardRef = Y, i.isFragment = z, i.isLazy = Z, i.isMemo = H, i.isPortal = $, i.isProfiler = B, i.isStrictMode = ie, i.isSuspense = X, i.isValidElementType = D, i.typeOf = S;
            })();
          }
        ),
        /***/
        "./node_modules/react-is/index.js": (
          /*!****************************************!*\
            !*** ./node_modules/react-is/index.js ***!
            \****************************************/
          /***/
          (u, i, d) => {
            u.exports = d(
              /*! ./cjs/react-is.development.js */
              "./node_modules/react-is/cjs/react-is.development.js"
            );
          }
        ),
        /***/
        "./node_modules/shallow-equal/dist/index.esm.js": (
          /*!******************************************************!*\
            !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
            \******************************************************/
          /***/
          (u, i, d) => {
            d.r(i), d.d(i, {
              /* harmony export */
              shallowEqualArrays: () => (
                /* binding */
                m
              ),
              /* harmony export */
              shallowEqualObjects: () => (
                /* binding */
                s
              )
              /* harmony export */
            });
            function s(y, v) {
              if (y === v)
                return !0;
              if (!y || !v)
                return !1;
              var p = Object.keys(y), g = Object.keys(v), c = p.length;
              if (g.length !== c)
                return !1;
              for (var b = 0; b < c; b++) {
                var M = p[b];
                if (y[M] !== v[M] || !Object.prototype.hasOwnProperty.call(v, M))
                  return !1;
              }
              return !0;
            }
            function m(y, v) {
              if (y === v)
                return !0;
              if (!y || !v)
                return !1;
              var p = y.length;
              if (v.length !== p)
                return !1;
              for (var g = 0; g < p; g++)
                if (y[g] !== v[g])
                  return !1;
              return !0;
            }
          }
        ),
        /***/
        "./src/Component.ts": (
          /*!**************************!*\
            !*** ./src/Component.ts ***!
            \**************************/
          /***/
          function(u, i, d) {
            var s = this && this.__rest || function(p, g) {
              var c = {};
              for (var b in p)
                Object.prototype.hasOwnProperty.call(p, b) && g.indexOf(b) < 0 && (c[b] = p[b]);
              if (p != null && typeof Object.getOwnPropertySymbols == "function")
                for (var M = 0, b = Object.getOwnPropertySymbols(p); M < b.length; M++)
                  g.indexOf(b[M]) < 0 && Object.prototype.propertyIsEnumerable.call(p, b[M]) && (c[b[M]] = p[b[M]]);
              return c;
            }, m = this && this.__importDefault || function(p) {
              return p && p.__esModule ? p : { default: p };
            };
            Object.defineProperty(i, "__esModule", { value: !0 });
            var y = m(d(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            )), v = function(p) {
              var g = p.children, c = p.device, b = p.onChange, M = s(p, ["children", "device", "onChange"]), h = (0, y.default)(M, c, b);
              return typeof g == "function" ? g(h) : h ? g : null;
            };
            i.default = v;
          }
        ),
        /***/
        "./src/Context.ts": (
          /*!************************!*\
            !*** ./src/Context.ts ***!
            \************************/
          /***/
          (u, i, d) => {
            Object.defineProperty(i, "__esModule", { value: !0 });
            var s = d(
              /*! react */
              "react"
            ), m = (0, s.createContext)(void 0);
            i.default = m;
          }
        ),
        /***/
        "./src/index.ts": (
          /*!**********************!*\
            !*** ./src/index.ts ***!
            \**********************/
          /***/
          function(u, i, d) {
            var s = this && this.__importDefault || function(g) {
              return g && g.__esModule ? g : { default: g };
            };
            Object.defineProperty(i, "__esModule", { value: !0 }), i.Context = i.toQuery = i.useMediaQuery = i.default = void 0;
            var m = s(d(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            ));
            i.useMediaQuery = m.default;
            var y = s(d(
              /*! ./Component */
              "./src/Component.ts"
            ));
            i.default = y.default;
            var v = s(d(
              /*! ./toQuery */
              "./src/toQuery.ts"
            ));
            i.toQuery = v.default;
            var p = s(d(
              /*! ./Context */
              "./src/Context.ts"
            ));
            i.Context = p.default;
          }
        ),
        /***/
        "./src/mediaQuery.ts": (
          /*!***************************!*\
            !*** ./src/mediaQuery.ts ***!
            \***************************/
          /***/
          function(u, i, d) {
            var s = this && this.__assign || function() {
              return s = Object.assign || function(f) {
                for (var w, _ = 1, x = arguments.length; _ < x; _++) {
                  w = arguments[_];
                  for (var T in w)
                    Object.prototype.hasOwnProperty.call(w, T) && (f[T] = w[T]);
                }
                return f;
              }, s.apply(this, arguments);
            }, m = this && this.__rest || function(f, w) {
              var _ = {};
              for (var x in f)
                Object.prototype.hasOwnProperty.call(f, x) && w.indexOf(x) < 0 && (_[x] = f[x]);
              if (f != null && typeof Object.getOwnPropertySymbols == "function")
                for (var T = 0, x = Object.getOwnPropertySymbols(f); T < x.length; T++)
                  w.indexOf(x[T]) < 0 && Object.prototype.propertyIsEnumerable.call(f, x[T]) && (_[x[T]] = f[x[T]]);
              return _;
            }, y = this && this.__importDefault || function(f) {
              return f && f.__esModule ? f : { default: f };
            };
            Object.defineProperty(i, "__esModule", { value: !0 });
            var v = y(d(
              /*! prop-types */
              "./node_modules/prop-types/index.js"
            )), p = v.default.oneOfType([
              v.default.string,
              v.default.number
            ]), g = {
              all: v.default.bool,
              grid: v.default.bool,
              aural: v.default.bool,
              braille: v.default.bool,
              handheld: v.default.bool,
              print: v.default.bool,
              projection: v.default.bool,
              screen: v.default.bool,
              tty: v.default.bool,
              tv: v.default.bool,
              embossed: v.default.bool
            }, c = {
              orientation: v.default.oneOf([
                "portrait",
                "landscape"
              ]),
              scan: v.default.oneOf([
                "progressive",
                "interlace"
              ]),
              aspectRatio: v.default.string,
              deviceAspectRatio: v.default.string,
              height: p,
              deviceHeight: p,
              width: p,
              deviceWidth: p,
              color: v.default.bool,
              colorIndex: v.default.bool,
              monochrome: v.default.bool,
              resolution: p,
              type: Object.keys(g)
            };
            c.type;
            var b = m(
              c,
              ["type"]
            ), M = s({ minAspectRatio: v.default.string, maxAspectRatio: v.default.string, minDeviceAspectRatio: v.default.string, maxDeviceAspectRatio: v.default.string, minHeight: p, maxHeight: p, minDeviceHeight: p, maxDeviceHeight: p, minWidth: p, maxWidth: p, minDeviceWidth: p, maxDeviceWidth: p, minColor: v.default.number, maxColor: v.default.number, minColorIndex: v.default.number, maxColorIndex: v.default.number, minMonochrome: v.default.number, maxMonochrome: v.default.number, minResolution: p, maxResolution: p }, b), h = s(s({}, g), M);
            i.default = {
              all: h,
              types: g,
              matchers: c,
              features: M
            };
          }
        ),
        /***/
        "./src/toQuery.ts": (
          /*!************************!*\
            !*** ./src/toQuery.ts ***!
            \************************/
          /***/
          function(u, i, d) {
            var s = this && this.__importDefault || function(b) {
              return b && b.__esModule ? b : { default: b };
            };
            Object.defineProperty(i, "__esModule", { value: !0 });
            var m = s(d(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), y = s(d(
              /*! ./mediaQuery */
              "./src/mediaQuery.ts"
            )), v = function(b) {
              return "not ".concat(b);
            }, p = function(b, M) {
              var h = (0, m.default)(b);
              return typeof M == "number" && (M = "".concat(M, "px")), M === !0 ? h : M === !1 ? v(h) : "(".concat(h, ": ").concat(M, ")");
            }, g = function(b) {
              return b.join(" and ");
            }, c = function(b) {
              var M = [];
              return Object.keys(y.default.all).forEach(function(h) {
                var f = b[h];
                f != null && M.push(p(h, f));
              }), g(M);
            };
            i.default = c;
          }
        ),
        /***/
        "./src/useMediaQuery.ts": (
          /*!******************************!*\
            !*** ./src/useMediaQuery.ts ***!
            \******************************/
          /***/
          function(u, i, d) {
            var s = this && this.__importDefault || function(O) {
              return O && O.__esModule ? O : { default: O };
            };
            Object.defineProperty(i, "__esModule", { value: !0 });
            var m = d(
              /*! react */
              "react"
            ), y = s(d(
              /*! matchmediaquery */
              "./node_modules/matchmediaquery/index.js"
            )), v = s(d(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), p = d(
              /*! shallow-equal */
              "./node_modules/shallow-equal/dist/index.esm.js"
            ), g = s(d(
              /*! ./toQuery */
              "./src/toQuery.ts"
            )), c = s(d(
              /*! ./Context */
              "./src/Context.ts"
            )), b = function(O) {
              return O.query || (0, g.default)(O);
            }, M = function(O) {
              if (O) {
                var P = Object.keys(O);
                return P.reduce(function(R, D) {
                  return R[(0, v.default)(D)] = O[D], R;
                }, {});
              }
            }, h = function() {
              var O = (0, m.useRef)(!1);
              return (0, m.useEffect)(function() {
                O.current = !0;
              }, []), O.current;
            }, f = function(O) {
              var P = (0, m.useContext)(c.default), R = function() {
                return M(O) || M(P);
              }, D = (0, m.useState)(R), S = D[0], N = D[1];
              return (0, m.useEffect)(function() {
                var C = R();
                (0, p.shallowEqualObjects)(S, C) || N(C);
              }, [O, P]), S;
            }, w = function(O) {
              var P = function() {
                return b(O);
              }, R = (0, m.useState)(P), D = R[0], S = R[1];
              return (0, m.useEffect)(function() {
                var N = P();
                D !== N && S(N);
              }, [O]), D;
            }, _ = function(O, P) {
              var R = function() {
                return (0, y.default)(O, P || {}, !!P);
              }, D = (0, m.useState)(R), S = D[0], N = D[1], C = h();
              return (0, m.useEffect)(function() {
                if (C) {
                  var A = R();
                  return N(A), function() {
                    A && A.dispose();
                  };
                }
              }, [O, P]), S;
            }, x = function(O) {
              var P = (0, m.useState)(O.matches), R = P[0], D = P[1];
              return (0, m.useEffect)(function() {
                var S = function(N) {
                  D(N.matches);
                };
                return O.addListener(S), D(O.matches), function() {
                  O.removeListener(S);
                };
              }, [O]), R;
            }, T = function(O, P, R) {
              var D = f(P), S = w(O);
              if (!S)
                throw new Error("Invalid or missing MediaQuery!");
              var N = _(S, D), C = x(N), A = h();
              return (0, m.useEffect)(function() {
                A && R && R(C);
              }, [C]), (0, m.useEffect)(function() {
                return function() {
                  N && N.dispose();
                };
              }, []), C;
            };
            i.default = T;
          }
        ),
        /***/
        react: (
          /*!**************************************************************************************!*\
            !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
            \**************************************************************************************/
          /***/
          (u) => {
            u.exports = r;
          }
        )
        /******/
      }, n = {};
      function o(u) {
        var i = n[u];
        if (i !== void 0)
          return i.exports;
        var d = n[u] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return a[u].call(d.exports, d, d.exports, o), d.exports;
      }
      o.d = (u, i) => {
        for (var d in i)
          o.o(i, d) && !o.o(u, d) && Object.defineProperty(u, d, { enumerable: !0, get: i[d] });
      }, o.o = (u, i) => Object.prototype.hasOwnProperty.call(u, i), o.r = (u) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(u, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(u, "__esModule", { value: !0 });
      };
      var l = o("./src/index.ts");
      return l;
    })()
  ));
})(lo);
var rl = lo.exports;
function al(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function ii(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function E(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ii(Object(r), !0).forEach(function(a) {
      al(t, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ii(Object(r)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return t;
}
function ae(t, e) {
  if (t == null)
    return {};
  var r = {}, a = Object.keys(t), n, o;
  for (o = 0; o < a.length; o++)
    n = a[o], !(e.indexOf(n) >= 0) && (r[n] = t[n]);
  return r;
}
function nl(t, e) {
  if (t) {
    if (typeof t == "string")
      return oi(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return oi(t, e);
  }
}
function oi(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, a = new Array(e); r < e; r++)
    a[r] = t[r];
  return a;
}
function vt(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = nl(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var a = 0;
      return function() {
        return a >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[a++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
var Hn = /* @__PURE__ */ it({});
function il(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function ui(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function Et(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ui(Object(r), !0).forEach(function(a) {
      il(t, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ui(Object(r)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return t;
}
function Sr(t, e) {
  if (t == null)
    return {};
  var r = {}, a = Object.keys(t), n, o;
  for (o = 0; o < a.length; o++)
    n = a[o], !(e.indexOf(n) >= 0) && (r[n] = t[n]);
  return r;
}
function ol(t, e) {
  if (t) {
    if (typeof t == "string")
      return li(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return li(t, e);
  }
}
function li(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, a = new Array(e); r < e; r++)
    a[r] = t[r];
  return a;
}
function di(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = ol(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var a = 0;
      return function() {
        return a >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[a++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
function ul(t) {
  return typeof t == "function";
}
var Ct = function(e, r, a) {
  a === void 0 && (a = r.children);
  var n = Ce(Hn);
  if (n.useCreateElement)
    return n.useCreateElement(e, r, a);
  if (typeof e == "string" && ul(a)) {
    r.children;
    var o = Sr(r, ["children"]);
    return a(o);
  }
  return /* @__PURE__ */ He(e, r, a);
};
function ll(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function si(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function rt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? si(Object(r), !0).forEach(function(a) {
      ll(t, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : si(Object(r)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return t;
}
function dl(t, e) {
  if (t == null)
    return {};
  var r = {}, a = Object.keys(t), n, o;
  for (o = 0; o < a.length; o++)
    n = a[o], !(e.indexOf(n) >= 0) && (r[n] = t[n]);
  return r;
}
function sl(t, e) {
  if (t) {
    if (typeof t == "string")
      return fi(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return fi(t, e);
  }
}
function fi(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, a = new Array(e); r < e; r++)
    a[r] = t[r];
  return a;
}
function fl(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = sl(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var a = 0;
      return function() {
        return a >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[a++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
function $n(t) {
  return typeof t == "object" && t != null;
}
function Tr(t) {
  var e;
  if (!$n(t))
    return !1;
  var r = Object.getPrototypeOf(t);
  return r == null ? !0 : ((e = r.constructor) === null || e === void 0 ? void 0 : e.toString()) === Object.toString();
}
function ci(t, e) {
  for (var r = Object.keys(t), a = {}, n = {}, o = 0, l = r; o < l.length; o++) {
    var u = l[o];
    e.indexOf(u) >= 0 ? a[u] = t[u] : n[u] = t[u];
  }
  return [a, n];
}
function vi(t, e) {
  if (e === void 0 && (e = []), !Tr(t.state))
    return ci(t, e);
  var r = ci(t, [].concat(e, ["state"])), a = r[0], n = r[1], o = a.state, l = dl(a, ["state"]);
  return [rt(rt({}, o), l), n];
}
function Ht(t, e) {
  if (t === e)
    return !0;
  if (!t || !e || typeof t != "object" || typeof e != "object")
    return !1;
  var r = Object.keys(t), a = Object.keys(e), n = r.length;
  if (a.length !== n)
    return !1;
  for (var o = 0, l = r; o < l.length; o++) {
    var u = l[o];
    if (t[u] !== e[u])
      return !1;
  }
  return !0;
}
function mi(t) {
  return t.name === "normalizePropsAreEqualInner" ? t : function(r, a) {
    return !Tr(r.state) || !Tr(a.state) ? t(r, a) : t(rt(rt({}, r.state), r), rt(rt({}, a.state), a));
  };
}
function cl(t) {
  return /* @__PURE__ */ uo(t);
}
function vl(t, e) {
  return /* @__PURE__ */ Yu(t, e);
}
function ge(t) {
  var e = t.as, r = t.useHook, a = t.memo, n = t.propsAreEqual, o = n === void 0 ? r == null ? void 0 : r.unstable_propsAreEqual : n, l = t.keys, u = l === void 0 ? (r == null ? void 0 : r.__keys) || [] : l, i = t.useCreateElement, d = i === void 0 ? Ct : i, s = function(y, v) {
    var p = y.as, g = p === void 0 ? e : p, c = Sr(y, ["as"]);
    if (r) {
      var b, M = vi(c, u), h = M[0], f = M[1], w = r(h, Et({
        ref: v
      }, f)), _ = w.wrapElement, x = Sr(w, ["wrapElement"]), T = ((b = g.render) === null || b === void 0 ? void 0 : b.__keys) || g.__keys, O = T && vi(c, T)[0], P = O ? Et(Et({}, x), O) : x, R = d(g, P);
      return _ ? _(R) : R;
    }
    return d(g, Et({
      ref: v
    }, c));
  };
  return process.env.NODE_ENV !== "production" && r && (s.displayName = r.name.replace(/^(unstable_)?use/, "")), s = cl(s), a && (s = vl(s, o && mi(o))), s.__keys = u, s.unstable_propsAreEqual = mi(o || Ht), s;
}
function so(t, e) {
  Fn(t);
  var r = Ce(Hn);
  return r[t] != null ? r[t] : e;
}
function ml(t, e, r) {
  e === void 0 && (e = {}), r === void 0 && (r = {});
  var a = "use" + t + "Props";
  Fn(a);
  var n = so(a);
  return n ? n(e, r) : r;
}
function hl(t, e, r) {
  e === void 0 && (e = {}), r === void 0 && (r = {});
  var a = "use" + t + "Options";
  Fn(a);
  var n = so(a);
  return n ? Et(Et({}, e), n(e, r)) : e;
}
function pl(t) {
  return Array.isArray(t) ? t : typeof t < "u" ? [t] : [];
}
function ye(t) {
  var e, r, a = pl(t.compose), n = function(i, d) {
    if (t.useOptions && (i = t.useOptions(i, d)), t.name && (i = hl(t.name, i, d)), t.compose)
      for (var s = di(a), m; !(m = s()).done; ) {
        var y = m.value;
        i = y.__useOptions(i, d);
      }
    return i;
  }, o = function(i, d, s) {
    if (i === void 0 && (i = {}), d === void 0 && (d = {}), s === void 0 && (s = !1), s || (i = n(i, d)), t.useProps && (d = t.useProps(i, d)), t.name && (d = ml(t.name, i, d)), t.compose)
      if (t.useComposeOptions && (i = t.useComposeOptions(i, d)), t.useComposeProps)
        d = t.useComposeProps(i, d);
      else
        for (var m = di(a), y; !(y = m()).done; ) {
          var v = y.value;
          d = v(i, d, !0);
        }
    var p = {}, g = d || {};
    for (var c in g)
      g[c] !== void 0 && (p[c] = g[c]);
    return p;
  };
  o.__useOptions = n;
  var l = a.reduce(function(u, i) {
    return u.push.apply(u, i.__keys || []), u;
  }, []);
  return o.__keys = [].concat(l, ((e = t.useState) === null || e === void 0 ? void 0 : e.__keys) || [], t.keys || []), o.unstable_propsAreEqual = t.propsAreEqual || ((r = a[0]) === null || r === void 0 ? void 0 : r.unstable_propsAreEqual) || Ht, process.env.NODE_ENV !== "production" && t.name && Object.defineProperty(o, "name", {
    value: "use" + t.name
  }), o;
}
function hi(t, e) {
  e === void 0 && (e = null), t && (typeof t == "function" ? t(e) : t.current = e);
}
function Be(t, e) {
  return Le(function() {
    return t == null && e == null ? null : function(r) {
      hi(t, r), hi(e, r);
    };
  }, [t, e]);
}
var bl = ["button", "color", "file", "image", "reset", "submit"];
function sr(t) {
  if (t.tagName === "BUTTON")
    return !0;
  if (t.tagName === "INPUT") {
    var e = t;
    return bl.indexOf(e.type) !== -1;
  }
  return !1;
}
function fo(t) {
  for (var e = [], r = fl(t), a; !(a = r()).done; ) {
    var n = a.value;
    Array.isArray(n) ? e.push.apply(e, fo(n)) : e.push(n);
  }
  return e;
}
function De(t) {
  if (process.env.NODE_ENV !== "production") {
    var e;
    if (!t)
      return;
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
      a[n - 1] = arguments[n];
    var o = fo(a.map(function(l) {
      return [l, `
`];
    }));
    (e = console).warn.apply(e, o.slice(0, -1));
    try {
      throw Error(o.join(""));
    } catch {
    }
  }
}
function gl(t) {
  return $n(t) && "current" in t;
}
function Yt(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), a = 1; a < e; a++)
    r[a - 1] = arguments[a];
  process.env.NODE_ENV !== "production" && oe(function() {
    process.env.NODE_ENV !== "production" && De.apply(void 0, [t].concat(r.map(function(n) {
      return gl(n) ? n.current : n;
    })));
  }, [t]);
}
function Me(t) {
  return t ? t.ownerDocument || t : document;
}
var Cr;
try {
  Cr = window;
} catch {
}
function co(t) {
  return t && Me(t).defaultView || Cr;
}
function yl() {
  var t = co();
  return !!(typeof t < "u" && t.document && t.document.createElement);
}
var kt = yl(), ot = kt ? Bu : oe;
function ne(t) {
  var e = re(t);
  return ot(function() {
    e.current = t;
  }), e;
}
function Fe(t) {
  return t.target === t.currentTarget;
}
function Rt(t) {
  var e = Me(t), r = e.activeElement;
  return r != null && r.nodeName ? r : null;
}
function $e(t, e) {
  return t === e || t.contains(e);
}
function Bt(t) {
  var e = Rt(t);
  if (!e)
    return !1;
  if ($e(t, e))
    return !0;
  var r = e.getAttribute("aria-activedescendant");
  return r ? r === t.id ? !0 : !!t.querySelector("#" + r) : !1;
}
function zn(t) {
  return !$e(t.currentTarget, t.target);
}
function dt(t) {
  return kt ? window.navigator.userAgent.indexOf(t) !== -1 : !1;
}
function vo(t, e) {
  return "matches" in t ? t.matches(e) : "msMatchesSelector" in t ? t.msMatchesSelector(e) : t.webkitMatchesSelector(e);
}
function mo(t, e) {
  if ("closest" in t)
    return t.closest(e);
  do {
    if (vo(t, e))
      return t;
    t = t.parentElement || t.parentNode;
  } while (t !== null && t.nodeType === 1);
  return null;
}
var ho = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function Ml(t) {
  var e = t;
  return e.offsetWidth > 0 || e.offsetHeight > 0 || t.getClientRects().length > 0;
}
function wl(t) {
  var e = parseInt(t.getAttribute("tabindex") || "0", 10);
  return e < 0;
}
function po(t) {
  return vo(t, ho) && Ml(t);
}
function kr(t) {
  return po(t) && !wl(t);
}
function bo(t, e) {
  var r = Array.from(t.querySelectorAll(ho)), a = r.filter(kr);
  return kr(t) && a.unshift(t), !a.length && e ? r : a;
}
function go(t, e) {
  var r = bo(t, e), a = r[0];
  return a || null;
}
function _l(t, e) {
  var r = bo(t, e);
  return r[r.length - 1] || null;
}
var El = ["unstable_system"], qt = ye({
  name: "Role",
  keys: El,
  propsAreEqual: function(e, r) {
    var a = e.unstable_system, n = ae(e, ["unstable_system"]), o = r.unstable_system, l = ae(r, ["unstable_system"]);
    return a !== o && !Ht(a, o) ? !1 : Ht(n, l);
  }
});
ge({
  as: "div",
  useHook: qt
});
var Pl = ["disabled", "focusable"], xl = dt("Mac") && !dt("Chrome") && (dt("Safari") || dt("Firefox"));
function pi(t) {
  !Bt(t) && po(t) && t.focus();
}
function Ol(t) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"].includes(t.tagName);
}
function Dl(t) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA"].includes(t.tagName);
}
function Sl(t, e, r, a) {
  return t ? e && !r ? -1 : void 0 : e ? a : a || 0;
}
function pr(t, e) {
  return F(function(r) {
    var a;
    (a = t.current) === null || a === void 0 || a.call(t, r), !r.defaultPrevented && e && (r.stopPropagation(), r.preventDefault());
  }, [t, e]);
}
var nr = ye({
  name: "Tabbable",
  compose: qt,
  keys: Pl,
  useOptions: function(e, r) {
    var a = r.disabled;
    return E({
      disabled: a
    }, e);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.tabIndex, o = r.onClickCapture, l = r.onMouseDownCapture, u = r.onMouseDown, i = r.onKeyPressCapture, d = r.style, s = ae(r, ["ref", "tabIndex", "onClickCapture", "onMouseDownCapture", "onMouseDown", "onKeyPressCapture", "style"]), m = re(null), y = ne(o), v = ne(l), p = ne(u), g = ne(i), c = !!e.disabled && !e.focusable, b = de(!0), M = b[0], h = b[1], f = de(!0), w = f[0], _ = f[1], x = e.disabled ? E({
      pointerEvents: "none"
    }, d) : d;
    ot(function() {
      var D = m.current;
      if (!D) {
        process.env.NODE_ENV !== "production" && De(!0, "Can't determine if the element is a native tabbable element because `ref` wasn't passed to the component.", "See https://reakit.io/docs/tabbable");
        return;
      }
      Ol(D) || h(!1), Dl(D) || _(!1);
    }, []);
    var T = pr(y, e.disabled), O = pr(v, e.disabled), P = pr(g, e.disabled), R = F(function(D) {
      var S;
      (S = p.current) === null || S === void 0 || S.call(p, D);
      var N = D.currentTarget;
      if (!D.defaultPrevented && xl && !zn(D) && sr(N)) {
        var C = requestAnimationFrame(function() {
          N.removeEventListener("mouseup", A, !0), pi(N);
        }), A = function() {
          cancelAnimationFrame(C), pi(N);
        };
        N.addEventListener("mouseup", A, {
          once: !0,
          capture: !0
        });
      }
    }, []);
    return E({
      ref: Be(m, a),
      style: x,
      tabIndex: Sl(c, M, w, n),
      disabled: c && w ? !0 : void 0,
      "aria-disabled": e.disabled ? !0 : void 0,
      onClickCapture: T,
      onMouseDownCapture: O,
      onMouseDown: R,
      onKeyPressCapture: P
    }, s);
  }
});
ge({
  as: "div",
  useHook: nr
});
var Tl = ["unstable_clickOnEnter", "unstable_clickOnSpace"];
function Cl(t) {
  var e = t.currentTarget;
  return t.isTrusted ? sr(e) || e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.tagName === "A" || e.tagName === "SELECT" : !1;
}
var Wt = ye({
  name: "Clickable",
  compose: nr,
  keys: Tl,
  useOptions: function(e) {
    var r = e.unstable_clickOnEnter, a = r === void 0 ? !0 : r, n = e.unstable_clickOnSpace, o = n === void 0 ? !0 : n, l = ae(e, ["unstable_clickOnEnter", "unstable_clickOnSpace"]);
    return E({
      unstable_clickOnEnter: a,
      unstable_clickOnSpace: o
    }, l);
  },
  useProps: function(e, r) {
    var a = r.onKeyDown, n = r.onKeyUp, o = ae(r, ["onKeyDown", "onKeyUp"]), l = de(!1), u = l[0], i = l[1], d = ne(a), s = ne(n), m = F(function(v) {
      var p;
      if ((p = d.current) === null || p === void 0 || p.call(d, v), !v.defaultPrevented && !e.disabled && !v.metaKey && Fe(v)) {
        var g = e.unstable_clickOnEnter && v.key === "Enter", c = e.unstable_clickOnSpace && v.key === " ";
        if (g || c) {
          if (Cl(v))
            return;
          v.preventDefault(), g ? v.currentTarget.click() : c && i(!0);
        }
      }
    }, [e.disabled, e.unstable_clickOnEnter, e.unstable_clickOnSpace]), y = F(function(v) {
      var p;
      if ((p = s.current) === null || p === void 0 || p.call(s, v), !v.defaultPrevented && !e.disabled && !v.metaKey) {
        var g = e.unstable_clickOnSpace && v.key === " ";
        u && g && (i(!1), v.currentTarget.click());
      }
    }, [e.disabled, e.unstable_clickOnSpace, u]);
    return E({
      "data-active": u || void 0,
      onKeyDown: m,
      onKeyUp: y
    }, o);
  }
});
ge({
  as: "button",
  memo: !0,
  useHook: Wt
});
var kl = [], yo = ye({
  name: "Button",
  compose: Wt,
  keys: kl,
  useProps: function(e, r) {
    var a = r.ref, n = ae(r, ["ref"]), o = re(null), l = de(void 0), u = l[0], i = l[1], d = de("button"), s = d[0], m = d[1];
    return oe(function() {
      var y = o.current;
      if (!y) {
        process.env.NODE_ENV !== "production" && De(!0, "Can't determine whether the element is a native button because `ref` wasn't passed to the component", "See https://reakit.io/docs/button");
        return;
      }
      sr(y) || (y.tagName !== "A" && i("button"), m(void 0));
    }, []), E({
      ref: Be(o, a),
      role: u,
      type: s
    }, n);
  }
});
ge({
  as: "button",
  memo: !0,
  useHook: yo
});
function Rl(t, e) {
  return e === -1 ? t : [].concat(t.slice(0, e), t.slice(e + 1));
}
function Mo(t, e, r) {
  if (typeof Event == "function")
    return new Event(e, r);
  var a = Me(t).createEvent("Event");
  return a.initEvent(e, r == null ? void 0 : r.bubbles, r == null ? void 0 : r.cancelable), a;
}
function mt(t) {
  var e = de(t), r = e[0];
  return r;
}
function wo(t, e) {
  var r = re(!1);
  oe(function() {
    if (r.current)
      return t();
    r.current = !0;
  }, e);
}
function bi(t, e, r) {
  return r === void 0 && (r = {}), typeof FocusEvent == "function" ? new FocusEvent(e, r) : Mo(t, e, r);
}
function br(t, e) {
  var r = bi(t, "blur", e), a = t.dispatchEvent(r), n = rt(rt({}, e), {}, {
    bubbles: !0
  });
  return t.dispatchEvent(bi(t, "focusout", n)), a;
}
function jl(t, e, r) {
  if (r === void 0 && (r = {}), typeof KeyboardEvent == "function")
    return new KeyboardEvent(e, r);
  var a = Me(t).createEvent("KeyboardEvent");
  return a.initKeyboardEvent(e, r.bubbles, r.cancelable, co(t), r.key, r.location, r.ctrlKey, r.altKey, r.shiftKey, r.metaKey), a;
}
function Al(t, e, r) {
  return t.dispatchEvent(jl(t, e, r));
}
var Wl = kt && "msCrypto" in window;
function _o(t) {
  if (Wl) {
    var e = Rt(t.currentTarget);
    return e;
  }
  return t.relatedTarget;
}
function ir(t) {
  for (var e = [[]], r = function() {
    var l = n.value, u = e.find(function(i) {
      return !i[0] || i[0].groupId === l.groupId;
    });
    u ? u.push(l) : e.push([l]);
  }, a = vt(t), n; !(n = a()).done; )
    r();
  return e;
}
function Rr(t) {
  for (var e = [], r = vt(t), a; !(a = r()).done; ) {
    var n = a.value;
    e.push.apply(e, n);
  }
  return e;
}
function wt(t) {
  return t.slice().reverse();
}
function Ge(t, e) {
  return e ? t.find(function(r) {
    return !r.disabled && r.id !== e;
  }) : t.find(function(r) {
    return !r.disabled;
  });
}
function lt(t, e) {
  var r;
  return e || e === null ? e : t.currentId || t.currentId === null ? t.currentId : (r = Ge(t.items || [])) === null || r === void 0 ? void 0 : r.id;
}
function Eo(t, e) {
  if (e)
    return t == null ? void 0 : t.find(function(r) {
      return r.id === e && !r.disabled;
    });
}
var Il = ["baseId", "unstable_idCountRef", "setBaseId", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget"], Po = Il, Nl = Po, Fl = Nl;
function xo(t) {
  t.userFocus = !0, t.focus(), t.userFocus = !1;
}
function Ll(t) {
  return !!t.userFocus;
}
function gi(t, e) {
  t.userFocus = e;
}
var Hl = kt && "msCrypto" in window;
function $l(t) {
  return !(!Fe(t) || t.metaKey || t.key === "Tab");
}
function yi(t, e, r) {
  var a = ne(r);
  return F(function(n) {
    var o;
    if ((o = a.current) === null || o === void 0 || o.call(a, n), !n.defaultPrevented && t && $l(n)) {
      var l = e == null ? void 0 : e.ref.current;
      l && (Al(l, n.type, n) || n.preventDefault(), n.currentTarget.contains(l) && n.stopPropagation());
    }
  }, [t, e]);
}
function zl(t) {
  var e = re(null);
  return oe(function() {
    var r = Me(t.current), a = function(o) {
      var l = o.target;
      e.current = l;
    };
    return r.addEventListener("focus", a, !0), function() {
      r.removeEventListener("focus", a, !0);
    };
  }, []), e;
}
function Ul(t) {
  return Ge(Rr(wt(ir(t))));
}
function gr(t, e) {
  return t == null ? void 0 : t.some(function(r) {
    return !!e && r.ref.current === e;
  });
}
function Yl(t) {
  var e = ne(t), r = Ln(function(o) {
    return o + 1;
  }, 0), a = r[0], n = r[1];
  return oe(function() {
    var o, l = (o = e.current) === null || o === void 0 ? void 0 : o.ref.current;
    a && l && xo(l);
  }, [a]), n;
}
var Oo = ye({
  name: "Composite",
  compose: [nr],
  keys: Po,
  useOptions: function(e) {
    return E(E({}, e), {}, {
      currentId: lt(e)
    });
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.onFocusCapture, o = r.onFocus, l = r.onBlurCapture, u = r.onKeyDown, i = r.onKeyDownCapture, d = r.onKeyUpCapture, s = ae(r, ["ref", "onFocusCapture", "onFocus", "onBlurCapture", "onKeyDown", "onKeyDownCapture", "onKeyUpCapture"]), m = re(null), y = Eo(e.items, e.currentId), v = re(null), p = ne(n), g = ne(o), c = ne(l), b = ne(u), M = Yl(y), h = Hl ? zl(m) : void 0;
    oe(function() {
      var P = m.current;
      e.unstable_moves && !y && (process.env.NODE_ENV !== "production" && De(!P, "Can't focus composite component because `ref` wasn't passed to component.", "See https://reakit.io/docs/composite"), P == null || P.focus());
    }, [e.unstable_moves, y]);
    var f = yi(e.unstable_virtual, y, i), w = yi(e.unstable_virtual, y, d), _ = F(function(P) {
      var R;
      if ((R = p.current) === null || R === void 0 || R.call(p, P), !P.defaultPrevented && e.unstable_virtual) {
        var D = (h == null ? void 0 : h.current) || P.relatedTarget, S = gr(e.items, D);
        Fe(P) && S && (P.stopPropagation(), v.current = D);
      }
    }, [e.unstable_virtual, e.items]), x = F(function(P) {
      var R;
      if ((R = g.current) === null || R === void 0 || R.call(g, P), !P.defaultPrevented) {
        if (e.unstable_virtual)
          Fe(P) && M();
        else if (Fe(P)) {
          var D;
          (D = e.setCurrentId) === null || D === void 0 || D.call(e, null);
        }
      }
    }, [e.unstable_virtual, e.setCurrentId]), T = F(function(P) {
      var R;
      if ((R = c.current) === null || R === void 0 || R.call(c, P), !P.defaultPrevented && e.unstable_virtual) {
        var D = (y == null ? void 0 : y.ref.current) || null, S = _o(P), N = gr(e.items, S);
        if (Fe(P) && N)
          S === D ? v.current && v.current !== S && br(v.current, P) : D && br(D, P), P.stopPropagation();
        else {
          var C = gr(e.items, P.target);
          !C && D && br(D, P);
        }
      }
    }, [e.unstable_virtual, e.items, y]), O = F(function(P) {
      var R, D;
      if ((R = b.current) === null || R === void 0 || R.call(b, P), !P.defaultPrevented && e.currentId === null && Fe(P)) {
        var S = e.orientation !== "horizontal", N = e.orientation !== "vertical", C = !!((D = e.groups) !== null && D !== void 0 && D.length), A = function() {
          if (C) {
            var ue = Ul(e.items);
            if (ue != null && ue.id) {
              var ee;
              (ee = e.move) === null || ee === void 0 || ee.call(e, ue.id);
            }
          } else {
            var te;
            (te = e.last) === null || te === void 0 || te.call(e);
          }
        }, V = {
          ArrowUp: (C || S) && A,
          ArrowRight: (C || N) && e.first,
          ArrowDown: (C || S) && e.first,
          ArrowLeft: (C || N) && e.last,
          Home: e.first,
          End: e.last,
          PageUp: e.first,
          PageDown: e.last
        }, Q = V[P.key];
        Q && (P.preventDefault(), Q());
      }
    }, [e.currentId, e.orientation, e.groups, e.items, e.move, e.last, e.first]);
    return E({
      ref: Be(m, a),
      id: e.baseId,
      onFocus: x,
      onFocusCapture: _,
      onBlurCapture: T,
      onKeyDownCapture: f,
      onKeyDown: O,
      onKeyUpCapture: w,
      "aria-activedescendant": e.unstable_virtual && (y == null ? void 0 : y.id) || void 0
    }, s);
  },
  useComposeProps: function(e, r) {
    r = qt(e, r, !0);
    var a = nr(e, r, !0);
    return e.unstable_virtual || e.currentId === null ? E({
      tabIndex: 0
    }, a) : E(E({}, r), {}, {
      ref: a.ref
    });
  }
});
ge({
  as: "div",
  useHook: Oo,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Yt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/composite"), Ct(e, r, a);
  }
});
function Mi(t) {
  try {
    var e = t instanceof HTMLInputElement && t.selectionStart !== null, r = t.tagName === "TEXTAREA", a = t.contentEditable === "true";
    return e || r || a || !1;
  } catch {
    return !1;
  }
}
function Bl(t) {
  var e = Rt(t);
  if (!e)
    return !1;
  if (e === t)
    return !0;
  var r = e.getAttribute("aria-activedescendant");
  return r ? r === t.id : !1;
}
function $t(t, e) {
  var r = e === void 0 ? {} : e, a = r.preventScroll, n = r.isActive, o = n === void 0 ? Bl : n;
  return o(t) || (t.focus({
    preventScroll: a
  }), o(t)) ? -1 : requestAnimationFrame(function() {
    t.focus({
      preventScroll: a
    });
  });
}
var Do = "id";
function ql(t) {
  return t === void 0 && (t = Do), (t ? t + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var Un = /* @__PURE__ */ it(ql);
function Kl(t) {
  var e = t.children, r = t.prefix, a = r === void 0 ? Do : r, n = re(0), o = F(function(l) {
    return l === void 0 && (l = a), (l ? l + "-" : "") + ++n.current;
  }, [a]);
  return /* @__PURE__ */ He(Un.Provider, {
    value: o
  }, e);
}
var Xl = ["baseId", "unstable_idCountRef", "setBaseId"], Vl = [].concat(Xl, ["id"]), So = ye({
  keys: Vl,
  useOptions: function(e, r) {
    var a = Ce(Un), n = de(function() {
      return e.unstable_idCountRef ? (e.unstable_idCountRef.current += 1, "-" + e.unstable_idCountRef.current) : e.baseId ? "-" + a("") : "";
    }), o = n[0], l = Le(function() {
      return e.baseId || a();
    }, [e.baseId, a]), u = r.id || e.id || "" + l + o;
    return E(E({}, e), {}, {
      id: u
    });
  },
  useProps: function(e, r) {
    return E({
      id: e.id
    }, r);
  }
});
ge({
  as: "div",
  useHook: So
});
function Ql(t, e, r) {
  return t.dispatchEvent(Mo(t, e, r));
}
function wi(t, e) {
  if (t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement) {
    var r, a = Object.getPrototypeOf(t), n = (r = Object.getOwnPropertyDescriptor(a, "value")) === null || r === void 0 ? void 0 : r.set;
    n && (n.call(t, e), Ql(t, "input", {
      bubbles: !0
    }));
  }
}
function yr(t) {
  return t.querySelector("[data-composite-item-widget]");
}
function Gl(t) {
  return Le(function() {
    var e;
    return (e = t.items) === null || e === void 0 ? void 0 : e.find(function(r) {
      return t.id && r.id === t.id;
    });
  }, [t.items, t.id]);
}
function Jl(t, e) {
  if (Fe(t))
    return !1;
  for (var r = vt(e), a; !(a = r()).done; ) {
    var n = a.value;
    if (n.ref.current === t.target)
      return !0;
  }
  return !1;
}
var jr = ye({
  name: "CompositeItem",
  compose: [Wt, So],
  keys: Fl,
  propsAreEqual: function(e, r) {
    if (!r.id || e.id !== r.id)
      return Wt.unstable_propsAreEqual(e, r);
    var a = e.currentId, n = e.unstable_moves, o = ae(e, ["currentId", "unstable_moves"]), l = r.currentId, u = r.unstable_moves, i = ae(r, ["currentId", "unstable_moves"]);
    if (l !== a) {
      if (r.id === l || r.id === a)
        return !1;
    } else if (n !== u)
      return !1;
    return Wt.unstable_propsAreEqual(o, i);
  },
  useOptions: function(e) {
    return E(E({}, e), {}, {
      id: e.id,
      currentId: lt(e),
      unstable_clickOnSpace: e.unstable_hasActiveWidget ? !1 : e.unstable_clickOnSpace
    });
  },
  useProps: function(e, r) {
    var a, n = r.ref, o = r.tabIndex, l = o === void 0 ? 0 : o, u = r.onMouseDown, i = r.onFocus, d = r.onBlurCapture, s = r.onKeyDown, m = r.onClick, y = ae(r, ["ref", "tabIndex", "onMouseDown", "onFocus", "onBlurCapture", "onKeyDown", "onClick"]), v = re(null), p = e.id, g = e.disabled && !e.focusable, c = e.currentId === p, b = ne(c), M = re(!1), h = Gl(e), f = ne(u), w = ne(i), _ = ne(d), x = ne(s), T = ne(m), O = !e.unstable_virtual && !e.unstable_hasActiveWidget && c || // We don't want to set tabIndex="-1" when using CompositeItem as a
    // standalone component, without state props.
    !((a = e.items) !== null && a !== void 0 && a.length);
    oe(function() {
      var C;
      if (p)
        return (C = e.registerItem) === null || C === void 0 || C.call(e, {
          id: p,
          ref: v,
          disabled: !!g
        }), function() {
          var A;
          (A = e.unregisterItem) === null || A === void 0 || A.call(e, p);
        };
    }, [p, g, e.registerItem, e.unregisterItem]), oe(function() {
      var C = v.current;
      if (!C) {
        process.env.NODE_ENV !== "production" && De(!0, "Can't focus composite item component because `ref` wasn't passed to component.", "See https://reakit.io/docs/composite");
        return;
      }
      e.unstable_moves && b.current && xo(C);
    }, [e.unstable_moves]);
    var P = F(function(C) {
      var A;
      (A = f.current) === null || A === void 0 || A.call(f, C), gi(C.currentTarget, !0);
    }, []), R = F(function(C) {
      var A, V, Q = Ll(C.currentTarget);
      if (gi(C.currentTarget, !1), (A = w.current) === null || A === void 0 || A.call(w, C), !C.defaultPrevented && !zn(C) && p && !Jl(C, e.items) && ((V = e.setCurrentId) === null || V === void 0 || V.call(e, p), Q && e.unstable_virtual && e.baseId && Fe(C))) {
        var G = C.target, ue = Me(G).getElementById(e.baseId);
        ue && (M.current = !0, $t(ue));
      }
    }, [p, e.items, e.setCurrentId, e.unstable_virtual, e.baseId]), D = F(function(C) {
      var A;
      (A = _.current) === null || A === void 0 || A.call(_, C), !C.defaultPrevented && e.unstable_virtual && M.current && (M.current = !1, C.preventDefault(), C.stopPropagation());
    }, [e.unstable_virtual]), S = F(function(C) {
      var A;
      if (Fe(C)) {
        var V = e.orientation !== "horizontal", Q = e.orientation !== "vertical", G = !!(h != null && h.groupId), ue = {
          ArrowUp: (G || V) && e.up,
          ArrowRight: (G || Q) && e.next,
          ArrowDown: (G || V) && e.down,
          ArrowLeft: (G || Q) && e.previous,
          Home: function() {
            if (!G || C.ctrlKey) {
              var U;
              (U = e.first) === null || U === void 0 || U.call(e);
            } else {
              var J;
              (J = e.previous) === null || J === void 0 || J.call(e, !0);
            }
          },
          End: function() {
            if (!G || C.ctrlKey) {
              var U;
              (U = e.last) === null || U === void 0 || U.call(e);
            } else {
              var J;
              (J = e.next) === null || J === void 0 || J.call(e, !0);
            }
          },
          PageUp: function() {
            if (G) {
              var U;
              (U = e.up) === null || U === void 0 || U.call(e, !0);
            } else {
              var J;
              (J = e.first) === null || J === void 0 || J.call(e);
            }
          },
          PageDown: function() {
            if (G) {
              var U;
              (U = e.down) === null || U === void 0 || U.call(e, !0);
            } else {
              var J;
              (J = e.last) === null || J === void 0 || J.call(e);
            }
          }
        }, ee = ue[C.key];
        if (ee) {
          C.preventDefault(), ee();
          return;
        }
        if ((A = x.current) === null || A === void 0 || A.call(x, C), !C.defaultPrevented) {
          if (C.key.length === 1 && C.key !== " ") {
            var te = yr(C.currentTarget);
            te && Mi(te) && (te.focus(), wi(te, ""));
          } else if (C.key === "Delete" || C.key === "Backspace") {
            var ve = yr(C.currentTarget);
            ve && Mi(ve) && (C.preventDefault(), wi(ve, ""));
          }
        }
      }
    }, [e.orientation, h, e.up, e.next, e.down, e.previous, e.first, e.last]), N = F(function(C) {
      var A;
      if ((A = T.current) === null || A === void 0 || A.call(T, C), !C.defaultPrevented) {
        var V = C.currentTarget, Q = yr(V);
        Q && !Bt(Q) && Q.focus();
      }
    }, []);
    return E({
      ref: Be(v, n),
      id: p,
      tabIndex: O ? l : -1,
      "aria-selected": e.unstable_virtual && c ? !0 : void 0,
      onMouseDown: P,
      onFocus: R,
      onBlurCapture: D,
      onKeyDown: S,
      onClick: N
    }, y);
  }
});
ge({
  as: "button",
  memo: !0,
  useHook: jr
});
function Zl(t) {
  return typeof t == "function";
}
function et(t, e) {
  return Zl(t) ? t(e) : t;
}
function To(t) {
  t === void 0 && (t = {});
  var e = mt(t), r = e.baseId, a = Ce(Un), n = re(0), o = de(function() {
    return r || a();
  }), l = o[0], u = o[1];
  return {
    baseId: l,
    setBaseId: u,
    unstable_idCountRef: n
  };
}
function Co(t, e) {
  return !!(e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_PRECEDING);
}
function _i(t, e) {
  return t.findIndex(function(r) {
    return !r.ref.current || !e.ref.current ? !1 : Co(e.ref.current, r.ref.current);
  });
}
function ko(t) {
  for (var e = 0, r = vt(t), a; !(a = r()).done; ) {
    var n = a.value.length;
    n > e && (e = n);
  }
  return e;
}
function Ei(t) {
  for (var e = ir(t), r = ko(e), a = [], n = 0; n < r; n += 1)
    for (var o = vt(e), l; !(l = o()).done; ) {
      var u = l.value;
      u[n] && a.push(E(E({}, u[n]), {}, {
        // If there's no groupId, it means that it's not a grid composite,
        // but a single row instead. So, instead of verticalizing it, that
        // is, assigning a different groupId based on the column index, we
        // keep it undefined so they will be part of the same group.
        // It's useful when using up/down on one-dimensional composites.
        groupId: u[n].groupId ? "" + n : void 0
      }));
    }
  return a;
}
function ed(t) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    ref: {
      current: null
    },
    groupId: t
  };
}
function Pi(t, e, r) {
  for (var a = ko(t), n = vt(t), o; !(o = n()).done; )
    for (var l = o.value, u = 0; u < a; u += 1) {
      var i = l[u];
      if (!i || r && i.disabled) {
        var d = u === 0, s = d && r ? Ge(l) : l[u - 1];
        l[u] = s && e !== (s == null ? void 0 : s.id) && r ? s : ed(s == null ? void 0 : s.groupId);
      }
    }
  return t;
}
var td = {
  id: null,
  ref: {
    current: null
  }
};
function rd(t, e, r) {
  var a = t.findIndex(function(n) {
    return n.id === e;
  });
  return [].concat(t.slice(a + 1), r ? [td] : [], t.slice(0, a));
}
function Mr(t, e) {
  return t.filter(function(r) {
    return r.groupId === e;
  });
}
var ad = {
  horizontal: "vertical",
  vertical: "horizontal"
};
function nd(t) {
  return t && ad[t];
}
function xi(t, e, r) {
  return r in t ? [].concat(t.slice(0, r), [e], t.slice(r)) : [].concat(t, [e]);
}
function Ar(t) {
  var e = t.map(function(a, n) {
    return [n, a];
  }), r = !1;
  return e.sort(function(a, n) {
    var o = a[0], l = a[1], u = n[0], i = n[1], d = l.ref.current, s = i.ref.current;
    return !d || !s ? 0 : Co(d, s) ? (o > u && (r = !0), -1) : (o < u && (r = !0), 1);
  }), r ? e.map(function(a) {
    a[0];
    var n = a[1];
    return n;
  }) : t;
}
function Ro(t, e) {
  var r = Ar(t);
  t !== r && e(r);
}
function id(t) {
  for (var e, r = t[0], a = t.slice(1), n = r == null || (e = r.ref.current) === null || e === void 0 ? void 0 : e.parentElement, o = function() {
    var i = n;
    if (a.every(function(d) {
      return i.contains(d.ref.current);
    }))
      return {
        v: n
      };
    n = n.parentElement;
  }; n; ) {
    var l = o();
    if (typeof l == "object")
      return l.v;
  }
  return Me(n).body;
}
function od(t, e) {
  var r = re([]);
  oe(function() {
    for (var a = function() {
      var s = !!r.current.length;
      s && Ro(t, e), r.current = t;
    }, n = id(t), o = new IntersectionObserver(a, {
      root: n
    }), l = vt(t), u; !(u = l()).done; ) {
      var i = u.value;
      i.ref.current && o.observe(i.ref.current);
    }
    return function() {
      o.disconnect();
    };
  }, [t]);
}
function ud(t, e) {
  oe(function() {
    var r = function() {
      return Ro(t, e);
    }, a = setTimeout(r, 250);
    return function() {
      return clearTimeout(a);
    };
  });
}
function ld(t, e) {
  typeof IntersectionObserver == "function" ? od(t, e) : ud(t, e);
}
function Se(t, e) {
  var r = t.unstable_virtual, a = t.rtl, n = t.orientation, o = t.items, l = t.groups, u = t.currentId, i = t.loop, d = t.wrap, s = t.pastIds, m = t.shift, y = t.unstable_moves, v = t.unstable_includesBaseElement, p = t.initialVirtual, g = t.initialRTL, c = t.initialOrientation, b = t.initialCurrentId, M = t.initialLoop, h = t.initialWrap, f = t.initialShift, w = t.hasSetCurrentId;
  switch (e.type) {
    case "registerGroup": {
      var _ = e.group;
      if (l.length === 0)
        return E(E({}, t), {}, {
          groups: [_]
        });
      var x = _i(l, _);
      return E(E({}, t), {}, {
        groups: xi(l, _, x)
      });
    }
    case "unregisterGroup": {
      var T = e.id, O = l.filter(function(Re) {
        return Re.id !== T;
      });
      return O.length === l.length ? t : E(E({}, t), {}, {
        groups: O
      });
    }
    case "registerItem": {
      var P = e.item, R = l.find(function(Re) {
        var mr;
        return (mr = Re.ref.current) === null || mr === void 0 ? void 0 : mr.contains(P.ref.current);
      }), D = E({
        groupId: R == null ? void 0 : R.id
      }, P), S = _i(o, D), N = E(E({}, t), {}, {
        items: xi(o, D, S)
      });
      if (!w && !y && b === void 0) {
        var C;
        return E(E({}, N), {}, {
          currentId: (C = Ge(N.items)) === null || C === void 0 ? void 0 : C.id
        });
      }
      return N;
    }
    case "unregisterItem": {
      var A = e.id, V = o.filter(function(Re) {
        return Re.id !== A;
      });
      if (V.length === o.length)
        return t;
      var Q = s.filter(function(Re) {
        return Re !== A;
      }), G = E(E({}, t), {}, {
        pastIds: Q,
        items: V
      });
      if (u && u === A) {
        var ue = v ? null : lt(E(E({}, G), {}, {
          currentId: Q[0]
        }));
        return E(E({}, G), {}, {
          currentId: ue
        });
      }
      return G;
    }
    case "move": {
      var ee = e.id;
      if (ee === void 0)
        return t;
      var te = s.filter(function(Re) {
        return Re !== u && Re !== ee;
      }), ve = u ? [u].concat(te) : te, L = E(E({}, t), {}, {
        pastIds: ve
      });
      if (ee === null)
        return E(E({}, L), {}, {
          unstable_moves: y + 1,
          currentId: lt(L, ee)
        });
      var U = Eo(o, ee);
      return E(E({}, L), {}, {
        unstable_moves: U ? y + 1 : y,
        currentId: lt(L, U == null ? void 0 : U.id)
      });
    }
    case "next": {
      if (u == null)
        return Se(t, E(E({}, e), {}, {
          type: "first"
        }));
      var J = n !== "vertical", se = a && J, fe = se ? wt(o) : o, be = fe.find(function(Re) {
        return Re.id === u;
      });
      if (!be)
        return Se(t, E(E({}, e), {}, {
          type: "first"
        }));
      var k = !!be.groupId, W = fe.indexOf(be), K = fe.slice(W + 1), Y = Mr(K, be.groupId);
      if (e.allTheWay) {
        var z = Ge(se ? Mr(fe, be.groupId) : wt(Y));
        return Se(t, E(E({}, e), {}, {
          type: "move",
          id: z == null ? void 0 : z.id
        }));
      }
      var Z = nd(
        // If it's a grid and orientation is not set, it's a next/previous
        // call, which is inherently horizontal. up/down will call next with
        // orientation set to vertical by default (see below on up/down cases).
        k ? n || "horizontal" : n
      ), H = i && i !== Z, $ = k && d && d !== Z, B = (
        // `previous` and `up` will set action.hasNullItem, but when calling
        // next directly, hasNullItem will only be true if it's not a grid and
        // loop is set to true, which means that pressing right or down keys on
        // grids will never focus the composite element. On one-dimensional
        // composites that don't loop, pressing right or down keys also doesn't
        // focus the composite element.
        e.hasNullItem || !k && H && v
      );
      if (H) {
        var ie = $ && !B ? fe : Mr(fe, be.groupId), X = rd(ie, u, B), j = Ge(X, u);
        return Se(t, E(E({}, e), {}, {
          type: "move",
          id: j == null ? void 0 : j.id
        }));
      }
      if ($) {
        var le = Ge(
          // We can use nextItems, which contains all the next items, including
          // items from other groups, to wrap between groups. However, if there
          // is a null item (the composite element), we'll only use the next
          // items in the group. So moving next from the last item will focus
          // the composite element (null). On grid composites, horizontal
          // navigation never focuses the composite element, only vertical.
          B ? Y : K,
          u
        ), we = B ? (le == null ? void 0 : le.id) || null : le == null ? void 0 : le.id;
        return Se(t, E(E({}, e), {}, {
          type: "move",
          id: we
        }));
      }
      var Ne = Ge(Y, u);
      return !Ne && B ? Se(t, E(E({}, e), {}, {
        type: "move",
        id: null
      })) : Se(t, E(E({}, e), {}, {
        type: "move",
        id: Ne == null ? void 0 : Ne.id
      }));
    }
    case "previous": {
      var Qt = !!l.length, Gt = !Qt && v, Jt = Se(E(E({}, t), {}, {
        items: wt(o)
      }), E(E({}, e), {}, {
        type: "next",
        hasNullItem: Gt
      }));
      return E(E({}, Jt), {}, {
        items: o
      });
    }
    case "down": {
      var Zt = m && !e.allTheWay, ku = Ei(Rr(Pi(ir(o), u, Zt))), Ru = i && i !== "horizontal", ju = Ru && v, Au = Se(E(E({}, t), {}, {
        orientation: "vertical",
        items: ku
      }), E(E({}, e), {}, {
        type: "next",
        hasNullItem: ju
      }));
      return E(E({}, Au), {}, {
        orientation: n,
        items: o
      });
    }
    case "up": {
      var Wu = m && !e.allTheWay, Iu = Ei(wt(Rr(Pi(ir(o), u, Wu)))), Nu = v, Fu = Se(E(E({}, t), {}, {
        orientation: "vertical",
        items: Iu
      }), E(E({}, e), {}, {
        type: "next",
        hasNullItem: Nu
      }));
      return E(E({}, Fu), {}, {
        orientation: n,
        items: o
      });
    }
    case "first": {
      var vr = Ge(o);
      return Se(t, E(E({}, e), {}, {
        type: "move",
        id: vr == null ? void 0 : vr.id
      }));
    }
    case "last": {
      var Lu = Se(E(E({}, t), {}, {
        items: wt(o)
      }), E(E({}, e), {}, {
        type: "first"
      }));
      return E(E({}, Lu), {}, {
        items: o
      });
    }
    case "sort":
      return E(E({}, t), {}, {
        items: Ar(o),
        groups: Ar(l)
      });
    case "setVirtual":
      return E(E({}, t), {}, {
        unstable_virtual: et(e.virtual, r)
      });
    case "setRTL":
      return E(E({}, t), {}, {
        rtl: et(e.rtl, a)
      });
    case "setOrientation":
      return E(E({}, t), {}, {
        orientation: et(e.orientation, n)
      });
    case "setCurrentId": {
      var Hu = lt(E(E({}, t), {}, {
        currentId: et(e.currentId, u)
      }));
      return E(E({}, t), {}, {
        currentId: Hu,
        hasSetCurrentId: !0
      });
    }
    case "setLoop":
      return E(E({}, t), {}, {
        loop: et(e.loop, i)
      });
    case "setWrap":
      return E(E({}, t), {}, {
        wrap: et(e.wrap, d)
      });
    case "setShift":
      return E(E({}, t), {}, {
        shift: et(e.shift, m)
      });
    case "setIncludesBaseElement":
      return E(E({}, t), {}, {
        unstable_includesBaseElement: et(e.includesBaseElement, v)
      });
    case "reset":
      return E(E({}, t), {}, {
        unstable_virtual: p,
        rtl: g,
        orientation: c,
        currentId: lt(E(E({}, t), {}, {
          currentId: b
        })),
        loop: M,
        wrap: h,
        shift: f,
        unstable_moves: 0,
        pastIds: []
      });
    case "setItems":
      return E(E({}, t), {}, {
        items: e.items
      });
    default:
      throw new Error();
  }
}
function he(t) {
  return F(t, []);
}
function dd() {
  var t = re(!1);
  return ot(function() {
    return function() {
      t.current = !0;
    };
  }, []), t;
}
function sd(t) {
  t === void 0 && (t = {});
  var e = mt(t), r = e.unstable_virtual, a = r === void 0 ? !1 : r, n = e.rtl, o = n === void 0 ? !1 : n, l = e.orientation, u = e.currentId, i = e.loop, d = i === void 0 ? !1 : i, s = e.wrap, m = s === void 0 ? !1 : s, y = e.shift, v = y === void 0 ? !1 : y, p = e.unstable_includesBaseElement, g = ae(e, ["unstable_virtual", "rtl", "orientation", "currentId", "loop", "wrap", "shift", "unstable_includesBaseElement"]), c = To(g), b = Ln(Se, {
    unstable_virtual: a,
    rtl: o,
    orientation: l,
    items: [],
    groups: [],
    currentId: u,
    loop: d,
    wrap: m,
    shift: v,
    unstable_moves: 0,
    pastIds: [],
    unstable_includesBaseElement: p ?? u === null,
    initialVirtual: a,
    initialRTL: o,
    initialOrientation: l,
    initialCurrentId: u,
    initialLoop: d,
    initialWrap: m,
    initialShift: v
  }), M = b[0];
  M.pastIds, M.initialVirtual, M.initialRTL, M.initialOrientation, M.initialCurrentId, M.initialLoop, M.initialWrap, M.initialShift, M.hasSetCurrentId;
  var h = ae(M, ["pastIds", "initialVirtual", "initialRTL", "initialOrientation", "initialCurrentId", "initialLoop", "initialWrap", "initialShift", "hasSetCurrentId"]), f = b[1], w = de(!1), _ = w[0], x = w[1], T = dd(), O = F(function(P) {
    return f({
      type: "setItems",
      items: P
    });
  }, []);
  return ld(h.items, O), E(E(E({}, c), h), {}, {
    unstable_hasActiveWidget: _,
    unstable_setHasActiveWidget: x,
    registerItem: he(function(P) {
      T.current || f({
        type: "registerItem",
        item: P
      });
    }),
    unregisterItem: he(function(P) {
      T.current || f({
        type: "unregisterItem",
        id: P
      });
    }),
    registerGroup: he(function(P) {
      T.current || f({
        type: "registerGroup",
        group: P
      });
    }),
    unregisterGroup: he(function(P) {
      T.current || f({
        type: "unregisterGroup",
        id: P
      });
    }),
    move: he(function(P) {
      return f({
        type: "move",
        id: P
      });
    }),
    next: he(function(P) {
      return f({
        type: "next",
        allTheWay: P
      });
    }),
    previous: he(function(P) {
      return f({
        type: "previous",
        allTheWay: P
      });
    }),
    up: he(function(P) {
      return f({
        type: "up",
        allTheWay: P
      });
    }),
    down: he(function(P) {
      return f({
        type: "down",
        allTheWay: P
      });
    }),
    first: he(function() {
      return f({
        type: "first"
      });
    }),
    last: he(function() {
      return f({
        type: "last"
      });
    }),
    sort: he(function() {
      return f({
        type: "sort"
      });
    }),
    unstable_setVirtual: he(function(P) {
      return f({
        type: "setVirtual",
        virtual: P
      });
    }),
    setRTL: he(function(P) {
      return f({
        type: "setRTL",
        rtl: P
      });
    }),
    setOrientation: he(function(P) {
      return f({
        type: "setOrientation",
        orientation: P
      });
    }),
    setCurrentId: he(function(P) {
      return f({
        type: "setCurrentId",
        currentId: P
      });
    }),
    setLoop: he(function(P) {
      return f({
        type: "setLoop",
        loop: P
      });
    }),
    setWrap: he(function(P) {
      return f({
        type: "setWrap",
        wrap: P
      });
    }),
    setShift: he(function(P) {
      return f({
        type: "setShift",
        shift: P
      });
    }),
    unstable_setIncludesBaseElement: he(function(P) {
      return f({
        type: "setIncludesBaseElement",
        includesBaseElement: P
      });
    }),
    reset: he(function() {
      return f({
        type: "reset"
      });
    })
  });
}
var xe = "top", We = "bottom", Ie = "right", Oe = "left", Yn = "auto", Kt = [xe, We, Ie, Oe], Pt = "start", zt = "end", fd = "clippingParents", jo = "viewport", At = "popper", cd = "reference", Oi = /* @__PURE__ */ Kt.reduce(function(t, e) {
  return t.concat([e + "-" + Pt, e + "-" + zt]);
}, []), Ao = /* @__PURE__ */ [].concat(Kt, [Yn]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Pt, e + "-" + zt]);
}, []), vd = "beforeRead", md = "read", hd = "afterRead", pd = "beforeMain", bd = "main", gd = "afterMain", yd = "beforeWrite", Md = "write", wd = "afterWrite", _d = [vd, md, hd, pd, bd, gd, yd, Md, wd];
function Ye(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function ke(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function ct(t) {
  var e = ke(t).Element;
  return t instanceof e || t instanceof Element;
}
function Ae(t) {
  var e = ke(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function Bn(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = ke(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function Ed(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var a = e.styles[r] || {}, n = e.attributes[r] || {}, o = e.elements[r];
    !Ae(o) || !Ye(o) || (Object.assign(o.style, a), Object.keys(n).forEach(function(l) {
      var u = n[l];
      u === !1 ? o.removeAttribute(l) : o.setAttribute(l, u === !0 ? "" : u);
    }));
  });
}
function Pd(t) {
  var e = t.state, r = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(a) {
      var n = e.elements[a], o = e.attributes[a] || {}, l = Object.keys(e.styles.hasOwnProperty(a) ? e.styles[a] : r[a]), u = l.reduce(function(i, d) {
        return i[d] = "", i;
      }, {});
      !Ae(n) || !Ye(n) || (Object.assign(n.style, u), Object.keys(o).forEach(function(i) {
        n.removeAttribute(i);
      }));
    });
  };
}
const xd = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Ed,
  effect: Pd,
  requires: ["computeStyles"]
};
function Ue(t) {
  return t.split("-")[0];
}
var st = Math.max, or = Math.min, xt = Math.round;
function Wr() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function Wo() {
  return !/^((?!chrome|android).)*safari/i.test(Wr());
}
function Ot(t, e, r) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  var a = t.getBoundingClientRect(), n = 1, o = 1;
  e && Ae(t) && (n = t.offsetWidth > 0 && xt(a.width) / t.offsetWidth || 1, o = t.offsetHeight > 0 && xt(a.height) / t.offsetHeight || 1);
  var l = ct(t) ? ke(t) : window, u = l.visualViewport, i = !Wo() && r, d = (a.left + (i && u ? u.offsetLeft : 0)) / n, s = (a.top + (i && u ? u.offsetTop : 0)) / o, m = a.width / n, y = a.height / o;
  return {
    width: m,
    height: y,
    top: s,
    right: d + m,
    bottom: s + y,
    left: d,
    x: d,
    y: s
  };
}
function qn(t) {
  var e = Ot(t), r = t.offsetWidth, a = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - a) <= 1 && (a = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: r,
    height: a
  };
}
function Io(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && Bn(r)) {
    var a = e;
    do {
      if (a && t.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function Je(t) {
  return ke(t).getComputedStyle(t);
}
function Od(t) {
  return ["table", "td", "th"].indexOf(Ye(t)) >= 0;
}
function ut(t) {
  return ((ct(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function fr(t) {
  return Ye(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (Bn(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ut(t)
  );
}
function Di(t) {
  return !Ae(t) || // https://github.com/popperjs/popper-core/issues/837
  Je(t).position === "fixed" ? null : t.offsetParent;
}
function Dd(t) {
  var e = /firefox/i.test(Wr()), r = /Trident/i.test(Wr());
  if (r && Ae(t)) {
    var a = Je(t);
    if (a.position === "fixed")
      return null;
  }
  var n = fr(t);
  for (Bn(n) && (n = n.host); Ae(n) && ["html", "body"].indexOf(Ye(n)) < 0; ) {
    var o = Je(n);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || e && o.willChange === "filter" || e && o.filter && o.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function Xt(t) {
  for (var e = ke(t), r = Di(t); r && Od(r) && Je(r).position === "static"; )
    r = Di(r);
  return r && (Ye(r) === "html" || Ye(r) === "body" && Je(r).position === "static") ? e : r || Dd(t) || e;
}
function Kn(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function It(t, e, r) {
  return st(t, or(e, r));
}
function Sd(t, e, r) {
  var a = It(t, e, r);
  return a > r ? r : a;
}
function No() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Fo(t) {
  return Object.assign({}, No(), t);
}
function Lo(t, e) {
  return e.reduce(function(r, a) {
    return r[a] = t, r;
  }, {});
}
var Td = function(e, r) {
  return e = typeof e == "function" ? e(Object.assign({}, r.rects, {
    placement: r.placement
  })) : e, Fo(typeof e != "number" ? e : Lo(e, Kt));
};
function Cd(t) {
  var e, r = t.state, a = t.name, n = t.options, o = r.elements.arrow, l = r.modifiersData.popperOffsets, u = Ue(r.placement), i = Kn(u), d = [Oe, Ie].indexOf(u) >= 0, s = d ? "height" : "width";
  if (!(!o || !l)) {
    var m = Td(n.padding, r), y = qn(o), v = i === "y" ? xe : Oe, p = i === "y" ? We : Ie, g = r.rects.reference[s] + r.rects.reference[i] - l[i] - r.rects.popper[s], c = l[i] - r.rects.reference[i], b = Xt(o), M = b ? i === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, h = g / 2 - c / 2, f = m[v], w = M - y[s] - m[p], _ = M / 2 - y[s] / 2 + h, x = It(f, _, w), T = i;
    r.modifiersData[a] = (e = {}, e[T] = x, e.centerOffset = x - _, e);
  }
}
function kd(t) {
  var e = t.state, r = t.options, a = r.element, n = a === void 0 ? "[data-popper-arrow]" : a;
  n != null && (typeof n == "string" && (n = e.elements.popper.querySelector(n), !n) || Io(e.elements.popper, n) && (e.elements.arrow = n));
}
const Rd = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Cd,
  effect: kd,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Dt(t) {
  return t.split("-")[1];
}
var jd = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ad(t, e) {
  var r = t.x, a = t.y, n = e.devicePixelRatio || 1;
  return {
    x: xt(r * n) / n || 0,
    y: xt(a * n) / n || 0
  };
}
function Si(t) {
  var e, r = t.popper, a = t.popperRect, n = t.placement, o = t.variation, l = t.offsets, u = t.position, i = t.gpuAcceleration, d = t.adaptive, s = t.roundOffsets, m = t.isFixed, y = l.x, v = y === void 0 ? 0 : y, p = l.y, g = p === void 0 ? 0 : p, c = typeof s == "function" ? s({
    x: v,
    y: g
  }) : {
    x: v,
    y: g
  };
  v = c.x, g = c.y;
  var b = l.hasOwnProperty("x"), M = l.hasOwnProperty("y"), h = Oe, f = xe, w = window;
  if (d) {
    var _ = Xt(r), x = "clientHeight", T = "clientWidth";
    if (_ === ke(r) && (_ = ut(r), Je(_).position !== "static" && u === "absolute" && (x = "scrollHeight", T = "scrollWidth")), _ = _, n === xe || (n === Oe || n === Ie) && o === zt) {
      f = We;
      var O = m && _ === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        _[x]
      );
      g -= O - a.height, g *= i ? 1 : -1;
    }
    if (n === Oe || (n === xe || n === We) && o === zt) {
      h = Ie;
      var P = m && _ === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        _[T]
      );
      v -= P - a.width, v *= i ? 1 : -1;
    }
  }
  var R = Object.assign({
    position: u
  }, d && jd), D = s === !0 ? Ad({
    x: v,
    y: g
  }, ke(r)) : {
    x: v,
    y: g
  };
  if (v = D.x, g = D.y, i) {
    var S;
    return Object.assign({}, R, (S = {}, S[f] = M ? "0" : "", S[h] = b ? "0" : "", S.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + g + "px)" : "translate3d(" + v + "px, " + g + "px, 0)", S));
  }
  return Object.assign({}, R, (e = {}, e[f] = M ? g + "px" : "", e[h] = b ? v + "px" : "", e.transform = "", e));
}
function Wd(t) {
  var e = t.state, r = t.options, a = r.gpuAcceleration, n = a === void 0 ? !0 : a, o = r.adaptive, l = o === void 0 ? !0 : o, u = r.roundOffsets, i = u === void 0 ? !0 : u, d = {
    placement: Ue(e.placement),
    variation: Dt(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: n,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Si(Object.assign({}, d, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: l,
    roundOffsets: i
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Si(Object.assign({}, d, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: i
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const Id = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Wd,
  data: {}
};
var er = {
  passive: !0
};
function Nd(t) {
  var e = t.state, r = t.instance, a = t.options, n = a.scroll, o = n === void 0 ? !0 : n, l = a.resize, u = l === void 0 ? !0 : l, i = ke(e.elements.popper), d = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return o && d.forEach(function(s) {
    s.addEventListener("scroll", r.update, er);
  }), u && i.addEventListener("resize", r.update, er), function() {
    o && d.forEach(function(s) {
      s.removeEventListener("scroll", r.update, er);
    }), u && i.removeEventListener("resize", r.update, er);
  };
}
const Fd = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Nd,
  data: {}
};
var Ld = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ar(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return Ld[e];
  });
}
var Hd = {
  start: "end",
  end: "start"
};
function Ti(t) {
  return t.replace(/start|end/g, function(e) {
    return Hd[e];
  });
}
function Xn(t) {
  var e = ke(t), r = e.pageXOffset, a = e.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: a
  };
}
function Vn(t) {
  return Ot(ut(t)).left + Xn(t).scrollLeft;
}
function $d(t, e) {
  var r = ke(t), a = ut(t), n = r.visualViewport, o = a.clientWidth, l = a.clientHeight, u = 0, i = 0;
  if (n) {
    o = n.width, l = n.height;
    var d = Wo();
    (d || !d && e === "fixed") && (u = n.offsetLeft, i = n.offsetTop);
  }
  return {
    width: o,
    height: l,
    x: u + Vn(t),
    y: i
  };
}
function zd(t) {
  var e, r = ut(t), a = Xn(t), n = (e = t.ownerDocument) == null ? void 0 : e.body, o = st(r.scrollWidth, r.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), l = st(r.scrollHeight, r.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), u = -a.scrollLeft + Vn(t), i = -a.scrollTop;
  return Je(n || r).direction === "rtl" && (u += st(r.clientWidth, n ? n.clientWidth : 0) - o), {
    width: o,
    height: l,
    x: u,
    y: i
  };
}
function Qn(t) {
  var e = Je(t), r = e.overflow, a = e.overflowX, n = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + n + a);
}
function Ho(t) {
  return ["html", "body", "#document"].indexOf(Ye(t)) >= 0 ? t.ownerDocument.body : Ae(t) && Qn(t) ? t : Ho(fr(t));
}
function Nt(t, e) {
  var r;
  e === void 0 && (e = []);
  var a = Ho(t), n = a === ((r = t.ownerDocument) == null ? void 0 : r.body), o = ke(a), l = n ? [o].concat(o.visualViewport || [], Qn(a) ? a : []) : a, u = e.concat(l);
  return n ? u : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    u.concat(Nt(fr(l)))
  );
}
function Ir(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function Ud(t, e) {
  var r = Ot(t, !1, e === "fixed");
  return r.top = r.top + t.clientTop, r.left = r.left + t.clientLeft, r.bottom = r.top + t.clientHeight, r.right = r.left + t.clientWidth, r.width = t.clientWidth, r.height = t.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Ci(t, e, r) {
  return e === jo ? Ir($d(t, r)) : ct(e) ? Ud(e, r) : Ir(zd(ut(t)));
}
function Yd(t) {
  var e = Nt(fr(t)), r = ["absolute", "fixed"].indexOf(Je(t).position) >= 0, a = r && Ae(t) ? Xt(t) : t;
  return ct(a) ? e.filter(function(n) {
    return ct(n) && Io(n, a) && Ye(n) !== "body";
  }) : [];
}
function Bd(t, e, r, a) {
  var n = e === "clippingParents" ? Yd(t) : [].concat(e), o = [].concat(n, [r]), l = o[0], u = o.reduce(function(i, d) {
    var s = Ci(t, d, a);
    return i.top = st(s.top, i.top), i.right = or(s.right, i.right), i.bottom = or(s.bottom, i.bottom), i.left = st(s.left, i.left), i;
  }, Ci(t, l, a));
  return u.width = u.right - u.left, u.height = u.bottom - u.top, u.x = u.left, u.y = u.top, u;
}
function $o(t) {
  var e = t.reference, r = t.element, a = t.placement, n = a ? Ue(a) : null, o = a ? Dt(a) : null, l = e.x + e.width / 2 - r.width / 2, u = e.y + e.height / 2 - r.height / 2, i;
  switch (n) {
    case xe:
      i = {
        x: l,
        y: e.y - r.height
      };
      break;
    case We:
      i = {
        x: l,
        y: e.y + e.height
      };
      break;
    case Ie:
      i = {
        x: e.x + e.width,
        y: u
      };
      break;
    case Oe:
      i = {
        x: e.x - r.width,
        y: u
      };
      break;
    default:
      i = {
        x: e.x,
        y: e.y
      };
  }
  var d = n ? Kn(n) : null;
  if (d != null) {
    var s = d === "y" ? "height" : "width";
    switch (o) {
      case Pt:
        i[d] = i[d] - (e[s] / 2 - r[s] / 2);
        break;
      case zt:
        i[d] = i[d] + (e[s] / 2 - r[s] / 2);
        break;
    }
  }
  return i;
}
function Ut(t, e) {
  e === void 0 && (e = {});
  var r = e, a = r.placement, n = a === void 0 ? t.placement : a, o = r.strategy, l = o === void 0 ? t.strategy : o, u = r.boundary, i = u === void 0 ? fd : u, d = r.rootBoundary, s = d === void 0 ? jo : d, m = r.elementContext, y = m === void 0 ? At : m, v = r.altBoundary, p = v === void 0 ? !1 : v, g = r.padding, c = g === void 0 ? 0 : g, b = Fo(typeof c != "number" ? c : Lo(c, Kt)), M = y === At ? cd : At, h = t.rects.popper, f = t.elements[p ? M : y], w = Bd(ct(f) ? f : f.contextElement || ut(t.elements.popper), i, s, l), _ = Ot(t.elements.reference), x = $o({
    reference: _,
    element: h,
    strategy: "absolute",
    placement: n
  }), T = Ir(Object.assign({}, h, x)), O = y === At ? T : _, P = {
    top: w.top - O.top + b.top,
    bottom: O.bottom - w.bottom + b.bottom,
    left: w.left - O.left + b.left,
    right: O.right - w.right + b.right
  }, R = t.modifiersData.offset;
  if (y === At && R) {
    var D = R[n];
    Object.keys(P).forEach(function(S) {
      var N = [Ie, We].indexOf(S) >= 0 ? 1 : -1, C = [xe, We].indexOf(S) >= 0 ? "y" : "x";
      P[S] += D[C] * N;
    });
  }
  return P;
}
function qd(t, e) {
  e === void 0 && (e = {});
  var r = e, a = r.placement, n = r.boundary, o = r.rootBoundary, l = r.padding, u = r.flipVariations, i = r.allowedAutoPlacements, d = i === void 0 ? Ao : i, s = Dt(a), m = s ? u ? Oi : Oi.filter(function(p) {
    return Dt(p) === s;
  }) : Kt, y = m.filter(function(p) {
    return d.indexOf(p) >= 0;
  });
  y.length === 0 && (y = m);
  var v = y.reduce(function(p, g) {
    return p[g] = Ut(t, {
      placement: g,
      boundary: n,
      rootBoundary: o,
      padding: l
    })[Ue(g)], p;
  }, {});
  return Object.keys(v).sort(function(p, g) {
    return v[p] - v[g];
  });
}
function Kd(t) {
  if (Ue(t) === Yn)
    return [];
  var e = ar(t);
  return [Ti(t), e, Ti(e)];
}
function Xd(t) {
  var e = t.state, r = t.options, a = t.name;
  if (!e.modifiersData[a]._skip) {
    for (var n = r.mainAxis, o = n === void 0 ? !0 : n, l = r.altAxis, u = l === void 0 ? !0 : l, i = r.fallbackPlacements, d = r.padding, s = r.boundary, m = r.rootBoundary, y = r.altBoundary, v = r.flipVariations, p = v === void 0 ? !0 : v, g = r.allowedAutoPlacements, c = e.options.placement, b = Ue(c), M = b === c, h = i || (M || !p ? [ar(c)] : Kd(c)), f = [c].concat(h).reduce(function(L, U) {
      return L.concat(Ue(U) === Yn ? qd(e, {
        placement: U,
        boundary: s,
        rootBoundary: m,
        padding: d,
        flipVariations: p,
        allowedAutoPlacements: g
      }) : U);
    }, []), w = e.rects.reference, _ = e.rects.popper, x = /* @__PURE__ */ new Map(), T = !0, O = f[0], P = 0; P < f.length; P++) {
      var R = f[P], D = Ue(R), S = Dt(R) === Pt, N = [xe, We].indexOf(D) >= 0, C = N ? "width" : "height", A = Ut(e, {
        placement: R,
        boundary: s,
        rootBoundary: m,
        altBoundary: y,
        padding: d
      }), V = N ? S ? Ie : Oe : S ? We : xe;
      w[C] > _[C] && (V = ar(V));
      var Q = ar(V), G = [];
      if (o && G.push(A[D] <= 0), u && G.push(A[V] <= 0, A[Q] <= 0), G.every(function(L) {
        return L;
      })) {
        O = R, T = !1;
        break;
      }
      x.set(R, G);
    }
    if (T)
      for (var ue = p ? 3 : 1, ee = function(U) {
        var J = f.find(function(se) {
          var fe = x.get(se);
          if (fe)
            return fe.slice(0, U).every(function(be) {
              return be;
            });
        });
        if (J)
          return O = J, "break";
      }, te = ue; te > 0; te--) {
        var ve = ee(te);
        if (ve === "break")
          break;
      }
    e.placement !== O && (e.modifiersData[a]._skip = !0, e.placement = O, e.reset = !0);
  }
}
const Vd = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Xd,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ki(t, e, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - r.y,
    right: t.right - e.width + r.x,
    bottom: t.bottom - e.height + r.y,
    left: t.left - e.width - r.x
  };
}
function Ri(t) {
  return [xe, Ie, We, Oe].some(function(e) {
    return t[e] >= 0;
  });
}
function Qd(t) {
  var e = t.state, r = t.name, a = e.rects.reference, n = e.rects.popper, o = e.modifiersData.preventOverflow, l = Ut(e, {
    elementContext: "reference"
  }), u = Ut(e, {
    altBoundary: !0
  }), i = ki(l, a), d = ki(u, n, o), s = Ri(i), m = Ri(d);
  e.modifiersData[r] = {
    referenceClippingOffsets: i,
    popperEscapeOffsets: d,
    isReferenceHidden: s,
    hasPopperEscaped: m
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": s,
    "data-popper-escaped": m
  });
}
const Gd = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Qd
};
function Jd(t, e, r) {
  var a = Ue(t), n = [Oe, xe].indexOf(a) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, e, {
    placement: t
  })) : r, l = o[0], u = o[1];
  return l = l || 0, u = (u || 0) * n, [Oe, Ie].indexOf(a) >= 0 ? {
    x: u,
    y: l
  } : {
    x: l,
    y: u
  };
}
function Zd(t) {
  var e = t.state, r = t.options, a = t.name, n = r.offset, o = n === void 0 ? [0, 0] : n, l = Ao.reduce(function(s, m) {
    return s[m] = Jd(m, e.rects, o), s;
  }, {}), u = l[e.placement], i = u.x, d = u.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += i, e.modifiersData.popperOffsets.y += d), e.modifiersData[a] = l;
}
const es = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Zd
};
function ts(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = $o({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const rs = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: ts,
  data: {}
};
function as(t) {
  return t === "x" ? "y" : "x";
}
function ns(t) {
  var e = t.state, r = t.options, a = t.name, n = r.mainAxis, o = n === void 0 ? !0 : n, l = r.altAxis, u = l === void 0 ? !1 : l, i = r.boundary, d = r.rootBoundary, s = r.altBoundary, m = r.padding, y = r.tether, v = y === void 0 ? !0 : y, p = r.tetherOffset, g = p === void 0 ? 0 : p, c = Ut(e, {
    boundary: i,
    rootBoundary: d,
    padding: m,
    altBoundary: s
  }), b = Ue(e.placement), M = Dt(e.placement), h = !M, f = Kn(b), w = as(f), _ = e.modifiersData.popperOffsets, x = e.rects.reference, T = e.rects.popper, O = typeof g == "function" ? g(Object.assign({}, e.rects, {
    placement: e.placement
  })) : g, P = typeof O == "number" ? {
    mainAxis: O,
    altAxis: O
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, O), R = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (_) {
    if (o) {
      var S, N = f === "y" ? xe : Oe, C = f === "y" ? We : Ie, A = f === "y" ? "height" : "width", V = _[f], Q = V + c[N], G = V - c[C], ue = v ? -T[A] / 2 : 0, ee = M === Pt ? x[A] : T[A], te = M === Pt ? -T[A] : -x[A], ve = e.elements.arrow, L = v && ve ? qn(ve) : {
        width: 0,
        height: 0
      }, U = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : No(), J = U[N], se = U[C], fe = It(0, x[A], L[A]), be = h ? x[A] / 2 - ue - fe - J - P.mainAxis : ee - fe - J - P.mainAxis, k = h ? -x[A] / 2 + ue + fe + se + P.mainAxis : te + fe + se + P.mainAxis, W = e.elements.arrow && Xt(e.elements.arrow), K = W ? f === "y" ? W.clientTop || 0 : W.clientLeft || 0 : 0, Y = (S = R == null ? void 0 : R[f]) != null ? S : 0, z = V + be - Y - K, Z = V + k - Y, H = It(v ? or(Q, z) : Q, V, v ? st(G, Z) : G);
      _[f] = H, D[f] = H - V;
    }
    if (u) {
      var $, B = f === "x" ? xe : Oe, ie = f === "x" ? We : Ie, X = _[w], j = w === "y" ? "height" : "width", le = X + c[B], we = X - c[ie], Ne = [xe, Oe].indexOf(b) !== -1, Qt = ($ = R == null ? void 0 : R[w]) != null ? $ : 0, Gt = Ne ? le : X - x[j] - T[j] - Qt + P.altAxis, Jt = Ne ? X + x[j] + T[j] - Qt - P.altAxis : we, Zt = v && Ne ? Sd(Gt, X, Jt) : It(v ? Gt : le, X, v ? Jt : we);
      _[w] = Zt, D[w] = Zt - X;
    }
    e.modifiersData[a] = D;
  }
}
const is = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: ns,
  requiresIfExists: ["offset"]
};
function os(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function us(t) {
  return t === ke(t) || !Ae(t) ? Xn(t) : os(t);
}
function ls(t) {
  var e = t.getBoundingClientRect(), r = xt(e.width) / t.offsetWidth || 1, a = xt(e.height) / t.offsetHeight || 1;
  return r !== 1 || a !== 1;
}
function ds(t, e, r) {
  r === void 0 && (r = !1);
  var a = Ae(e), n = Ae(e) && ls(e), o = ut(e), l = Ot(t, n, r), u = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = {
    x: 0,
    y: 0
  };
  return (a || !a && !r) && ((Ye(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Qn(o)) && (u = us(e)), Ae(e) ? (i = Ot(e, !0), i.x += e.clientLeft, i.y += e.clientTop) : o && (i.x = Vn(o))), {
    x: l.left + u.scrollLeft - i.x,
    y: l.top + u.scrollTop - i.y,
    width: l.width,
    height: l.height
  };
}
function ss(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), a = [];
  t.forEach(function(o) {
    e.set(o.name, o);
  });
  function n(o) {
    r.add(o.name);
    var l = [].concat(o.requires || [], o.requiresIfExists || []);
    l.forEach(function(u) {
      if (!r.has(u)) {
        var i = e.get(u);
        i && n(i);
      }
    }), a.push(o);
  }
  return t.forEach(function(o) {
    r.has(o.name) || n(o);
  }), a;
}
function fs(t) {
  var e = ss(t);
  return _d.reduce(function(r, a) {
    return r.concat(e.filter(function(n) {
      return n.phase === a;
    }));
  }, []);
}
function cs(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function vs(t) {
  var e = t.reduce(function(r, a) {
    var n = r[a.name];
    return r[a.name] = n ? Object.assign({}, n, a, {
      options: Object.assign({}, n.options, a.options),
      data: Object.assign({}, n.data, a.data)
    }) : a, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
var ji = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Ai() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return !e.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function ms(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, a = r === void 0 ? [] : r, n = e.defaultOptions, o = n === void 0 ? ji : n;
  return function(u, i, d) {
    d === void 0 && (d = o);
    var s = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ji, o),
      modifiersData: {},
      elements: {
        reference: u,
        popper: i
      },
      attributes: {},
      styles: {}
    }, m = [], y = !1, v = {
      state: s,
      setOptions: function(b) {
        var M = typeof b == "function" ? b(s.options) : b;
        g(), s.options = Object.assign({}, o, s.options, M), s.scrollParents = {
          reference: ct(u) ? Nt(u) : u.contextElement ? Nt(u.contextElement) : [],
          popper: Nt(i)
        };
        var h = fs(vs([].concat(a, s.options.modifiers)));
        return s.orderedModifiers = h.filter(function(f) {
          return f.enabled;
        }), p(), v.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!y) {
          var b = s.elements, M = b.reference, h = b.popper;
          if (Ai(M, h)) {
            s.rects = {
              reference: ds(M, Xt(h), s.options.strategy === "fixed"),
              popper: qn(h)
            }, s.reset = !1, s.placement = s.options.placement, s.orderedModifiers.forEach(function(P) {
              return s.modifiersData[P.name] = Object.assign({}, P.data);
            });
            for (var f = 0; f < s.orderedModifiers.length; f++) {
              if (s.reset === !0) {
                s.reset = !1, f = -1;
                continue;
              }
              var w = s.orderedModifiers[f], _ = w.fn, x = w.options, T = x === void 0 ? {} : x, O = w.name;
              typeof _ == "function" && (s = _({
                state: s,
                options: T,
                name: O,
                instance: v
              }) || s);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: cs(function() {
        return new Promise(function(c) {
          v.forceUpdate(), c(s);
        });
      }),
      destroy: function() {
        g(), y = !0;
      }
    };
    if (!Ai(u, i))
      return v;
    v.setOptions(d).then(function(c) {
      !y && d.onFirstUpdate && d.onFirstUpdate(c);
    });
    function p() {
      s.orderedModifiers.forEach(function(c) {
        var b = c.name, M = c.options, h = M === void 0 ? {} : M, f = c.effect;
        if (typeof f == "function") {
          var w = f({
            state: s,
            name: b,
            instance: v,
            options: h
          }), _ = function() {
          };
          m.push(w || _);
        }
      });
    }
    function g() {
      m.forEach(function(c) {
        return c();
      }), m = [];
    }
    return v;
  };
}
var hs = [Fd, rs, Id, xd, es, Vd, is, Rd, Gd], ps = /* @__PURE__ */ ms({
  defaultModifiers: hs
});
function bs(t) {
  var e = re(null);
  return ot(function() {
    e.current = t;
  }, [t]), e;
}
function gs(t) {
  t === void 0 && (t = {});
  var e = mt(t), r = e.visible, a = r === void 0 ? !1 : r, n = e.animated, o = n === void 0 ? !1 : n, l = ae(e, ["visible", "animated"]), u = To(l), i = de(a), d = i[0], s = i[1], m = de(o), y = m[0], v = m[1], p = de(!1), g = p[0], c = p[1], b = bs(d), M = b.current != null && b.current !== d;
  y && !g && M && c(!0), oe(function() {
    if (typeof y == "number" && g) {
      var x = setTimeout(function() {
        return c(!1);
      }, y);
      return function() {
        clearTimeout(x);
      };
    }
    if (y && g && process.env.NODE_ENV === "development") {
      var T = setTimeout(function() {
        process.env.NODE_ENV !== "production" && De(g, "It's been 8 seconds but stopAnimation has not been called. Does the disclousure element have a CSS transition?");
      }, 8e3);
      return function() {
        clearTimeout(T);
      };
    }
    return function() {
    };
  }, [y, g]);
  var h = F(function() {
    return s(!0);
  }, []), f = F(function() {
    return s(!1);
  }, []), w = F(function() {
    return s(function(x) {
      return !x;
    });
  }, []), _ = F(function() {
    return c(!1);
  }, []);
  return E(E({}, u), {}, {
    visible: d,
    animated: y,
    animating: g,
    show: h,
    hide: f,
    toggle: w,
    setVisible: s,
    setAnimated: v,
    stopAnimation: _
  });
}
function ys(t) {
  t === void 0 && (t = {});
  var e = mt(t), r = e.modal, a = r === void 0 ? !0 : r, n = ae(e, ["modal"]), o = gs(n), l = de(a), u = l[0], i = l[1], d = re(null);
  return E(E({}, o), {}, {
    modal: u,
    setModal: i,
    unstable_disclosureRef: d
  });
}
var Ms = dt("Mac") && !dt("Chrome") && dt("Safari");
function Wi(t) {
  return function(e) {
    return t && !Ht(e, t) ? t : e;
  };
}
function ws(t) {
  t === void 0 && (t = {});
  var e = mt(t), r = e.gutter, a = r === void 0 ? 12 : r, n = e.placement, o = n === void 0 ? "bottom" : n, l = e.unstable_flip, u = l === void 0 ? !0 : l, i = e.unstable_offset, d = e.unstable_preventOverflow, s = d === void 0 ? !0 : d, m = e.unstable_fixed, y = m === void 0 ? !1 : m, v = e.modal, p = v === void 0 ? !1 : v, g = ae(e, ["gutter", "placement", "unstable_flip", "unstable_offset", "unstable_preventOverflow", "unstable_fixed", "modal"]), c = re(null), b = re(null), M = re(null), h = re(null), f = de(o), w = f[0], _ = f[1], x = de(o), T = x[0], O = x[1], P = de(i || [0, a]), R = P[0], D = de({
    position: "fixed",
    left: "100%",
    top: "100%"
  }), S = D[0], N = D[1], C = de({}), A = C[0], V = C[1], Q = ys(E({
    modal: p
  }, g)), G = F(function() {
    return c.current ? (c.current.forceUpdate(), !0) : !1;
  }, []), ue = F(function(ee) {
    ee.placement && O(ee.placement), ee.styles && (N(Wi(ee.styles.popper)), h.current && V(Wi(ee.styles.arrow)));
  }, []);
  return ot(function() {
    return b.current && M.current && (c.current = ps(b.current, M.current, {
      // https://popper.js.org/docs/v2/constructors/#options
      placement: w,
      strategy: y ? "fixed" : "absolute",
      // Safari needs styles to be applied in the first render, otherwise
      // hovering over the popover when it gets visible for the first time
      // will change its dimensions unexpectedly.
      onFirstUpdate: Ms ? ue : void 0,
      modifiers: [{
        // https://popper.js.org/docs/v2/modifiers/event-listeners/
        name: "eventListeners",
        enabled: Q.visible
      }, {
        // https://popper.js.org/docs/v2/modifiers/apply-styles/
        name: "applyStyles",
        enabled: !1
      }, {
        // https://popper.js.org/docs/v2/modifiers/flip/
        name: "flip",
        enabled: u,
        options: {
          padding: 8
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/offset/
        name: "offset",
        options: {
          offset: R
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/prevent-overflow/
        name: "preventOverflow",
        enabled: s,
        options: {
          tetherOffset: function() {
            var te;
            return ((te = h.current) === null || te === void 0 ? void 0 : te.clientWidth) || 0;
          }
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/arrow/
        name: "arrow",
        enabled: !!h.current,
        options: {
          element: h.current
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/#custom-modifiers
        name: "updateState",
        phase: "write",
        requires: ["computeStyles"],
        enabled: Q.visible && process.env.NODE_ENV !== "test",
        fn: function(te) {
          var ve = te.state;
          return ue(ve);
        }
      }]
    })), function() {
      c.current && (c.current.destroy(), c.current = null);
    };
  }, [w, y, Q.visible, u, R, s]), oe(function() {
    if (Q.visible) {
      var ee = window.requestAnimationFrame(function() {
        var te;
        (te = c.current) === null || te === void 0 || te.forceUpdate();
      });
      return function() {
        window.cancelAnimationFrame(ee);
      };
    }
  }, [Q.visible]), E(E({}, Q), {}, {
    unstable_referenceRef: b,
    unstable_popoverRef: M,
    unstable_arrowRef: h,
    unstable_popoverStyles: S,
    unstable_arrowStyles: A,
    unstable_update: G,
    unstable_originalPlacement: w,
    placement: T,
    place: _
  });
}
var _s = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation"], zo = _s, Es = zo, Uo = ye({
  name: "DisclosureContent",
  compose: qt,
  keys: Es,
  useProps: function(e, r) {
    var a = r.onTransitionEnd, n = r.onAnimationEnd, o = r.style, l = ae(r, ["onTransitionEnd", "onAnimationEnd", "style"]), u = e.animated && e.animating, i = de(null), d = i[0], s = i[1], m = !e.visible && !u, y = m ? E({
      display: "none"
    }, o) : o, v = ne(a), p = ne(n), g = re(0);
    oe(function() {
      if (e.animated)
        return g.current = window.requestAnimationFrame(function() {
          g.current = window.requestAnimationFrame(function() {
            e.visible ? s("enter") : s(u ? "leave" : null);
          });
        }), function() {
          return window.cancelAnimationFrame(g.current);
        };
    }, [e.animated, e.visible, u]);
    var c = F(function(h) {
      if (Fe(h) && u && e.animated === !0) {
        var f;
        (f = e.stopAnimation) === null || f === void 0 || f.call(e);
      }
    }, [e.animated, u, e.stopAnimation]), b = F(function(h) {
      var f;
      (f = v.current) === null || f === void 0 || f.call(v, h), c(h);
    }, [c]), M = F(function(h) {
      var f;
      (f = p.current) === null || f === void 0 || f.call(p, h), c(h);
    }, [c]);
    return E({
      id: e.baseId,
      "data-enter": d === "enter" ? "" : void 0,
      "data-leave": d === "leave" ? "" : void 0,
      onTransitionEnd: b,
      onAnimationEnd: M,
      hidden: m,
      style: y
    }, l);
  }
});
ge({
  as: "div",
  useHook: Uo
});
function Yo() {
  return kt ? document.body : null;
}
var Ii = /* @__PURE__ */ it(Yo());
function St(t) {
  var e = t.children, r = Ce(Ii) || Yo(), a = de(function() {
    if (kt) {
      var o = document.createElement("div");
      return o.className = St.__className, o;
    }
    return null;
  }), n = a[0];
  return ot(function() {
    if (!(!n || !r))
      return r.appendChild(n), function() {
        r.removeChild(n);
      };
  }, [n, r]), n ? /* @__PURE__ */ tl(/* @__PURE__ */ He(Ii.Provider, {
    value: n
  }, e), n) : null;
}
St.__className = "__reakit-portal";
St.__selector = "." + St.__className;
function Nr(t, e) {
  var r = t.indexOf(e);
  return Rl(t, r);
}
var nt = /* @__PURE__ */ it(null);
function Ps(t, e, r) {
  var a = "unstable_orphan" in r && r.unstable_orphan, n = Ce(nt), o = de([]), l = o[0], u = o[1], i = n || {}, d = i.addChild, s = i.removeChild, m = F(function(g) {
    return u(function(c) {
      return [].concat(c, [g]);
    });
  }, []), y = F(function(g) {
    return u(function(c) {
      return Nr(c, g);
    });
  }, []);
  oe(function() {
    if (!(!d || a))
      return d(t), function() {
        s == null || s(t);
      };
  }, [t, d, s, a]);
  var v = Le(function() {
    return {
      orientation: r.orientation,
      next: r.next,
      previous: r.previous,
      ref: t,
      role: e,
      parent: n,
      children: l,
      addChild: m,
      removeChild: y
    };
  }, [r.orientation, r.next, r.previous, t, e, n, l, m, y]), p = F(function(g) {
    return /* @__PURE__ */ He(nt.Provider, {
      value: v
    }, g);
  }, [v]);
  return p;
}
function xs(t) {
  if (Array.isArray(t)) {
    for (var e = 0, r = Array(t.length); e < t.length; e++)
      r[e] = t[e];
    return r;
  } else
    return Array.from(t);
}
var Gn = !1;
if (typeof window < "u") {
  var Ni = {
    get passive() {
      Gn = !0;
    }
  };
  window.addEventListener("testPassive", null, Ni), window.removeEventListener("testPassive", null, Ni);
}
var Bo = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), at = [], ur = !1, qo = -1, Ft = void 0, Lt = void 0, Ko = function(e) {
  return at.some(function(r) {
    return !!(r.options.allowTouchMove && r.options.allowTouchMove(e));
  });
}, lr = function(e) {
  var r = e || window.event;
  return Ko(r.target) || r.touches.length > 1 ? !0 : (r.preventDefault && r.preventDefault(), !1);
}, Os = function(e) {
  if (Lt === void 0) {
    var r = !!e && e.reserveScrollBarGap === !0, a = window.innerWidth - document.documentElement.clientWidth;
    r && a > 0 && (Lt = document.body.style.paddingRight, document.body.style.paddingRight = a + "px");
  }
  Ft === void 0 && (Ft = document.body.style.overflow, document.body.style.overflow = "hidden");
}, Ds = function() {
  Lt !== void 0 && (document.body.style.paddingRight = Lt, Lt = void 0), Ft !== void 0 && (document.body.style.overflow = Ft, Ft = void 0);
}, Ss = function(e) {
  return e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1;
}, Ts = function(e, r) {
  var a = e.targetTouches[0].clientY - qo;
  return Ko(e.target) ? !1 : r && r.scrollTop === 0 && a > 0 || Ss(r) && a < 0 ? lr(e) : (e.stopPropagation(), !0);
}, Cs = function(e, r) {
  if (!e) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!at.some(function(n) {
    return n.targetElement === e;
  })) {
    var a = {
      targetElement: e,
      options: r || {}
    };
    at = [].concat(xs(at), [a]), Bo ? (e.ontouchstart = function(n) {
      n.targetTouches.length === 1 && (qo = n.targetTouches[0].clientY);
    }, e.ontouchmove = function(n) {
      n.targetTouches.length === 1 && Ts(n, e);
    }, ur || (document.addEventListener("touchmove", lr, Gn ? { passive: !1 } : void 0), ur = !0)) : Os(r);
  }
}, ks = function(e) {
  if (!e) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  at = at.filter(function(r) {
    return r.targetElement !== e;
  }), Bo ? (e.ontouchstart = null, e.ontouchmove = null, ur && at.length === 0 && (document.removeEventListener("touchmove", lr, Gn ? { passive: !1 } : void 0), ur = !1)) : at.length || Ds();
}, Rs = /* @__PURE__ */ it(void 0);
function js(t) {
  return Array.isArray(t) ? !t.length : $n(t) ? !Object.keys(t).length : t == null || t === "";
}
var Xo = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal"], As = [].concat(Xo, ["hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_initialFocusRef", "unstable_finalFocusRef", "unstable_orphan", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide"]), Ws = Xo, Is = Ws;
function Ns(t, e) {
  var r = re(null), a = !!(e.animated && e.animating);
  return oe(function() {
    if (!(e.visible || a)) {
      var n = function(u) {
        var i = u.target;
        "focus" in i && (r.current = i, e.unstable_disclosureRef && (e.unstable_disclosureRef.current = i));
      }, o = Me(t.current);
      return o.addEventListener("focusin", n), function() {
        return o.removeEventListener("focusin", n);
      };
    }
  }, [e.visible, a, e.unstable_disclosureRef, t]), oe(function() {
    var n;
    if (!(!e.visible || a)) {
      var o = function(i) {
        var d = i.currentTarget;
        sr(d) && (i.preventDefault(), d.focus());
      }, l = ((n = e.unstable_disclosureRef) === null || n === void 0 ? void 0 : n.current) || r.current;
      return l == null || l.addEventListener("mousedown", o), function() {
        return l == null ? void 0 : l.removeEventListener("mousedown", o);
      };
    }
  }, [e.visible, a, e.unstable_disclosureRef]), e.unstable_disclosureRef || r;
}
function Fs(t, e) {
  var r = !!(e.preventBodyScroll && e.visible);
  oe(function() {
    var a = t.current;
    if (!(!a || !r))
      return Cs(a, {
        reserveScrollBarGap: !0
      }), function() {
        return ks(a);
      };
  }, [t, r]);
}
function Ls(t, e, r) {
  var a = r.unstable_initialFocusRef, n = r.visible && r.unstable_autoFocusOnShow, o = !!(r.animated && r.animating);
  wo(function() {
    var l = t.current;
    if (process.env.NODE_ENV !== "production" && De(!!n && !l, "[reakit/Dialog]", "Can't set initial focus on dialog because `ref` wasn't passed to the dialog element.", "See https://reakit.io/docs/dialog"), !!n && l && !o && !e.some(function(d) {
      return d.current && !d.current.hidden;
    }))
      if (a != null && a.current)
        a.current.focus({
          preventScroll: !0
        });
      else {
        var u = go(l, !0), i = function() {
          return Bt(l);
        };
        u ? $t(u, {
          preventScroll: !0,
          isActive: i
        }) : ($t(l, {
          preventScroll: !0,
          isActive: i
        }), process.env.NODE_ENV !== "production" && De(l.tabIndex === void 0 || l.tabIndex < 0, "It's recommended to have at least one tabbable element inside dialog. The dialog element has been automatically focused.", "If this is the intended behavior, pass `tabIndex={0}` to the dialog element to disable this warning.", "See https://reakit.io/docs/dialog/#initial-focus", l));
      }
  }, [t, n, o, e, a]);
}
function Hs(t, e) {
  var r = re(null);
  return oe(function() {
    var a = t.current;
    !a || !e.visible || (r.current = mo(a, St.__selector));
  }, [t, e.visible]), r;
}
function Fi(t) {
  t.parentNode != null && t.parentNode.removeChild(t);
}
var Vo = "__reakit-focus-trap";
function $s(t) {
  var e;
  return (e = t.classList) === null || e === void 0 ? void 0 : e.contains(Vo);
}
function zs(t, e, r) {
  var a = Hs(t, r), n = r.visible && r.modal, o = re(null), l = re(null);
  oe(function() {
    if (n) {
      var u = a.current;
      if (!u) {
        process.env.NODE_ENV !== "production" && De(!0, "Can't trap focus within modal dialog because either `ref` wasn't passed to component or the component wasn't rendered within a portal", "See https://reakit.io/docs/dialog");
        return;
      }
      if (!o.current) {
        var i = Me(u);
        o.current = i.createElement("div"), o.current.className = Vo, o.current.tabIndex = 0, o.current.style.position = "fixed", o.current.setAttribute("aria-hidden", "true");
      }
      return l.current || (l.current = o.current.cloneNode()), u.insertAdjacentElement("beforebegin", o.current), u.insertAdjacentElement("afterend", l.current), function() {
        o.current && Fi(o.current), l.current && Fi(l.current);
      };
    }
  }, [a, n]), oe(function() {
    var u = o.current, i = l.current;
    if (!(!n || !u || !i)) {
      var d = function(m) {
        var y = t.current;
        if (!(!y || e.length)) {
          m.preventDefault();
          var v = m.target === i, p = v ? go(y) : _l(y);
          p ? p.focus() : y.focus();
        }
      };
      return u.addEventListener("focus", d), i.addEventListener("focus", d), function() {
        u.removeEventListener("focus", d), i.removeEventListener("focus", d);
      };
    }
  }, [t, e, n]);
}
function Us(t) {
  var e = t.current;
  if (!e)
    return !1;
  var r = Rt(e);
  return !r || $e(e, r) ? !1 : !!(kr(r) || r.getAttribute("data-dialog") === "true");
}
function Ys(t, e, r) {
  var a = r.unstable_autoFocusOnHide && !r.visible, n = !!(r.animated && r.animating);
  wo(function() {
    var o;
    if (a && !n && !Us(t)) {
      var l = ((o = r.unstable_finalFocusRef) === null || o === void 0 ? void 0 : o.current) || e.current;
      if (l) {
        if (l.id) {
          var u = Me(l), i = u.querySelector("[aria-activedescendant='" + l.id + "']");
          if (i) {
            $t(i);
            return;
          }
        }
        $t(l);
        return;
      }
      process.env.NODE_ENV !== "production" && De(!0, "Can't return focus after closing dialog. Either render a disclosure component or provide a `unstable_finalFocusRef` prop.", "See https://reakit.io/docs/dialog", t.current);
    }
  }, [a, n, t, e]);
}
var Li = /* @__PURE__ */ it({});
function Bs(t, e) {
  var r = Ce(Li), a = de([]), n = a[0], o = a[1], l = de(n), u = l[0], i = l[1], d = F(function(g) {
    var c;
    (c = r.addDialog) === null || c === void 0 || c.call(r, g), o(function(b) {
      return [].concat(b, [g]);
    });
  }, [r.addDialog]), s = F(function(g) {
    var c;
    (c = r.removeDialog) === null || c === void 0 || c.call(r, g), o(function(b) {
      return Nr(b, g);
    });
  }, [r.removeDialog]), m = F(function(g) {
    var c;
    (c = r.showDialog) === null || c === void 0 || c.call(r, g), i(function(b) {
      return [].concat(b, [g]);
    });
  }, [r.showDialog]), y = F(function(g) {
    var c;
    (c = r.hideDialog) === null || c === void 0 || c.call(r, g), i(function(b) {
      return Nr(b, g);
    });
  }, [r.hideDialog]);
  oe(function() {
    var g;
    if (!e.unstable_orphan)
      return (g = r.addDialog) === null || g === void 0 || g.call(r, t), function() {
        var c;
        (c = r.removeDialog) === null || c === void 0 || c.call(r, t);
      };
  }, [e.unstable_orphan, r.addDialog, t, r.removeDialog]), oe(function() {
    var g;
    if (!e.unstable_orphan && e.modal && e.visible)
      return (g = r.showDialog) === null || g === void 0 || g.call(r, t), function() {
        var c;
        (c = r.hideDialog) === null || c === void 0 || c.call(r, t);
      };
  }, [e.unstable_orphan, e.modal, e.visible, r.showDialog, t, r.hideDialog]), oe(function() {
    if (r.visible === !1 && e.visible && !e.unstable_orphan) {
      var g;
      (g = e.hide) === null || g === void 0 || g.call(e);
    }
  }, [r.visible, e.visible, e.hide, e.unstable_orphan]);
  var v = Le(function() {
    return {
      visible: e.visible,
      addDialog: d,
      removeDialog: s,
      showDialog: m,
      hideDialog: y
    };
  }, [e.visible, d, s, m, y]), p = F(function(g) {
    return /* @__PURE__ */ He(Li.Provider, {
      value: v
    }, g);
  }, [v]);
  return {
    dialogs: n,
    visibleModals: u,
    wrap: p
  };
}
function qs(t) {
  return function(e) {
    var r = e.current;
    if (!r)
      return !1;
    if ($e(r, t))
      return !0;
    var a = Me(r), n = a.querySelector('[data-dialog-ref="' + r.id + '"]');
    return n ? $e(n, t) : !1;
  };
}
function Ks(t, e) {
  return $e(e, t);
}
function Xs(t) {
  var e = Me(t);
  return t.tagName === "HTML" ? !0 : $e(e.body, t);
}
function Fr(t, e, r, a, n, o, l) {
  var u = ne(n);
  oe(function() {
    if (o) {
      var i = function(m) {
        if (u.current) {
          var y = t.current, v = e.current, p = m.target;
          if (!y) {
            process.env.NODE_ENV !== "production" && De(!0, "Can't detect events outside dialog because `ref` wasn't passed to component.", "See https://reakit.io/docs/dialog");
            return;
          }
          Xs(p) && ($e(y, p) || v && Ks(p, v) || $s(p) || r.some(qs(p)) || u.current(m));
        }
      }, d = Me(t.current);
      return d.addEventListener(a, i, l), function() {
        return d.removeEventListener(a, i, l);
      };
    }
  }, [t, e, r, a, o, u]);
}
function Vs(t, e) {
  var r = re();
  return oe(function() {
    if (e.visible && e.hideOnClickOutside) {
      var a = Me(t.current), n = function(l) {
        r.current = l.target;
      };
      return a.addEventListener("mousedown", n), function() {
        return a.removeEventListener("mousedown", n);
      };
    }
  }, [e.visible, e.hideOnClickOutside, t]), r;
}
function Qs(t, e, r, a) {
  var n = Vs(t, a);
  Fr(t, e, r, "click", function(o) {
    if (n.current === o.target) {
      var l;
      (l = a.hide) === null || l === void 0 || l.call(a);
    }
  }, a.visible && a.hideOnClickOutside), Fr(t, e, r, "focusin", function(o) {
    var l = Me(t.current);
    if (o.target !== l && o.target !== l.body) {
      var u;
      (u = a.hide) === null || u === void 0 || u.call(a);
    }
  }, a.visible && a.hideOnClickOutside);
}
function Gs(t, e, r) {
  var a = function(o) {
    return Fr(t, {
      current: null
    }, e, o, function(l) {
      l.stopPropagation(), l.preventDefault();
    }, r.visible && r.modal, !0);
  };
  a("mouseover"), a("mousemove"), a("mouseout");
}
function Js(t, e) {
  oe(function() {
    var r = t.current;
    if (!(!e.visible || !r)) {
      var a = new MutationObserver(function(n) {
        var o = n[0].target;
        if (o === r) {
          var l = Me(r), u = Rt(r);
          (u === l.body || js(u)) && r.focus();
        }
      });
      return a.observe(r, {
        childList: !0,
        subtree: !0
      }), function() {
        a.disconnect();
      };
    }
  }, [e.visible, t]);
}
function Hi(t) {
  return t && t.tagName && t.tagName !== "HTML" && t !== Me(t).body;
}
function Zs(t, e) {
  var r = Ln(function(l) {
    return l + 1;
  }, 0), a = r[0], n = r[1];
  ot(function() {
    var l = t.current;
    e.visible && a && (Hi(Rt(l)) || (process.env.NODE_ENV !== "production" && De(!l, "Can't focus dialog after a nested element got blurred because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog"), l == null || l.focus()));
  }, [a, t]);
  var o = F(function(l) {
    if (e.visible) {
      var u = _o(l);
      Hi(u) || n();
    }
  }, [e.visible]);
  return o;
}
var Qo = ye({
  name: "Dialog",
  compose: Uo,
  keys: As,
  useOptions: function(e) {
    var r = e.modal, a = r === void 0 ? !0 : r, n = e.hideOnEsc, o = n === void 0 ? !0 : n, l = e.hideOnClickOutside, u = l === void 0 ? !0 : l, i = e.preventBodyScroll, d = i === void 0 ? a : i, s = e.unstable_autoFocusOnShow, m = s === void 0 ? !0 : s, y = e.unstable_autoFocusOnHide, v = y === void 0 ? !0 : y, p = e.unstable_orphan, g = ae(e, ["modal", "hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide", "unstable_orphan"]);
    return E({
      modal: a,
      hideOnEsc: o,
      hideOnClickOutside: u,
      preventBodyScroll: a && d,
      unstable_autoFocusOnShow: m,
      unstable_autoFocusOnHide: v,
      unstable_orphan: a && p
    }, g);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.onKeyDown, o = r.onBlur, l = r.wrapElement, u = r.tabIndex, i = ae(r, ["ref", "onKeyDown", "onBlur", "wrapElement", "tabIndex"]), d = re(null), s = Ce(Rs), m = s && s === e.baseId, y = Ns(d, e), v = ne(n), p = ne(o), g = Zs(d, e), c = Bs(d, e), b = c.dialogs, M = c.visibleModals, h = c.wrap, f = e.modal && !M.length ? !0 : void 0;
    Fs(d, e), zs(d, M, e), Js(d, e), Ls(d, b, e), Ys(d, y, e), Qs(d, y, b, e), Gs(d, b, e);
    var w = F(function(T) {
      var O;
      if ((O = v.current) === null || O === void 0 || O.call(v, T), !T.defaultPrevented && T.key === "Escape" && e.hideOnEsc) {
        if (!e.hide) {
          process.env.NODE_ENV !== "production" && De(!0, "`hideOnEsc` prop is truthy, but `hide` prop wasn't provided.", "See https://reakit.io/docs/dialog", d.current);
          return;
        }
        T.stopPropagation(), e.hide();
      }
    }, [e.hideOnEsc, e.hide]), _ = F(function(T) {
      var O;
      (O = p.current) === null || O === void 0 || O.call(p, T), g(T);
    }, [g]), x = F(function(T) {
      return T = h(T), e.modal && !m && (T = /* @__PURE__ */ He(St, null, T)), l && (T = l(T)), // Prevents Menu > Dialog > Menu to behave as a sub menu
      /* @__PURE__ */ He(nt.Provider, {
        value: null
      }, T);
    }, [h, e.modal, m, l]);
    return E({
      ref: Be(d, a),
      role: "dialog",
      tabIndex: u ?? -1,
      "aria-modal": f,
      "data-dialog": !0,
      onKeyDown: w,
      onBlur: _,
      wrapElement: x
    }, i);
  }
});
ge({
  as: "div",
  useHook: Qo,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Yt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/dialog"), Ct(e, r, a);
  }
});
var ef = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"], Go = ef, tf = Go, rf = tf, Jo = ye({
  name: "Popover",
  compose: Qo,
  keys: Go,
  useOptions: function(e) {
    var r = e.modal, a = r === void 0 ? !1 : r, n = ae(e, ["modal"]);
    return E({
      modal: a
    }, n);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.style, o = ae(r, ["ref", "style"]);
    return E({
      ref: Be(e.unstable_popoverRef, a),
      style: E(E({}, e.unstable_popoverStyles), n)
    }, o);
  }
});
ge({
  as: "div",
  useHook: Jo,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Yt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/popover"), Ct(e, r, a);
  }
});
var Zo = ye({
  name: "Disclosure",
  compose: yo,
  keys: zo,
  useProps: function(e, r) {
    var a = r.onClick, n = r["aria-controls"], o = ae(r, ["onClick", "aria-controls"]), l = ne(a), u = n ? n + " " + e.baseId : e.baseId, i = F(function(d) {
      var s, m;
      (s = l.current) === null || s === void 0 || s.call(l, d), !d.defaultPrevented && ((m = e.toggle) === null || m === void 0 || m.call(e));
    }, [e.toggle]);
    return E({
      "aria-expanded": !!e.visible,
      "aria-controls": u,
      onClick: i
    }, o);
  }
});
ge({
  as: "button",
  memo: !0,
  useHook: Zo
});
var eu = ye({
  name: "DialogDisclosure",
  compose: Zo,
  keys: Is,
  useProps: function(e, r) {
    var a = r.ref, n = r.onClick, o = ae(r, ["ref", "onClick"]), l = re(null), u = ne(n), i = de(!1), d = i[0], s = i[1], m = e.unstable_disclosureRef;
    ot(function() {
      var v = l.current;
      process.env.NODE_ENV !== "production" && De(!v, "Can't determine whether the element is the current disclosure because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog"), m && !m.current && (m.current = v);
      var p = !(m != null && m.current) || m.current === v;
      s(!!e.visible && p);
    }, [e.visible, m]);
    var y = F(function(v) {
      var p;
      (p = u.current) === null || p === void 0 || p.call(u, v), !v.defaultPrevented && m && (m.current = v.currentTarget);
    }, [m]);
    return E({
      ref: Be(l, a),
      "aria-haspopup": "dialog",
      "aria-expanded": d,
      onClick: y
    }, o);
  }
});
ge({
  as: "button",
  memo: !0,
  useHook: eu
});
var af = ["baseId", "unstable_idCountRef", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "unstable_values", "setBaseId", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget", "unstable_setValue"], nf = [].concat(af, ["visible", "animated", "animating", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"]), tu = nf, of = tu, ru = of, au = ru, uf = au, lf = uf, nu = lf, df = nu;
function sf(t, e, r) {
  var a = e.items, n = a === void 0 ? [] : a, o = e.move;
  r === void 0 && (r = 500);
  var l = de(""), u = l[0], i = l[1];
  oe(function() {
    if (u) {
      var d = setTimeout(function() {
        return i("");
      }, r), s = n.find(function(m) {
        return !!(m.ref.current && m.ref.current.textContent && m.ref.current.textContent.toLowerCase().startsWith(u));
      });
      return s && o(s.id), function() {
        return clearTimeout(d);
      };
    }
  }, [u, n, o, r]), oe(function() {
    var d = t.current;
    if (d) {
      var s = function(y) {
        var v;
        if (!(y.key.length > 1) && !y.shiftKey && !y.metaKey && !y.ctrlKey && !y.altKey) {
          var p = y.target, g = (v = p.getAttribute) === null || v === void 0 ? void 0 : v.call(p, "role"), c = p === d, b = g && g.indexOf("menuitem") !== -1 && mo(p, "[role=menu],[role=menubar]") === d;
          !c && !b || /^[a-z0-9_-]$/i.test(y.key) && (y.stopPropagation(), y.preventDefault(), i(function(M) {
            return "" + M + y.key;
          }));
        }
      };
      return d.addEventListener("keydown", s), function() {
        return d.removeEventListener("keydown", s);
      };
    }
  }, [t, i]);
}
var iu = ye({
  name: "MenuBar",
  compose: Oo,
  keys: ru,
  useProps: function(e, r) {
    var a = r.ref, n = r.wrapElement, o = r.role, l = o === void 0 ? "menubar" : o, u = ae(r, ["ref", "wrapElement", "role"]), i = re(null), d = Ps(i, l, e);
    sf(i, e);
    var s = F(function(m) {
      return m = d(m), n ? n(m) : m;
    }, [d, n]);
    return E({
      ref: Be(i, a),
      role: l,
      "aria-orientation": e.orientation,
      wrapElement: s
    }, u);
  }
});
ge({
  as: "div",
  useHook: iu,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Yt(!r["aria-label"] && !r["aria-labelledby"] && r.role !== "menubar", "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu"), Ct(e, r, a);
  }
});
function ff(t) {
  return Le(function() {
    var e;
    return t == null || (e = t.split("-")) === null || e === void 0 ? void 0 : e[0];
  }, [t]);
}
var cf = ye({
  name: "Menu",
  compose: [iu, Jo],
  keys: tu,
  useOptions: function(e) {
    var r = Ce(nt), a = (r == null ? void 0 : r.role) === "menubar";
    return E(E({
      unstable_autoFocusOnHide: !a,
      modal: !1
    }, e), {}, {
      // will be handled by MenuButton
      unstable_autoFocusOnShow: !1,
      // will be handled differently from usePopover/useDialog
      hideOnEsc: !1
    });
  },
  useProps: function(e, r) {
    for (var a = r.onKeyDown, n = ae(r, ["onKeyDown"]), o = ne(a), l = Ce(nt), u = !!l, i = l; i && i.role !== "menubar"; )
      i = i.parent;
    var d = i || {}, s = d.next, m = d.previous, y = d.orientation, v = y === "horizontal", p = ff(e.placement), g = F(function(c) {
      var b;
      if ((b = o.current) === null || b === void 0 || b.call(o, c), !c.defaultPrevented) {
        if (c.key === "Escape") {
          var M;
          u || c.stopPropagation(), (M = e.hide) === null || M === void 0 || M.call(e);
        } else if (u && !zn(c)) {
          var h = v && p !== "left" ? s : p === "left" && e.hide, f = v && p !== "right" ? m : p === "right" && e.hide, w = {
            ArrowRight: h,
            ArrowLeft: f
          }, _ = w[c.key];
          _ && (c.preventDefault(), u && c.stopPropagation(), _());
        }
      }
    }, [u, v, s, m, p, e.hide]);
    return E({
      role: "menu",
      onKeyDown: g
    }, n);
  }
}), vf = ge({
  as: "div",
  useHook: cf,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Yt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu"), Ct(e, r, a);
  }
});
function mf(t) {
  t === void 0 && (t = {});
  var e = mt(t), r = e.orientation, a = r === void 0 ? "horizontal" : r, n = e.unstable_values, o = n === void 0 ? {} : n, l = ae(e, ["orientation", "unstable_values"]), u = de(o), i = u[0], d = u[1], s = sd(E(E({}, l), {}, {
    orientation: a
  }));
  return E(E({}, s), {}, {
    unstable_values: i,
    unstable_setValue: F(function(m, y) {
      d(function(v) {
        var p;
        return E(E({}, v), {}, (p = {}, p[m] = typeof y == "function" ? y(v) : y, p));
      });
    }, [])
  });
}
var Lr = ye({
  name: "PopoverDisclosure",
  compose: eu,
  keys: rf,
  useProps: function(e, r) {
    var a = r.ref, n = ae(r, ["ref"]);
    return E({
      ref: Be(e.unstable_referenceRef, a)
    }, n);
  }
});
ge({
  as: "button",
  memo: !0,
  useHook: Lr
});
function Jn(t) {
  var e = t == null ? void 0 : t.find(function(r) {
    return r.current && !r.current.hidden;
  });
  return e == null ? void 0 : e.current;
}
var hf = function() {
}, pf = ye({
  name: "MenuButton",
  compose: Lr,
  keys: au,
  propsAreEqual: function(e, r) {
    e.unstable_popoverStyles, e.unstable_arrowStyles, e.currentId, e.unstable_moves;
    var a = ae(e, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
    r.unstable_popoverStyles, r.unstable_arrowStyles, r.currentId, r.unstable_moves;
    var n = ae(r, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
    return Lr.unstable_propsAreEqual(a, n);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.onClick, o = r.onKeyDown, l = r.onFocus, u = r.onMouseEnter, i = r.onMouseDown, d = ae(r, ["ref", "onClick", "onKeyDown", "onFocus", "onMouseEnter", "onMouseDown"]), s = Ce(nt), m = re(null), y = re(!1), v = e.placement.split("-"), p = v[0], g = !!s, c = (s == null ? void 0 : s.role) === "menubar", b = e.disabled || d["aria-disabled"], M = ne(n), h = ne(o), f = ne(l), w = ne(u), _ = ne(i), x = F(function(D) {
      var S;
      if (D.key === "Escape") {
        var N;
        (N = e.hide) === null || N === void 0 || N.call(e);
      } else if (!b) {
        var C = e.first && function() {
          return setTimeout(e.first);
        }, A = e.last && function() {
          return setTimeout(e.last);
        }, V = {
          Enter: C,
          " ": C,
          ArrowUp: (p === "top" || p === "bottom") && A,
          ArrowRight: p === "right" && C,
          ArrowDown: (p === "bottom" || p === "top") && C,
          ArrowLeft: p === "left" && C
        }, Q = V[D.key];
        if (Q) {
          var G;
          D.preventDefault(), D.stopPropagation(), (G = e.show) === null || G === void 0 || G.call(e), Q();
          return;
        }
      }
      (S = h.current) === null || S === void 0 || S.call(h, D);
    }, [b, e.hide, e.first, e.last, p, e.show]), T = F(function(D) {
      var S;
      if ((S = w.current) === null || S === void 0 || S.call(w, D), !D.defaultPrevented && s) {
        var N = D.currentTarget;
        c ? Jn(s.children) && N.focus() : setTimeout(function() {
          if (Bt(N)) {
            var C;
            (C = e.show) === null || C === void 0 || C.call(e);
          }
        }, 200);
      }
    }, [s, c, e.show]), O = F(function(D) {
      var S;
      y.current = !0, (S = _.current) === null || S === void 0 || S.call(_, D);
    }, []), P = F(function(D) {
      var S;
      if ((S = f.current) === null || S === void 0 || S.call(f, D), !D.defaultPrevented && !b && c && !y.current) {
        var N;
        (N = e.show) === null || N === void 0 || N.call(e);
      }
    }, [c, b, e.show]), R = F(function(D) {
      var S;
      if ((S = M.current) === null || S === void 0 || S.call(M, D), !D.defaultPrevented) {
        if (g && !c) {
          var N;
          (N = e.show) === null || N === void 0 || N.call(e);
        } else {
          var C;
          if ((C = e.toggle) === null || C === void 0 || C.call(e), y.current && !c && !e.visible) {
            var A;
            (A = e.move) === null || A === void 0 || A.call(e, null);
          }
        }
        y.current = !1;
      }
    }, [g, c, e.show, e.toggle, e.visible, e.move]);
    return E({
      ref: Be(m, a),
      "aria-haspopup": "menu",
      onKeyDown: x,
      onMouseEnter: T,
      onMouseDown: O,
      onFocus: P,
      onClick: R
    }, d);
  },
  useComposeOptions: function(e) {
    return E(E({}, e), {}, {
      // Toggling is handled by MenuButton
      toggle: hf
    });
  }
}), bf = ge({
  as: "button",
  memo: !0,
  useHook: pf
});
function tr(t, e, r) {
  return Math.abs((t.x * (e.y - r.y) + e.x * (r.y - t.y) + r.x * (t.y - e.y)) / 2);
}
function gf(t, e, r, a) {
  var n = tr(e, r, a), o = tr(t, r, a), l = tr(e, t, a), u = tr(e, r, t);
  return n === o + l + u;
}
function yf(t, e) {
  var r = e.getBoundingClientRect(), a = r.top, n = r.right, o = r.bottom, l = r.left, u = l > t.clientX ? l : n;
  return [{
    x: u,
    y: a
  }, {
    x: u,
    y: o
  }];
}
function Mf(t, e) {
  var r = ne(e), a = re(null), n = re(null), o = re(null), l = re(0), u = re(0), i = F(function(m) {
    if (t != null && t.children.length) {
      n.current = null, o.current = null;
      var y = Jn(t.children);
      if (y) {
        var v = yf(m, y);
        n.current = v[0], o.current = v[1];
      }
    }
  }, [t == null ? void 0 : t.children]), d = F(function(m) {
    var y = l.current !== m.clientX || u.current !== m.clientY;
    if (m.isTrusted && !y)
      return !0;
    var v = Math.abs(l.current - m.clientX);
    l.current = m.clientX, u.current = m.clientY;
    var p = function() {
      return n.current && o.current;
    };
    return m.type === "mouseleave" && !p() && i(m), p() ? v && a.current && gf({
      x: m.clientX,
      y: m.clientY
    }, a.current, n.current, o.current) : !1;
  }, [i]), s = F(function(m) {
    var y;
    (y = r.current) === null || y === void 0 || y.call(r, m), !m.defaultPrevented && (t == null ? void 0 : t.role) !== "menubar" && (a.current = {
      x: m.clientX,
      y: m.clientY
    }, i(m));
  }, [t == null ? void 0 : t.role, i]);
  return {
    onMouseEnter: s,
    isMouseInTransitToSubmenu: d
  };
}
function Zn(t) {
  var e = t.relatedTarget;
  return (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE ? t.relatedTarget : t.toElement || null;
}
function wf(t) {
  var e = Zn(t);
  return e ? $e(t.currentTarget, e) : !1;
}
function _f(t, e) {
  if (!(e != null && e.length))
    return !1;
  var r = Zn(t);
  if (!r)
    return !1;
  var a = Jn(e);
  return a && $e(a, r);
}
function Ef(t, e) {
  var r = Zn(t);
  return r ? e == null ? void 0 : e.some(function(a) {
    return a.ref.current && $e(a.ref.current, r);
  }) : !1;
}
var Pf = ye({
  name: "MenuItem",
  compose: jr,
  keys: nu,
  propsAreEqual: function(e, r) {
    e.unstable_popoverStyles, e.unstable_arrowStyles, e.visible;
    var a = ae(e, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
    r.unstable_popoverStyles, r.unstable_arrowStyles, r.visible;
    var n = ae(r, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
    return jr.unstable_propsAreEqual(a, n);
  },
  useProps: function(e, r) {
    var a = r.onMouseEnter, n = r.onMouseMove, o = r.onMouseLeave, l = ae(r, ["onMouseEnter", "onMouseMove", "onMouseLeave"]), u = Ce(nt), i = ne(n), d = ne(o), s = Mf(u, a), m = s.onMouseEnter, y = s.isMouseInTransitToSubmenu, v = F(function(g) {
      var c, b;
      (c = i.current) === null || c === void 0 || c.call(i, g), !g.defaultPrevented && (u == null ? void 0 : u.role) !== "menubar" && (y(g) || Bt(g.currentTarget) || (b = e.move) === null || b === void 0 || b.call(e, g.currentTarget.id));
    }, [e.move]), p = F(function(g) {
      var c;
      if ((c = d.current) === null || c === void 0 || c.call(d, g), !g.defaultPrevented && (u == null ? void 0 : u.role) !== "menubar" && !wf(g) && !_f(g, u == null ? void 0 : u.children) && !Ef(g, e.items)) {
        var b;
        if (y(g))
          return;
        (b = e.move) === null || b === void 0 || b.call(e, null);
      }
    }, [u == null ? void 0 : u.role, u == null ? void 0 : u.children, e.items, e.move]);
    return E({
      role: "menuitem",
      onMouseEnter: m,
      onMouseMove: v,
      onMouseLeave: p
    }, l);
  }
}), xf = ge({
  as: "button",
  memo: !0,
  useHook: Pf
}), Of = ["orientation"], ou = ye({
  name: "Separator",
  compose: qt,
  keys: Of,
  useOptions: function(e) {
    var r = e.orientation, a = r === void 0 ? "horizontal" : r, n = ae(e, ["orientation"]);
    return E({
      orientation: a
    }, n);
  },
  useProps: function(e, r) {
    return E({
      role: "separator",
      "aria-orientation": e.orientation
    }, r);
  }
});
ge({
  as: "hr",
  memo: !0,
  useHook: ou
});
var Df = ye({
  name: "MenuSeparator",
  compose: ou,
  keys: df,
  useOptions: function(e) {
    var r = e.orientation, a = r === void 0 ? "vertical" : r, n = ae(e, ["orientation"]);
    return E({
      orientation: a === "vertical" ? "horizontal" : "vertical"
    }, n);
  }
}), $i = ge({
  as: "hr",
  memo: !0,
  useHook: Df
});
function Sf(t) {
  t === void 0 && (t = {});
  var e = Ce(nt), r = mt(t), a = r.orientation, n = a === void 0 ? "vertical" : a, o = r.gutter, l = o === void 0 ? 0 : o, u = ae(r, ["orientation", "gutter"]), i = u.placement || (e && e.orientation === "vertical" ? "right-start" : "bottom-start"), d = mf(E(E({}, u), {}, {
    orientation: n
  })), s = ws(E(E({}, u), {}, {
    placement: i,
    gutter: l
  }));
  return oe(function() {
    s.visible || d.reset();
  }, [s.visible, d.reset]), E(E({}, d), s);
}
function Tf(t) {
  var e = t.children, r = t.unstable_system;
  return /* @__PURE__ */ He(Hn.Provider, {
    value: r
  }, e);
}
var Cf = {};
function uu(t) {
  var e = t.unstable_prefix, r = t.unstable_system, a = r === void 0 ? Cf : r, n = t.children;
  return /* @__PURE__ */ He(Kl, {
    prefix: e
  }, /* @__PURE__ */ He(Tf, {
    unstable_system: a
  }, n));
}
const lu = ({ children: t, i18nInstance: e }) => /* @__PURE__ */ q(Zu, { i18n: e, children: t }), ei = (t = "label") => {
  const e = Array.isArray(t) ? t : [t];
  return el(e);
}, kf = () => {
  const { t } = ei("label");
  return /* @__PURE__ */ q("div", { "data-testid": "default-loading-fallback", children: t("CX_ERROR_LOADING_TEXT", { ns: "label" }) });
};
var Hr = { exports: {} }, du = { exports: {} };
(function(t) {
  function e(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(du);
var I = du.exports, $r = { exports: {} }, zr = { exports: {} }, su = { exports: {} };
(function(t) {
  function e(r) {
    "@babel/helpers - typeof";
    return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(su);
var fu = su.exports, Ur = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a, n) {
    if (n.length < a)
      throw new TypeError(a + " argument" + (a > 1 ? "s" : "") + " required, but only " + n.length + " present");
  }
  t.exports = e.default;
})(Ur, Ur.exports);
var _e = Ur.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var a = r(fu), n = r(_e);
  function o(l) {
    return (0, n.default)(1, arguments), l instanceof Date || (0, a.default)(l) === "object" && Object.prototype.toString.call(l) === "[object Date]";
  }
  t.exports = e.default;
})(zr, zr.exports);
var Rf = zr.exports, Yr = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var a = r(fu), n = r(_e);
  function o(l) {
    (0, n.default)(1, arguments);
    var u = Object.prototype.toString.call(l);
    return l instanceof Date || (0, a.default)(l) === "object" && u === "[object Date]" ? new Date(l.getTime()) : typeof l == "number" || u === "[object Number]" ? new Date(l) : ((typeof l == "string" || u === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  t.exports = e.default;
})(Yr, Yr.exports);
var qe = Yr.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var a = r(Rf), n = r(qe), o = r(_e);
  function l(u) {
    if ((0, o.default)(1, arguments), !(0, a.default)(u) && typeof u != "number")
      return !1;
    var i = (0, n.default)(u);
    return !isNaN(Number(i));
  }
  t.exports = e.default;
})($r, $r.exports);
var jf = $r.exports, Br = { exports: {} }, qr = { exports: {} }, Kr = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    if (a === null || a === !0 || a === !1)
      return NaN;
    var n = Number(a);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  t.exports = e.default;
})(Kr, Kr.exports);
var ht = Kr.exports;
const Af = /* @__PURE__ */ pe(ht);
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var a = r(ht), n = r(qe), o = r(_e);
  function l(u, i) {
    (0, o.default)(2, arguments);
    var d = (0, n.default)(u).getTime(), s = (0, a.default)(i);
    return new Date(d + s);
  }
  t.exports = e.default;
})(qr, qr.exports);
var Wf = qr.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var a = r(Wf), n = r(_e), o = r(ht);
  function l(u, i) {
    (0, n.default)(2, arguments);
    var d = (0, o.default)(i);
    return (0, a.default)(u, -d);
  }
  t.exports = e.default;
})(Br, Br.exports);
var If = Br.exports, Xr = { exports: {} }, Vr = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var a = r(qe), n = r(_e), o = 864e5;
  function l(u) {
    (0, n.default)(1, arguments);
    var i = (0, a.default)(u), d = i.getTime();
    i.setUTCMonth(0, 1), i.setUTCHours(0, 0, 0, 0);
    var s = i.getTime(), m = d - s;
    return Math.floor(m / o) + 1;
  }
  t.exports = e.default;
})(Vr, Vr.exports);
var Nf = Vr.exports, Qr = { exports: {} }, Gr = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var a = r(qe), n = r(_e);
  function o(l) {
    (0, n.default)(1, arguments);
    var u = 1, i = (0, a.default)(l), d = i.getUTCDay(), s = (d < u ? 7 : 0) + d - u;
    return i.setUTCDate(i.getUTCDate() - s), i.setUTCHours(0, 0, 0, 0), i;
  }
  t.exports = e.default;
})(Gr, Gr.exports);
var ti = Gr.exports, Jr = { exports: {} }, Zr = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var a = r(qe), n = r(_e), o = r(ti);
  function l(u) {
    (0, n.default)(1, arguments);
    var i = (0, a.default)(u), d = i.getUTCFullYear(), s = /* @__PURE__ */ new Date(0);
    s.setUTCFullYear(d + 1, 0, 4), s.setUTCHours(0, 0, 0, 0);
    var m = (0, o.default)(s), y = /* @__PURE__ */ new Date(0);
    y.setUTCFullYear(d, 0, 4), y.setUTCHours(0, 0, 0, 0);
    var v = (0, o.default)(y);
    return i.getTime() >= m.getTime() ? d + 1 : i.getTime() >= v.getTime() ? d : d - 1;
  }
  t.exports = e.default;
})(Zr, Zr.exports);
var cu = Zr.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var a = r(cu), n = r(ti), o = r(_e);
  function l(u) {
    (0, o.default)(1, arguments);
    var i = (0, a.default)(u), d = /* @__PURE__ */ new Date(0);
    d.setUTCFullYear(i, 0, 4), d.setUTCHours(0, 0, 0, 0);
    var s = (0, n.default)(d);
    return s;
  }
  t.exports = e.default;
})(Jr, Jr.exports);
var Ff = Jr.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var a = r(qe), n = r(ti), o = r(Ff), l = r(_e), u = 6048e5;
  function i(d) {
    (0, l.default)(1, arguments);
    var s = (0, a.default)(d), m = (0, n.default)(s).getTime() - (0, o.default)(s).getTime();
    return Math.round(m / u) + 1;
  }
  t.exports = e.default;
})(Qr, Qr.exports);
var Lf = Qr.exports, ea = { exports: {} }, ta = { exports: {} }, pt = {};
Object.defineProperty(pt, "__esModule", {
  value: !0
});
pt.getDefaultOptions = Hf;
pt.setDefaultOptions = $f;
var vu = {};
function Hf() {
  return vu;
}
function $f(t) {
  vu = t;
}
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = u;
  var a = r(qe), n = r(_e), o = r(ht), l = pt;
  function u(i, d) {
    var s, m, y, v, p, g, c, b;
    (0, n.default)(1, arguments);
    var M = (0, l.getDefaultOptions)(), h = (0, o.default)((s = (m = (y = (v = d == null ? void 0 : d.weekStartsOn) !== null && v !== void 0 ? v : d == null || (p = d.locale) === null || p === void 0 || (g = p.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && y !== void 0 ? y : M.weekStartsOn) !== null && m !== void 0 ? m : (c = M.locale) === null || c === void 0 || (b = c.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && s !== void 0 ? s : 0);
    if (!(h >= 0 && h <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var f = (0, a.default)(i), w = f.getUTCDay(), _ = (w < h ? 7 : 0) + w - h;
    return f.setUTCDate(f.getUTCDate() - _), f.setUTCHours(0, 0, 0, 0), f;
  }
  t.exports = e.default;
})(ta, ta.exports);
var cr = ta.exports, ra = { exports: {} }, aa = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var a = r(qe), n = r(_e), o = r(cr), l = r(ht), u = pt;
  function i(d, s) {
    var m, y, v, p, g, c, b, M;
    (0, n.default)(1, arguments);
    var h = (0, a.default)(d), f = h.getUTCFullYear(), w = (0, u.getDefaultOptions)(), _ = (0, l.default)((m = (y = (v = (p = s == null ? void 0 : s.firstWeekContainsDate) !== null && p !== void 0 ? p : s == null || (g = s.locale) === null || g === void 0 || (c = g.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && v !== void 0 ? v : w.firstWeekContainsDate) !== null && y !== void 0 ? y : (b = w.locale) === null || b === void 0 || (M = b.options) === null || M === void 0 ? void 0 : M.firstWeekContainsDate) !== null && m !== void 0 ? m : 1);
    if (!(_ >= 1 && _ <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var x = /* @__PURE__ */ new Date(0);
    x.setUTCFullYear(f + 1, 0, _), x.setUTCHours(0, 0, 0, 0);
    var T = (0, o.default)(x, s), O = /* @__PURE__ */ new Date(0);
    O.setUTCFullYear(f, 0, _), O.setUTCHours(0, 0, 0, 0);
    var P = (0, o.default)(O, s);
    return h.getTime() >= T.getTime() ? f + 1 : h.getTime() >= P.getTime() ? f : f - 1;
  }
  t.exports = e.default;
})(aa, aa.exports);
var mu = aa.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var a = r(mu), n = r(_e), o = r(cr), l = r(ht), u = pt;
  function i(d, s) {
    var m, y, v, p, g, c, b, M;
    (0, n.default)(1, arguments);
    var h = (0, u.getDefaultOptions)(), f = (0, l.default)((m = (y = (v = (p = s == null ? void 0 : s.firstWeekContainsDate) !== null && p !== void 0 ? p : s == null || (g = s.locale) === null || g === void 0 || (c = g.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && v !== void 0 ? v : h.firstWeekContainsDate) !== null && y !== void 0 ? y : (b = h.locale) === null || b === void 0 || (M = b.options) === null || M === void 0 ? void 0 : M.firstWeekContainsDate) !== null && m !== void 0 ? m : 1), w = (0, a.default)(d, s), _ = /* @__PURE__ */ new Date(0);
    _.setUTCFullYear(w, 0, f), _.setUTCHours(0, 0, 0, 0);
    var x = (0, o.default)(_, s);
    return x;
  }
  t.exports = e.default;
})(ra, ra.exports);
var zf = ra.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var a = r(qe), n = r(cr), o = r(zf), l = r(_e), u = 6048e5;
  function i(d, s) {
    (0, l.default)(1, arguments);
    var m = (0, a.default)(d), y = (0, n.default)(m, s).getTime() - (0, o.default)(m, s).getTime();
    return Math.round(y / u) + 1;
  }
  t.exports = e.default;
})(ea, ea.exports);
var Uf = ea.exports, na = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a, n) {
    for (var o = a < 0 ? "-" : "", l = Math.abs(a).toString(); l.length < n; )
      l = "0" + l;
    return o + l;
  }
  t.exports = e.default;
})(na, na.exports);
var hu = na.exports, ia = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(hu), n = {
    // Year
    y: function(u, i) {
      var d = u.getUTCFullYear(), s = d > 0 ? d : 1 - d;
      return (0, a.default)(i === "yy" ? s % 100 : s, i.length);
    },
    // Month
    M: function(u, i) {
      var d = u.getUTCMonth();
      return i === "M" ? String(d + 1) : (0, a.default)(d + 1, 2);
    },
    // Day of the month
    d: function(u, i) {
      return (0, a.default)(u.getUTCDate(), i.length);
    },
    // AM or PM
    a: function(u, i) {
      var d = u.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (i) {
        case "a":
        case "aa":
          return d.toUpperCase();
        case "aaa":
          return d;
        case "aaaaa":
          return d[0];
        case "aaaa":
        default:
          return d === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(u, i) {
      return (0, a.default)(u.getUTCHours() % 12 || 12, i.length);
    },
    // Hour [0-23]
    H: function(u, i) {
      return (0, a.default)(u.getUTCHours(), i.length);
    },
    // Minute
    m: function(u, i) {
      return (0, a.default)(u.getUTCMinutes(), i.length);
    },
    // Second
    s: function(u, i) {
      return (0, a.default)(u.getUTCSeconds(), i.length);
    },
    // Fraction of second
    S: function(u, i) {
      var d = i.length, s = u.getUTCMilliseconds(), m = Math.floor(s * Math.pow(10, d - 3));
      return (0, a.default)(m, i.length);
    }
  }, o = n;
  e.default = o, t.exports = e.default;
})(ia, ia.exports);
var Yf = ia.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Nf), n = r(Lf), o = r(cu), l = r(Uf), u = r(mu), i = r(hu), d = r(Yf), s = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, m = {
    // Era
    G: function(b, M, h) {
      var f = b.getUTCFullYear() > 0 ? 1 : 0;
      switch (M) {
        case "G":
        case "GG":
        case "GGG":
          return h.era(f, {
            width: "abbreviated"
          });
        case "GGGGG":
          return h.era(f, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return h.era(f, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(b, M, h) {
      if (M === "yo") {
        var f = b.getUTCFullYear(), w = f > 0 ? f : 1 - f;
        return h.ordinalNumber(w, {
          unit: "year"
        });
      }
      return d.default.y(b, M);
    },
    // Local week-numbering year
    Y: function(b, M, h, f) {
      var w = (0, u.default)(b, f), _ = w > 0 ? w : 1 - w;
      if (M === "YY") {
        var x = _ % 100;
        return (0, i.default)(x, 2);
      }
      return M === "Yo" ? h.ordinalNumber(_, {
        unit: "year"
      }) : (0, i.default)(_, M.length);
    },
    // ISO week-numbering year
    R: function(b, M) {
      var h = (0, o.default)(b);
      return (0, i.default)(h, M.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(b, M) {
      var h = b.getUTCFullYear();
      return (0, i.default)(h, M.length);
    },
    // Quarter
    Q: function(b, M, h) {
      var f = Math.ceil((b.getUTCMonth() + 1) / 3);
      switch (M) {
        case "Q":
          return String(f);
        case "QQ":
          return (0, i.default)(f, 2);
        case "Qo":
          return h.ordinalNumber(f, {
            unit: "quarter"
          });
        case "QQQ":
          return h.quarter(f, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return h.quarter(f, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return h.quarter(f, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(b, M, h) {
      var f = Math.ceil((b.getUTCMonth() + 1) / 3);
      switch (M) {
        case "q":
          return String(f);
        case "qq":
          return (0, i.default)(f, 2);
        case "qo":
          return h.ordinalNumber(f, {
            unit: "quarter"
          });
        case "qqq":
          return h.quarter(f, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return h.quarter(f, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return h.quarter(f, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(b, M, h) {
      var f = b.getUTCMonth();
      switch (M) {
        case "M":
        case "MM":
          return d.default.M(b, M);
        case "Mo":
          return h.ordinalNumber(f + 1, {
            unit: "month"
          });
        case "MMM":
          return h.month(f, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return h.month(f, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return h.month(f, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(b, M, h) {
      var f = b.getUTCMonth();
      switch (M) {
        case "L":
          return String(f + 1);
        case "LL":
          return (0, i.default)(f + 1, 2);
        case "Lo":
          return h.ordinalNumber(f + 1, {
            unit: "month"
          });
        case "LLL":
          return h.month(f, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return h.month(f, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return h.month(f, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(b, M, h, f) {
      var w = (0, l.default)(b, f);
      return M === "wo" ? h.ordinalNumber(w, {
        unit: "week"
      }) : (0, i.default)(w, M.length);
    },
    // ISO week of year
    I: function(b, M, h) {
      var f = (0, n.default)(b);
      return M === "Io" ? h.ordinalNumber(f, {
        unit: "week"
      }) : (0, i.default)(f, M.length);
    },
    // Day of the month
    d: function(b, M, h) {
      return M === "do" ? h.ordinalNumber(b.getUTCDate(), {
        unit: "date"
      }) : d.default.d(b, M);
    },
    // Day of year
    D: function(b, M, h) {
      var f = (0, a.default)(b);
      return M === "Do" ? h.ordinalNumber(f, {
        unit: "dayOfYear"
      }) : (0, i.default)(f, M.length);
    },
    // Day of week
    E: function(b, M, h) {
      var f = b.getUTCDay();
      switch (M) {
        case "E":
        case "EE":
        case "EEE":
          return h.day(f, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return h.day(f, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return h.day(f, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return h.day(f, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(b, M, h, f) {
      var w = b.getUTCDay(), _ = (w - f.weekStartsOn + 8) % 7 || 7;
      switch (M) {
        case "e":
          return String(_);
        case "ee":
          return (0, i.default)(_, 2);
        case "eo":
          return h.ordinalNumber(_, {
            unit: "day"
          });
        case "eee":
          return h.day(w, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return h.day(w, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return h.day(w, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return h.day(w, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(b, M, h, f) {
      var w = b.getUTCDay(), _ = (w - f.weekStartsOn + 8) % 7 || 7;
      switch (M) {
        case "c":
          return String(_);
        case "cc":
          return (0, i.default)(_, M.length);
        case "co":
          return h.ordinalNumber(_, {
            unit: "day"
          });
        case "ccc":
          return h.day(w, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return h.day(w, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return h.day(w, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return h.day(w, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(b, M, h) {
      var f = b.getUTCDay(), w = f === 0 ? 7 : f;
      switch (M) {
        case "i":
          return String(w);
        case "ii":
          return (0, i.default)(w, M.length);
        case "io":
          return h.ordinalNumber(w, {
            unit: "day"
          });
        case "iii":
          return h.day(f, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return h.day(f, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return h.day(f, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return h.day(f, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(b, M, h) {
      var f = b.getUTCHours(), w = f / 12 >= 1 ? "pm" : "am";
      switch (M) {
        case "a":
        case "aa":
          return h.dayPeriod(w, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return h.dayPeriod(w, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return h.dayPeriod(w, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return h.dayPeriod(w, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(b, M, h) {
      var f = b.getUTCHours(), w;
      switch (f === 12 ? w = s.noon : f === 0 ? w = s.midnight : w = f / 12 >= 1 ? "pm" : "am", M) {
        case "b":
        case "bb":
          return h.dayPeriod(w, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return h.dayPeriod(w, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return h.dayPeriod(w, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return h.dayPeriod(w, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(b, M, h) {
      var f = b.getUTCHours(), w;
      switch (f >= 17 ? w = s.evening : f >= 12 ? w = s.afternoon : f >= 4 ? w = s.morning : w = s.night, M) {
        case "B":
        case "BB":
        case "BBB":
          return h.dayPeriod(w, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return h.dayPeriod(w, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return h.dayPeriod(w, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(b, M, h) {
      if (M === "ho") {
        var f = b.getUTCHours() % 12;
        return f === 0 && (f = 12), h.ordinalNumber(f, {
          unit: "hour"
        });
      }
      return d.default.h(b, M);
    },
    // Hour [0-23]
    H: function(b, M, h) {
      return M === "Ho" ? h.ordinalNumber(b.getUTCHours(), {
        unit: "hour"
      }) : d.default.H(b, M);
    },
    // Hour [0-11]
    K: function(b, M, h) {
      var f = b.getUTCHours() % 12;
      return M === "Ko" ? h.ordinalNumber(f, {
        unit: "hour"
      }) : (0, i.default)(f, M.length);
    },
    // Hour [1-24]
    k: function(b, M, h) {
      var f = b.getUTCHours();
      return f === 0 && (f = 24), M === "ko" ? h.ordinalNumber(f, {
        unit: "hour"
      }) : (0, i.default)(f, M.length);
    },
    // Minute
    m: function(b, M, h) {
      return M === "mo" ? h.ordinalNumber(b.getUTCMinutes(), {
        unit: "minute"
      }) : d.default.m(b, M);
    },
    // Second
    s: function(b, M, h) {
      return M === "so" ? h.ordinalNumber(b.getUTCSeconds(), {
        unit: "second"
      }) : d.default.s(b, M);
    },
    // Fraction of second
    S: function(b, M) {
      return d.default.S(b, M);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(b, M, h, f) {
      var w = f._originalDate || b, _ = w.getTimezoneOffset();
      if (_ === 0)
        return "Z";
      switch (M) {
        case "X":
          return v(_);
        case "XXXX":
        case "XX":
          return p(_);
        case "XXXXX":
        case "XXX":
        default:
          return p(_, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(b, M, h, f) {
      var w = f._originalDate || b, _ = w.getTimezoneOffset();
      switch (M) {
        case "x":
          return v(_);
        case "xxxx":
        case "xx":
          return p(_);
        case "xxxxx":
        case "xxx":
        default:
          return p(_, ":");
      }
    },
    // Timezone (GMT)
    O: function(b, M, h, f) {
      var w = f._originalDate || b, _ = w.getTimezoneOffset();
      switch (M) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + y(_, ":");
        case "OOOO":
        default:
          return "GMT" + p(_, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(b, M, h, f) {
      var w = f._originalDate || b, _ = w.getTimezoneOffset();
      switch (M) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + y(_, ":");
        case "zzzz":
        default:
          return "GMT" + p(_, ":");
      }
    },
    // Seconds timestamp
    t: function(b, M, h, f) {
      var w = f._originalDate || b, _ = Math.floor(w.getTime() / 1e3);
      return (0, i.default)(_, M.length);
    },
    // Milliseconds timestamp
    T: function(b, M, h, f) {
      var w = f._originalDate || b, _ = w.getTime();
      return (0, i.default)(_, M.length);
    }
  };
  function y(c, b) {
    var M = c > 0 ? "-" : "+", h = Math.abs(c), f = Math.floor(h / 60), w = h % 60;
    if (w === 0)
      return M + String(f);
    var _ = b || "";
    return M + String(f) + _ + (0, i.default)(w, 2);
  }
  function v(c, b) {
    if (c % 60 === 0) {
      var M = c > 0 ? "-" : "+";
      return M + (0, i.default)(Math.abs(c) / 60, 2);
    }
    return p(c, b);
  }
  function p(c, b) {
    var M = b || "", h = c > 0 ? "-" : "+", f = Math.abs(c), w = (0, i.default)(Math.floor(f / 60), 2), _ = (0, i.default)(f % 60, 2);
    return h + w + M + _;
  }
  var g = m;
  e.default = g, t.exports = e.default;
})(Xr, Xr.exports);
var Bf = Xr.exports, oa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = function(i, d) {
    switch (i) {
      case "P":
        return d.date({
          width: "short"
        });
      case "PP":
        return d.date({
          width: "medium"
        });
      case "PPP":
        return d.date({
          width: "long"
        });
      case "PPPP":
      default:
        return d.date({
          width: "full"
        });
    }
  }, a = function(i, d) {
    switch (i) {
      case "p":
        return d.time({
          width: "short"
        });
      case "pp":
        return d.time({
          width: "medium"
        });
      case "ppp":
        return d.time({
          width: "long"
        });
      case "pppp":
      default:
        return d.time({
          width: "full"
        });
    }
  }, n = function(i, d) {
    var s = i.match(/(P+)(p+)?/) || [], m = s[1], y = s[2];
    if (!y)
      return r(i, d);
    var v;
    switch (m) {
      case "P":
        v = d.dateTime({
          width: "short"
        });
        break;
      case "PP":
        v = d.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        v = d.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        v = d.dateTime({
          width: "full"
        });
        break;
    }
    return v.replace("{{date}}", r(m, d)).replace("{{time}}", a(y, d));
  }, o = {
    p: a,
    P: n
  }, l = o;
  e.default = l, t.exports = e.default;
})(oa, oa.exports);
var qf = oa.exports, ua = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    var n = new Date(Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds(), a.getMilliseconds()));
    return n.setUTCFullYear(a.getFullYear()), a.getTime() - n.getTime();
  }
  t.exports = e.default;
})(ua, ua.exports);
var pu = ua.exports;
const zi = /* @__PURE__ */ pe(pu);
var Vt = {};
Object.defineProperty(Vt, "__esModule", {
  value: !0
});
Vt.isProtectedDayOfYearToken = Vf;
Vt.isProtectedWeekYearToken = Qf;
Vt.throwProtectedError = Gf;
var Kf = ["D", "DD"], Xf = ["YY", "YYYY"];
function Vf(t) {
  return Kf.indexOf(t) !== -1;
}
function Qf(t) {
  return Xf.indexOf(t) !== -1;
}
function Gf(t, e, r) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var la = { exports: {} }, da = { exports: {} }, sa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, a = function(l, u, i) {
    var d, s = r[l];
    return typeof s == "string" ? d = s : u === 1 ? d = s.one : d = s.other.replace("{{count}}", u.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "in " + d : d + " ago" : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(sa, sa.exports);
var jt = sa.exports, fa = { exports: {} }, ca = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    return function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = n.width ? String(n.width) : a.defaultWidth, l = a.formats[o] || a.formats[a.defaultWidth];
      return l;
    };
  }
  t.exports = e.default;
})(ca, ca.exports);
var Ee = ca.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, l = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(fa, fa.exports);
var Jf = fa.exports, va = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, a = function(l, u, i, d) {
    return r[l];
  }, n = a;
  e.default = n, t.exports = e.default;
})(va, va.exports);
var bt = va.exports, ma = { exports: {} }, ha = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    return function(n, o) {
      var l = o != null && o.context ? String(o.context) : "standalone", u;
      if (l === "formatting" && a.formattingValues) {
        var i = a.defaultFormattingWidth || a.defaultWidth, d = o != null && o.width ? String(o.width) : i;
        u = a.formattingValues[d] || a.formattingValues[i];
      } else {
        var s = a.defaultWidth, m = o != null && o.width ? String(o.width) : a.defaultWidth;
        u = a.values[m] || a.values[s];
      }
      var y = a.argumentCallback ? a.argumentCallback(n) : n;
      return u[y];
    };
  }
  t.exports = e.default;
})(ha, ha.exports);
var Ke = ha.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, l = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, u = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, s = function(p, g) {
    var c = Number(p), b = c % 100;
    if (b > 20 || b < 10)
      switch (b % 10) {
        case 1:
          return c + "st";
        case 2:
          return c + "nd";
        case 3:
          return c + "rd";
      }
    return c + "th";
  }, m = {
    ordinalNumber: s,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(p) {
        return p - 1;
      }
    }),
    month: (0, a.default)({
      values: l,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: d,
      defaultFormattingWidth: "wide"
    })
  }, y = m;
  e.default = y, t.exports = e.default;
})(ma, ma.exports);
var gt = ma.exports, pa = { exports: {} }, ba = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(o) {
    return function(l) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = u.width, d = i && o.matchPatterns[i] || o.matchPatterns[o.defaultMatchWidth], s = l.match(d);
      if (!s)
        return null;
      var m = s[0], y = i && o.parsePatterns[i] || o.parsePatterns[o.defaultParseWidth], v = Array.isArray(y) ? n(y, function(c) {
        return c.test(m);
      }) : a(y, function(c) {
        return c.test(m);
      }), p;
      p = o.valueCallback ? o.valueCallback(v) : v, p = u.valueCallback ? u.valueCallback(p) : p;
      var g = l.slice(m.length);
      return {
        value: p,
        rest: g
      };
    };
  }
  function a(o, l) {
    for (var u in o)
      if (o.hasOwnProperty(u) && l(o[u]))
        return u;
  }
  function n(o, l) {
    for (var u = 0; u < o.length; u++)
      if (l(o[u]))
        return u;
  }
  t.exports = e.default;
})(ba, ba.exports);
var Xe = ba.exports, ga = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    return function(n) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = n.match(a.matchPattern);
      if (!l)
        return null;
      var u = l[0], i = n.match(a.parsePattern);
      if (!i)
        return null;
      var d = a.valueCallback ? a.valueCallback(i[0]) : i[0];
      d = o.valueCallback ? o.valueCallback(d) : d;
      var s = n.slice(u.length);
      return {
        value: d,
        rest: s
      };
    };
  }
  t.exports = e.default;
})(ga, ga.exports);
var Ve = ga.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Xe), n = r(Ve), o = /^(\d+)(th|st|nd|rd)?/i, l = /\d+/i, u = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, i = {
    any: [/^b/i, /^(a|c)/i]
  }, d = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, s = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, y = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, p = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, g = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, c = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: l,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: s,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: g,
      defaultMatchWidth: "any",
      parsePatterns: c,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(pa, pa.exports);
var yt = pa.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(jt), n = r(Jf), o = r(bt), l = r(gt), u = r(yt), i = {
    code: "en-US",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: l.default,
    match: u.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(da, da.exports);
var bu = da.exports;
const Zf = /* @__PURE__ */ pe(bu);
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(bu), n = a.default;
  e.default = n, t.exports = e.default;
})(la, la.exports);
var ec = la.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = h;
  var a = r(jf), n = r(If), o = r(qe), l = r(Bf), u = r(qf), i = r(pu), d = Vt, s = r(ht), m = r(_e), y = pt, v = r(ec), p = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, g = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, c = /^'([^]*?)'?$/, b = /''/g, M = /[a-zA-Z]/;
  function h(w, _, x) {
    var T, O, P, R, D, S, N, C, A, V, Q, G, ue, ee, te, ve, L, U;
    (0, m.default)(2, arguments);
    var J = String(_), se = (0, y.getDefaultOptions)(), fe = (T = (O = x == null ? void 0 : x.locale) !== null && O !== void 0 ? O : se.locale) !== null && T !== void 0 ? T : v.default, be = (0, s.default)((P = (R = (D = (S = x == null ? void 0 : x.firstWeekContainsDate) !== null && S !== void 0 ? S : x == null || (N = x.locale) === null || N === void 0 || (C = N.options) === null || C === void 0 ? void 0 : C.firstWeekContainsDate) !== null && D !== void 0 ? D : se.firstWeekContainsDate) !== null && R !== void 0 ? R : (A = se.locale) === null || A === void 0 || (V = A.options) === null || V === void 0 ? void 0 : V.firstWeekContainsDate) !== null && P !== void 0 ? P : 1);
    if (!(be >= 1 && be <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var k = (0, s.default)((Q = (G = (ue = (ee = x == null ? void 0 : x.weekStartsOn) !== null && ee !== void 0 ? ee : x == null || (te = x.locale) === null || te === void 0 || (ve = te.options) === null || ve === void 0 ? void 0 : ve.weekStartsOn) !== null && ue !== void 0 ? ue : se.weekStartsOn) !== null && G !== void 0 ? G : (L = se.locale) === null || L === void 0 || (U = L.options) === null || U === void 0 ? void 0 : U.weekStartsOn) !== null && Q !== void 0 ? Q : 0);
    if (!(k >= 0 && k <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!fe.localize)
      throw new RangeError("locale must contain localize property");
    if (!fe.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var W = (0, o.default)(w);
    if (!(0, a.default)(W))
      throw new RangeError("Invalid time value");
    var K = (0, i.default)(W), Y = (0, n.default)(W, K), z = {
      firstWeekContainsDate: be,
      weekStartsOn: k,
      locale: fe,
      _originalDate: W
    }, Z = J.match(g).map(function(H) {
      var $ = H[0];
      if ($ === "p" || $ === "P") {
        var B = u.default[$];
        return B(H, fe.formatLong);
      }
      return H;
    }).join("").match(p).map(function(H) {
      if (H === "''")
        return "'";
      var $ = H[0];
      if ($ === "'")
        return f(H);
      var B = l.default[$];
      if (B)
        return !(x != null && x.useAdditionalWeekYearTokens) && (0, d.isProtectedWeekYearToken)(H) && (0, d.throwProtectedError)(H, _, String(w)), !(x != null && x.useAdditionalDayOfYearTokens) && (0, d.isProtectedDayOfYearToken)(H) && (0, d.throwProtectedError)(H, _, String(w)), B(Y, H, fe.localize, z);
      if ($.match(M))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + $ + "`");
      return H;
    }).join("");
    return Z;
  }
  function f(w) {
    var _ = w.match(c);
    return _ ? _[1].replace(b, "'") : w;
  }
  t.exports = e.default;
})(Hr, Hr.exports);
var tc = Hr.exports;
const rc = /* @__PURE__ */ pe(tc);
function Ui(t, e, r) {
  var a = ic(t, r.timeZone, r.locale);
  return a.formatToParts ? ac(a, e) : nc(a, e);
}
function ac(t, e) {
  for (var r = t.formatToParts(e), a = r.length - 1; a >= 0; --a)
    if (r[a].type === "timeZoneName")
      return r[a].value;
}
function nc(t, e) {
  var r = t.format(e).replace(/\u200E/g, ""), a = / [\w-+ ]+$/.exec(r);
  return a ? a[0].substr(1) : "";
}
function ic(t, e, r) {
  if (r && !r.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(r ? [r.code, "en-US"] : void 0, {
    timeZone: e,
    timeZoneName: t
  });
}
function oc(t, e) {
  var r = sc(e);
  return r.formatToParts ? lc(r, t) : dc(r, t);
}
var uc = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function lc(t, e) {
  try {
    for (var r = t.formatToParts(e), a = [], n = 0; n < r.length; n++) {
      var o = uc[r[n].type];
      o >= 0 && (a[o] = parseInt(r[n].value, 10));
    }
    return a;
  } catch (l) {
    if (l instanceof RangeError)
      return [NaN];
    throw l;
  }
}
function dc(t, e) {
  var r = t.format(e), a = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [a[3], a[1], a[2], a[4], a[5], a[6]];
}
var wr = {};
function sc(t) {
  if (!wr[t]) {
    var e = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), r = e === "06/25/2014, 00:00:00" || e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    wr[t] = r ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return wr[t];
}
function gu(t, e, r, a, n, o, l) {
  var u = /* @__PURE__ */ new Date(0);
  return u.setUTCFullYear(t, e, r), u.setUTCHours(a, n, o, l), u;
}
var Yi = 36e5, fc = 6e4, _r = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function ri(t, e, r) {
  var a, n;
  if (!t || (a = _r.timezoneZ.exec(t), a))
    return 0;
  var o;
  if (a = _r.timezoneHH.exec(t), a)
    return o = parseInt(a[1], 10), Bi(o) ? -(o * Yi) : NaN;
  if (a = _r.timezoneHHMM.exec(t), a) {
    o = parseInt(a[2], 10);
    var l = parseInt(a[3], 10);
    return Bi(o, l) ? (n = Math.abs(o) * Yi + l * fc, a[1] === "+" ? -n : n) : NaN;
  }
  if (mc(t)) {
    e = new Date(e || Date.now());
    var u = r ? e : cc(e), i = ya(u, t), d = r ? i : vc(e, i, t);
    return -d;
  }
  return NaN;
}
function cc(t) {
  return gu(
    t.getFullYear(),
    t.getMonth(),
    t.getDate(),
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  );
}
function ya(t, e) {
  var r = oc(t, e), a = gu(
    r[0],
    r[1] - 1,
    r[2],
    r[3] % 24,
    r[4],
    r[5],
    0
  ).getTime(), n = t.getTime(), o = n % 1e3;
  return n -= o >= 0 ? o : 1e3 + o, a - n;
}
function vc(t, e, r) {
  var a = t.getTime(), n = a - e, o = ya(new Date(n), r);
  if (e === o)
    return e;
  n -= o - e;
  var l = ya(new Date(n), r);
  return o === l ? o : Math.max(o, l);
}
function Bi(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
var qi = {};
function mc(t) {
  if (qi[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), qi[t] = !0, !0;
  } catch {
    return !1;
  }
}
var hc = 60 * 1e3, pc = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, r, a) {
    var n = Er(a.timeZone, t);
    if (n === 0)
      return "Z";
    switch (e) {
      case "X":
        return Ki(n);
      case "XXXX":
      case "XX":
        return _t(n);
      case "XXXXX":
      case "XXX":
      default:
        return _t(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, r, a) {
    var n = Er(a.timeZone, t);
    switch (e) {
      case "x":
        return Ki(n);
      case "xxxx":
      case "xx":
        return _t(n);
      case "xxxxx":
      case "xxx":
      default:
        return _t(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, r, a) {
    var n = Er(a.timeZone, t);
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + bc(n, ":");
      case "OOOO":
      default:
        return "GMT" + _t(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, r, a) {
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return Ui("short", t, a);
      case "zzzz":
      default:
        return Ui("long", t, a);
    }
  }
};
function Er(t, e) {
  var r = t ? ri(t, e, !0) / hc : e.getTimezoneOffset();
  if (Number.isNaN(r))
    throw new RangeError("Invalid time zone specified: " + t);
  return r;
}
function dr(t, e) {
  for (var r = t < 0 ? "-" : "", a = Math.abs(t).toString(); a.length < e; )
    a = "0" + a;
  return r + a;
}
function _t(t, e) {
  var r = e || "", a = t > 0 ? "-" : "+", n = Math.abs(t), o = dr(Math.floor(n / 60), 2), l = dr(Math.floor(n % 60), 2);
  return a + o + r + l;
}
function Ki(t, e) {
  if (t % 60 === 0) {
    var r = t > 0 ? "-" : "+";
    return r + dr(Math.abs(t) / 60, 2);
  }
  return _t(t, e);
}
function bc(t, e) {
  var r = t > 0 ? "-" : "+", a = Math.abs(t), n = Math.floor(a / 60), o = a % 60;
  if (o === 0)
    return r + String(n);
  var l = e || "";
  return r + String(n) + l + dr(o, 2);
}
const gc = pc;
var yc = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, Pr = 36e5, Xi = 6e4, Mc = 2, Pe = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: yc
};
function yu(t, e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var r = e || {}, a = r.additionalDigits == null ? Mc : Af(r.additionalDigits);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n = wc(t), o = _c(n.date, a), l = o.year, u = o.restDateString, i = Ec(u, l);
  if (isNaN(i))
    return /* @__PURE__ */ new Date(NaN);
  if (i) {
    var d = i.getTime(), s = 0, m;
    if (n.time && (s = Pc(n.time), isNaN(s)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || r.timeZone) {
      if (m = ri(n.timeZone || r.timeZone, new Date(d + s)), isNaN(m))
        return /* @__PURE__ */ new Date(NaN);
    } else
      m = zi(new Date(d + s)), m = zi(new Date(d + s + m));
    return new Date(d + s + m);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function wc(t) {
  var e = {}, r = Pe.dateTimePattern.exec(t), a;
  if (r ? (e.date = r[1], a = r[3]) : (r = Pe.datePattern.exec(t), r ? (e.date = r[1], a = r[2]) : (e.date = null, a = t)), a) {
    var n = Pe.timeZone.exec(a);
    n ? (e.time = a.replace(n[1], ""), e.timeZone = n[1].trim()) : e.time = a;
  }
  return e;
}
function _c(t, e) {
  var r = Pe.YYY[e], a = Pe.YYYYY[e], n;
  if (n = Pe.YYYY.exec(t) || a.exec(t), n) {
    var o = n[1];
    return {
      year: parseInt(o, 10),
      restDateString: t.slice(o.length)
    };
  }
  if (n = Pe.YY.exec(t) || r.exec(t), n) {
    var l = n[1];
    return {
      year: parseInt(l, 10) * 100,
      restDateString: t.slice(l.length)
    };
  }
  return {
    year: null
  };
}
function Ec(t, e) {
  if (e === null)
    return null;
  var r, a, n, o;
  if (t.length === 0)
    return a = /* @__PURE__ */ new Date(0), a.setUTCFullYear(e), a;
  if (r = Pe.MM.exec(t), r)
    return a = /* @__PURE__ */ new Date(0), n = parseInt(r[1], 10) - 1, Qi(e, n) ? (a.setUTCFullYear(e, n), a) : /* @__PURE__ */ new Date(NaN);
  if (r = Pe.DDD.exec(t), r) {
    a = /* @__PURE__ */ new Date(0);
    var l = parseInt(r[1], 10);
    return Dc(e, l) ? (a.setUTCFullYear(e, 0, l), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Pe.MMDD.exec(t), r) {
    a = /* @__PURE__ */ new Date(0), n = parseInt(r[1], 10) - 1;
    var u = parseInt(r[2], 10);
    return Qi(e, n, u) ? (a.setUTCFullYear(e, n, u), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Pe.Www.exec(t), r)
    return o = parseInt(r[1], 10) - 1, Gi(e, o) ? Vi(e, o) : /* @__PURE__ */ new Date(NaN);
  if (r = Pe.WwwD.exec(t), r) {
    o = parseInt(r[1], 10) - 1;
    var i = parseInt(r[2], 10) - 1;
    return Gi(e, o, i) ? Vi(e, o, i) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Pc(t) {
  var e, r, a;
  if (e = Pe.HH.exec(t), e)
    return r = parseFloat(e[1].replace(",", ".")), xr(r) ? r % 24 * Pr : NaN;
  if (e = Pe.HHMM.exec(t), e)
    return r = parseInt(e[1], 10), a = parseFloat(e[2].replace(",", ".")), xr(r, a) ? r % 24 * Pr + a * Xi : NaN;
  if (e = Pe.HHMMSS.exec(t), e) {
    r = parseInt(e[1], 10), a = parseInt(e[2], 10);
    var n = parseFloat(e[3].replace(",", "."));
    return xr(r, a, n) ? r % 24 * Pr + a * Xi + n * 1e3 : NaN;
  }
  return null;
}
function Vi(t, e, r) {
  e = e || 0, r = r || 0;
  var a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4);
  var n = a.getUTCDay() || 7, o = e * 7 + r + 1 - n;
  return a.setUTCDate(a.getUTCDate() + o), a;
}
var xc = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Oc = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Mu(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function Qi(t, e, r) {
  if (e < 0 || e > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    var a = Mu(t);
    if (a && r > Oc[e] || !a && r > xc[e])
      return !1;
  }
  return !0;
}
function Dc(t, e) {
  if (e < 1)
    return !1;
  var r = Mu(t);
  return !(r && e > 366 || !r && e > 365);
}
function Gi(t, e, r) {
  return !(e < 0 || e > 52 || r != null && (r < 0 || r > 6));
}
function xr(t, e, r) {
  return !(t != null && (t < 0 || t >= 25) || e != null && (e < 0 || e >= 60) || r != null && (r < 0 || r >= 60));
}
var Sc = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function Tc(t, e, r) {
  var a = String(e), n = r || {}, o = a.match(Sc);
  if (o) {
    var l = yu(n.originalDate || t, n);
    a = o.reduce(function(u, i) {
      if (i[0] === "'")
        return u;
      var d = u.indexOf(i), s = u[d - 1] === "'", m = u.replace(
        i,
        "'" + gc[i[0]](l, i, null, n) + "'"
      );
      return s ? m.substring(0, d - 1) + m.substring(d + 1) : m;
    }, a);
  }
  return rc(t, a, n);
}
var Ma = { exports: {} }, wa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a, n) {
    if (a == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (a[o] = n[o]);
    return a;
  }
  t.exports = e.default;
})(wa, wa.exports);
var Cc = wa.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  var a = r(Cc);
  function n(o) {
    return (0, a.default)({}, o);
  }
  t.exports = e.default;
})(Ma, Ma.exports);
var kc = Ma.exports;
const Rc = /* @__PURE__ */ pe(kc);
function jc(t, e, r) {
  var a = yu(t, r), n = ri(e, a, !0), o = new Date(a.getTime() - n), l = /* @__PURE__ */ new Date(0);
  return l.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), l.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), l;
}
function Ji(t, e, r, a) {
  var n = Rc(a);
  return n.timeZone = e, n.originalDate = t, Tc(jc(t, e), r, n);
}
var _a = { exports: {} }, Ea = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "mindre end ét sekund",
      other: "mindre end {{count}} sekunder"
    },
    xSeconds: {
      one: "1 sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "ét halvt minut",
    lessThanXMinutes: {
      one: "mindre end ét minut",
      other: "mindre end {{count}} minutter"
    },
    xMinutes: {
      one: "1 minut",
      other: "{{count}} minutter"
    },
    aboutXHours: {
      one: "cirka 1 time",
      other: "cirka {{count}} timer"
    },
    xHours: {
      one: "1 time",
      other: "{{count}} timer"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dage"
    },
    aboutXWeeks: {
      one: "cirka 1 uge",
      other: "cirka {{count}} uger"
    },
    xWeeks: {
      one: "1 uge",
      other: "{{count}} uger"
    },
    aboutXMonths: {
      one: "cirka 1 måned",
      other: "cirka {{count}} måneder"
    },
    xMonths: {
      one: "1 måned",
      other: "{{count}} måneder"
    },
    aboutXYears: {
      one: "cirka 1 år",
      other: "cirka {{count}} år"
    },
    xYears: {
      one: "1 år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "over 1 år",
      other: "over {{count}} år"
    },
    almostXYears: {
      one: "næsten 1 år",
      other: "næsten {{count}} år"
    }
  }, a = function(l, u, i) {
    var d, s = r[l];
    return typeof s == "string" ? d = s : u === 1 ? d = s.one : d = s.other.replace("{{count}}", String(u)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "om " + d : d + " siden" : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Ea, Ea.exports);
var Ac = Ea.exports, Pa = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE 'den' d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, l = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(Pa, Pa.exports);
var Wc = Pa.exports, xa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i går kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'på' eeee 'kl.' p",
    other: "P"
  }, a = function(l, u, i, d) {
    return r[l];
  }, n = a;
  e.default = n, t.exports = e.default;
})(xa, xa.exports);
var Ic = xa.exports, Oa = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = {
    narrow: ["fvt", "vt"],
    abbreviated: ["f.v.t.", "v.t."],
    wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
    wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
  }, l = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
  }, u = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
    abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
    wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    }
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    }
  }, s = function(p, g) {
    var c = Number(p);
    return c + ".";
  }, m = {
    ordinalNumber: s,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(p) {
        return p - 1;
      }
    }),
    month: (0, a.default)({
      values: l,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: d,
      defaultFormattingWidth: "wide"
    })
  }, y = m;
  e.default = y, t.exports = e.default;
})(Oa, Oa.exports);
var Nc = Oa.exports, Da = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Xe), n = r(Ve), o = /^(\d+)(\.)?/i, l = /\d+/i, u = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
  }, i = {
    any: [/^f/i, /^(v|e)/i]
  }, d = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
  }, s = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
  }, y = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
  }, p = {
    narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, g = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
  }, c = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /midnat/i,
      noon: /middag/i,
      morning: /morgen/i,
      afternoon: /eftermiddag/i,
      evening: /aften/i,
      night: /nat/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: l,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: s,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: g,
      defaultMatchWidth: "any",
      parsePatterns: c,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(Da, Da.exports);
var Fc = Da.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ac), n = r(Wc), o = r(Ic), l = r(Nc), u = r(Fc), i = {
    code: "da",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: l.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(_a, _a.exports);
var Lc = _a.exports;
const Hc = /* @__PURE__ */ pe(Lc);
var Sa = { exports: {} }, Ta = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      standalone: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      },
      withPreposition: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      }
    },
    xSeconds: {
      standalone: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      },
      withPreposition: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      }
    },
    halfAMinute: {
      standalone: "halbe Minute",
      withPreposition: "halben Minute"
    },
    lessThanXMinutes: {
      standalone: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      },
      withPreposition: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      }
    },
    xMinutes: {
      standalone: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      },
      withPreposition: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      }
    },
    aboutXHours: {
      standalone: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      },
      withPreposition: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      }
    },
    xHours: {
      standalone: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      },
      withPreposition: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      }
    },
    xDays: {
      standalone: {
        one: "1 Tag",
        other: "{{count}} Tage"
      },
      withPreposition: {
        one: "1 Tag",
        other: "{{count}} Tagen"
      }
    },
    aboutXWeeks: {
      standalone: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      },
      withPreposition: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      }
    },
    xWeeks: {
      standalone: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      },
      withPreposition: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      }
    },
    aboutXMonths: {
      standalone: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monate"
      },
      withPreposition: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monaten"
      }
    },
    xMonths: {
      standalone: {
        one: "1 Monat",
        other: "{{count}} Monate"
      },
      withPreposition: {
        one: "1 Monat",
        other: "{{count}} Monaten"
      }
    },
    aboutXYears: {
      standalone: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahre"
      },
      withPreposition: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahren"
      }
    },
    xYears: {
      standalone: {
        one: "1 Jahr",
        other: "{{count}} Jahre"
      },
      withPreposition: {
        one: "1 Jahr",
        other: "{{count}} Jahren"
      }
    },
    overXYears: {
      standalone: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahre"
      },
      withPreposition: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahren"
      }
    },
    almostXYears: {
      standalone: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahre"
      },
      withPreposition: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahren"
      }
    }
  }, a = function(l, u, i) {
    var d, s = i != null && i.addSuffix ? r[l].withPreposition : r[l].standalone;
    return typeof s == "string" ? d = s : u === 1 ? d = s.one : d = s.other.replace("{{count}}", String(u)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "in " + d : "vor " + d : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Ta, Ta.exports);
var $c = Ta.exports, Ca = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE, do MMMM y",
    // Montag, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan. 2018
    short: "dd.MM.y"
    // 07.01.2018
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, l = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(Ca, Ca.exports);
var zc = Ca.exports, ka = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
  }, a = function(l, u, i, d) {
    return r[l];
  }, n = a;
  e.default = n, t.exports = e.default;
})(ka, ka.exports);
var Uc = ka.exports, Ra = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = {
    narrow: ["v.Chr.", "n.Chr."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["vor Christus", "nach Christus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
  }, l = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
  }, u = {
    narrow: l.narrow,
    abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
    wide: l.wide
  }, i = {
    narrow: ["S", "M", "D", "M", "D", "F", "S"],
    short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
    wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
  }, d = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachm.",
      evening: "Abend",
      night: "Nacht"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    }
  }, s = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachm.",
      evening: "abends",
      night: "nachts"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    }
  }, m = function(g) {
    var c = Number(g);
    return c + ".";
  }, y = {
    ordinalNumber: m,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(g) {
        return g - 1;
      }
    }),
    month: (0, a.default)({
      values: l,
      formattingValues: u,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: s,
      defaultFormattingWidth: "wide"
    })
  }, v = y;
  e.default = v, t.exports = e.default;
})(Ra, Ra.exports);
var Yc = Ra.exports, ja = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Xe), n = r(Ve), o = /^(\d+)(\.)?/i, l = /\d+/i, u = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
  }, i = {
    any: [/^v/i, /^n/i]
  }, d = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
  }, s = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
  }, y = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
  }, p = {
    any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
  }, g = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
  }, c = {
    any: {
      am: /^v/i,
      pm: /^n/i,
      midnight: /^Mitte/i,
      noon: /^Mitta/i,
      morning: /morgens/i,
      afternoon: /nachmittags/i,
      // will never be matched. Afternoon is matched by `pm`
      evening: /abends/i,
      night: /nachts/i
      // will never be matched. Night is matched by `pm`
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: l,
      valueCallback: function(f) {
        return parseInt(f);
      }
    }),
    era: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: s,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: c,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(ja, ja.exports);
var Bc = ja.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r($c), n = r(zc), o = r(Uc), l = r(Yc), u = r(Bc), i = {
    code: "de",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: l.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(Sa, Sa.exports);
var qc = Sa.exports;
const Kc = /* @__PURE__ */ pe(qc);
var Aa = { exports: {} }, Wa = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, l = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(Wa, Wa.exports);
var Xc = Wa.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(jt), n = r(Xc), o = r(bt), l = r(gt), u = r(yt), i = {
    code: "en-AU",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: l.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(Aa, Aa.exports);
var Vc = Aa.exports;
const Qc = /* @__PURE__ */ pe(Vc);
var Ia = { exports: {} }, Na = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "a second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "a minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about an hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "an hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "a day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about a week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "a week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about a month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "a month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about a year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "a year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over a year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost a year",
      other: "almost {{count}} years"
    }
  }, a = function(l, u, i) {
    var d, s = r[l];
    return typeof s == "string" ? d = s : u === 1 ? d = s.one : d = s.other.replace("{{count}}", u.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "in " + d : d + " ago" : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Na, Na.exports);
var Gc = Na.exports, Fa = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE, MMMM do, yyyy",
    long: "MMMM do, yyyy",
    medium: "MMM d, yyyy",
    short: "yyyy-MM-dd"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, l = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(Fa, Fa.exports);
var Jc = Fa.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(bt), n = r(gt), o = r(yt), l = r(Gc), u = r(Jc), i = {
    code: "en-CA",
    formatDistance: l.default,
    formatLong: u.default,
    formatRelative: a.default,
    localize: n.default,
    match: o.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(Ia, Ia.exports);
var Zc = Ia.exports;
const ev = /* @__PURE__ */ pe(Zc);
var La = { exports: {} }, Ha = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, l = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(Ha, Ha.exports);
var tv = Ha.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(jt), n = r(bt), o = r(gt), l = r(yt), u = r(tv), i = {
    code: "en-GB",
    formatDistance: a.default,
    formatLong: u.default,
    formatRelative: n.default,
    localize: o.default,
    match: l.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(La, La.exports);
var rv = La.exports;
const av = /* @__PURE__ */ pe(rv);
var $a = { exports: {} }, za = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM, yyyy",
    medium: "d MMM, yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, l = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(za, za.exports);
var nv = za.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(jt), n = r(bt), o = r(gt), l = r(yt), u = r(nv), i = {
    code: "en-IN",
    formatDistance: a.default,
    formatLong: u.default,
    formatRelative: n.default,
    localize: o.default,
    match: l.default,
    options: {
      weekStartsOn: 1,
      // Monday is the first day of the week.
      firstWeekContainsDate: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})($a, $a.exports);
var iv = $a.exports;
const ov = /* @__PURE__ */ pe(iv);
var Ua = { exports: {} }, Ya = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, l = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(Ya, Ya.exports);
var uv = Ya.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(jt), n = r(bt), o = r(gt), l = r(yt), u = r(uv), i = {
    code: "en-NZ",
    formatDistance: a.default,
    formatLong: u.default,
    formatRelative: n.default,
    localize: o.default,
    match: l.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(Ua, Ua.exports);
var lv = Ua.exports;
const dv = /* @__PURE__ */ pe(lv);
var Ba = { exports: {} }, qa = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "yyyy/MM/dd"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, l = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(qa, qa.exports);
var sv = qa.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(jt), n = r(bt), o = r(gt), l = r(yt), u = r(sv), i = {
    code: "en-ZA",
    formatDistance: a.default,
    formatLong: u.default,
    formatRelative: n.default,
    localize: o.default,
    match: l.default,
    options: {
      weekStartsOn: 0,
      // Sunday is the first day of the week.
      firstWeekContainsDate: 1
      // The week that contains Jan 1st is the first week of the year.
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(Ba, Ba.exports);
var fv = Ba.exports;
const cv = /* @__PURE__ */ pe(fv);
var Ka = { exports: {} }, Xa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "menos de un segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
      one: "menos de un minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "alrededor de 1 hora",
      other: "alrededor de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 día",
      other: "{{count}} días"
    },
    aboutXWeeks: {
      one: "alrededor de 1 semana",
      other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "alrededor de 1 mes",
      other: "alrededor de {{count}} meses"
    },
    xMonths: {
      one: "1 mes",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "alrededor de 1 año",
      other: "alrededor de {{count}} años"
    },
    xYears: {
      one: "1 año",
      other: "{{count}} años"
    },
    overXYears: {
      one: "más de 1 año",
      other: "más de {{count}} años"
    },
    almostXYears: {
      one: "casi 1 año",
      other: "casi {{count}} años"
    }
  }, a = function(l, u, i) {
    var d, s = r[l];
    return typeof s == "string" ? d = s : u === 1 ? d = s.one : d = s.other.replace("{{count}}", u.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "en " + d : "hace " + d : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Xa, Xa.exports);
var vv = Xa.exports, Va = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, l = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(Va, Va.exports);
var mv = Va.exports, Qa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'mañana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
  }, a = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'mañana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
  }, n = function(u, i, d, s) {
    return i.getUTCHours() !== 1 ? a[u] : r[u];
  }, o = n;
  e.default = o, t.exports = e.default;
})(Qa, Qa.exports);
var hv = Qa.exports, Ga = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "después de cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, l = {
    narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
  }, u = {
    narrow: ["d", "l", "m", "m", "j", "v", "s"],
    short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
    abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    }
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    }
  }, s = function(p, g) {
    var c = Number(p);
    return c + "º";
  }, m = {
    ordinalNumber: s,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(p) {
        return Number(p) - 1;
      }
    }),
    month: (0, a.default)({
      values: l,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: d,
      defaultFormattingWidth: "wide"
    })
  }, y = m;
  e.default = y, t.exports = e.default;
})(Ga, Ga.exports);
var pv = Ga.exports, Ja = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ve), n = r(Xe), o = /^(\d+)(º)?/i, l = /\d+/i, u = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
  }, i = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
  }, d = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, s = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
  }, y = {
    narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
  }, v = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
  }, p = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
  }, g = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
  }, c = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn/i,
      noon: /^md/i,
      morning: /mañana/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noche/i
    }
  }, b = {
    ordinalNumber: (0, a.default)({
      matchPattern: o,
      parsePattern: l,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, n.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, n.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: s,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, n.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    day: (0, n.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, n.default)({
      matchPatterns: g,
      defaultMatchWidth: "any",
      parsePatterns: c,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(Ja, Ja.exports);
var bv = Ja.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(vv), n = r(mv), o = r(hv), l = r(pv), u = r(bv), i = {
    code: "es",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: l.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 1
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(Ka, Ka.exports);
var gv = Ka.exports;
const yv = /* @__PURE__ */ pe(gv);
var Za = { exports: {} }, en = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "moins d’une seconde",
      other: "moins de {{count}} secondes"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
      one: "moins d’une minute",
      other: "moins de {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "environ 1 heure",
      other: "environ {{count}} heures"
    },
    xHours: {
      one: "1 heure",
      other: "{{count}} heures"
    },
    xDays: {
      one: "1 jour",
      other: "{{count}} jours"
    },
    aboutXWeeks: {
      one: "environ 1 semaine",
      other: "environ {{count}} semaines"
    },
    xWeeks: {
      one: "1 semaine",
      other: "{{count}} semaines"
    },
    aboutXMonths: {
      one: "environ 1 mois",
      other: "environ {{count}} mois"
    },
    xMonths: {
      one: "1 mois",
      other: "{{count}} mois"
    },
    aboutXYears: {
      one: "environ 1 an",
      other: "environ {{count}} ans"
    },
    xYears: {
      one: "1 an",
      other: "{{count}} ans"
    },
    overXYears: {
      one: "plus d’un an",
      other: "plus de {{count}} ans"
    },
    almostXYears: {
      one: "presqu’un an",
      other: "presque {{count}} ans"
    }
  }, a = function(l, u, i) {
    var d, s = r[l];
    return typeof s == "string" ? d = s : u === 1 ? d = s.one : d = s.other.replace("{{count}}", String(u)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "dans " + d : "il y a " + d : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(en, en.exports);
var Mv = en.exports, tn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, l = {
    full: "{{date}} 'à' {{time}}",
    long: "{{date}} 'à' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(tn, tn.exports);
var wv = tn.exports, rn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "eeee 'dernier à' p",
    yesterday: "'hier à' p",
    today: "'aujourd’hui à' p",
    tomorrow: "'demain à' p'",
    nextWeek: "eeee 'prochain à' p",
    other: "P"
  }, a = function(l, u, i, d) {
    return r[l];
  }, n = a;
  e.default = n, t.exports = e.default;
})(rn, rn.exports);
var _v = rn.exports, an = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = {
    narrow: ["av. J.-C", "ap. J.-C"],
    abbreviated: ["av. J.-C", "ap. J.-C"],
    wide: ["avant Jésus-Christ", "après Jésus-Christ"]
  }, o = {
    narrow: ["T1", "T2", "T3", "T4"],
    abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
    wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
  }, l = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
    wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
  }, u = {
    narrow: ["D", "L", "M", "M", "J", "V", "S"],
    short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
    abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
    wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
  }, i = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "mat.",
      afternoon: "ap.m.",
      evening: "soir",
      night: "mat."
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "matin",
      afternoon: "après-midi",
      evening: "soir",
      night: "matin"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "du matin",
      afternoon: "de l’après-midi",
      evening: "du soir",
      night: "du matin"
    }
  }, d = function(v, p) {
    var g = Number(v), c = p == null ? void 0 : p.unit;
    if (g === 0)
      return "0";
    var b = ["year", "week", "hour", "minute", "second"], M;
    return g === 1 ? M = c && b.includes(c) ? "ère" : "er" : M = "ème", g + M;
  }, s = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: l,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    })
  }, m = s;
  e.default = m, t.exports = e.default;
})(an, an.exports);
var Ev = an.exports, nn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Xe), n = r(Ve), o = /^(\d+)(ième|ère|ème|er|e)?/i, l = /\d+/i, u = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
  }, i = {
    any: [/^av/i, /^ap/i]
  }, d = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
  }, s = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
  }, y = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
  }, p = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
  }, g = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
  }, c = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^min/i,
      noon: /^mid/i,
      morning: /mat/i,
      afternoon: /ap/i,
      evening: /soir/i,
      night: /nuit/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: l,
      valueCallback: function(f) {
        return parseInt(f);
      }
    }),
    era: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: s,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: g,
      defaultMatchWidth: "any",
      parsePatterns: c,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(nn, nn.exports);
var Pv = nn.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Mv), n = r(wv), o = r(_v), l = r(Ev), u = r(Pv), i = {
    code: "fr",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: l.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(Za, Za.exports);
var xv = Za.exports;
const Ov = /* @__PURE__ */ pe(xv);
var on = { exports: {} }, un = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "meno di un secondo",
      other: "meno di {{count}} secondi"
    },
    xSeconds: {
      one: "un secondo",
      other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
      one: "meno di un minuto",
      other: "meno di {{count}} minuti"
    },
    xMinutes: {
      one: "un minuto",
      other: "{{count}} minuti"
    },
    aboutXHours: {
      one: "circa un'ora",
      other: "circa {{count}} ore"
    },
    xHours: {
      one: "un'ora",
      other: "{{count}} ore"
    },
    xDays: {
      one: "un giorno",
      other: "{{count}} giorni"
    },
    aboutXWeeks: {
      one: "circa una settimana",
      other: "circa {{count}} settimane"
    },
    xWeeks: {
      one: "una settimana",
      other: "{{count}} settimane"
    },
    aboutXMonths: {
      one: "circa un mese",
      other: "circa {{count}} mesi"
    },
    xMonths: {
      one: "un mese",
      other: "{{count}} mesi"
    },
    aboutXYears: {
      one: "circa un anno",
      other: "circa {{count}} anni"
    },
    xYears: {
      one: "un anno",
      other: "{{count}} anni"
    },
    overXYears: {
      one: "più di un anno",
      other: "più di {{count}} anni"
    },
    almostXYears: {
      one: "quasi un anno",
      other: "quasi {{count}} anni"
    }
  }, a = function(l, u, i) {
    var d, s = r[l];
    return typeof s == "string" ? d = s : u === 1 ? d = s.one : d = s.other.replace("{{count}}", u.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "tra " + d : d + " fa" : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(un, un.exports);
var Dv = un.exports, ln = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, l = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(ln, ln.exports);
var Sv = ln.exports, dn = { exports: {} }, sn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var a = r(_e), n = r(cr);
  function o(l, u, i) {
    (0, a.default)(2, arguments);
    var d = (0, n.default)(l, i), s = (0, n.default)(u, i);
    return d.getTime() === s.getTime();
  }
  t.exports = e.default;
})(sn, sn.exports);
var Tv = sn.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Tv), n = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
  function o(m) {
    switch (m) {
      case 0:
        return "'domenica scorsa alle' p";
      default:
        return "'" + n[m] + " scorso alle' p";
    }
  }
  function l(m) {
    return "'" + n[m] + " alle' p";
  }
  function u(m) {
    switch (m) {
      case 0:
        return "'domenica prossima alle' p";
      default:
        return "'" + n[m] + " prossimo alle' p";
    }
  }
  var i = {
    lastWeek: function(y, v, p) {
      var g = y.getUTCDay();
      return (0, a.default)(y, v, p) ? l(g) : o(g);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function(y, v, p) {
      var g = y.getUTCDay();
      return (0, a.default)(y, v, p) ? l(g) : u(g);
    },
    other: "P"
  }, d = function(y, v, p, g) {
    var c = i[y];
    return typeof c == "function" ? c(v, p, g) : c;
  }, s = d;
  e.default = s, t.exports = e.default;
})(dn, dn.exports);
var Cv = dn.exports, fn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["avanti Cristo", "dopo Cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, l = {
    narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
    abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
    wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
  }, u = {
    narrow: ["D", "L", "M", "M", "G", "V", "S"],
    short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
  }, i = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    }
  }, d = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    }
  }, s = function(p, g) {
    var c = Number(p);
    return String(c);
  }, m = {
    ordinalNumber: s,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(p) {
        return p - 1;
      }
    }),
    month: (0, a.default)({
      values: l,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: d,
      defaultFormattingWidth: "wide"
    })
  }, y = m;
  e.default = y, t.exports = e.default;
})(fn, fn.exports);
var kv = fn.exports, cn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Xe), n = r(Ve), o = /^(\d+)(º)?/i, l = /\d+/i, u = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
  }, i = {
    any: [/^a/i, /^(d|e)/i]
  }, d = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, s = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
  }, y = {
    narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
  }, p = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
    any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
  }, g = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
  }, c = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mezza/i,
      noon: /^mezzo/i,
      morning: /mattina/i,
      afternoon: /pomeriggio/i,
      evening: /sera/i,
      night: /notte/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: l,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: s,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: g,
      defaultMatchWidth: "any",
      parsePatterns: c,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(cn, cn.exports);
var Rv = cn.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Dv), n = r(Sv), o = r(Cv), l = r(kv), u = r(Rv), i = {
    code: "it",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: l.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(on, on.exports);
var jv = on.exports;
const Av = /* @__PURE__ */ pe(jv);
var vn = { exports: {} }, mn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "minder dan een seconde",
      other: "minder dan {{count}} seconden"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
      one: "minder dan een minuut",
      other: "minder dan {{count}} minuten"
    },
    xMinutes: {
      one: "een minuut",
      other: "{{count}} minuten"
    },
    aboutXHours: {
      one: "ongeveer 1 uur",
      other: "ongeveer {{count}} uur"
    },
    xHours: {
      one: "1 uur",
      other: "{{count}} uur"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dagen"
    },
    aboutXWeeks: {
      one: "ongeveer 1 week",
      other: "ongeveer {{count}} weken"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weken"
    },
    aboutXMonths: {
      one: "ongeveer 1 maand",
      other: "ongeveer {{count}} maanden"
    },
    xMonths: {
      one: "1 maand",
      other: "{{count}} maanden"
    },
    aboutXYears: {
      one: "ongeveer 1 jaar",
      other: "ongeveer {{count}} jaar"
    },
    xYears: {
      one: "1 jaar",
      other: "{{count}} jaar"
    },
    overXYears: {
      one: "meer dan 1 jaar",
      other: "meer dan {{count}} jaar"
    },
    almostXYears: {
      one: "bijna 1 jaar",
      other: "bijna {{count}} jaar"
    }
  }, a = function(l, u, i) {
    var d, s = r[l];
    return typeof s == "string" ? d = s : u === 1 ? d = s.one : d = s.other.replace("{{count}}", String(u)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "over " + d : d + " geleden" : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(mn, mn.exports);
var Wv = mn.exports, hn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, l = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(hn, hn.exports);
var Iv = hn.exports, pn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
  }, a = function(l, u, i, d) {
    return r[l];
  }, n = a;
  e.default = n, t.exports = e.default;
})(pn, pn.exports);
var Nv = pn.exports, bn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = {
    narrow: ["v.C.", "n.C."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["voor Christus", "na Christus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["K1", "K2", "K3", "K4"],
    wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
  }, l = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
  }, u = {
    narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
    short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
    wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
  }, i = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    }
  }, d = function(v, p) {
    var g = Number(v);
    return g + "e";
  }, s = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: l,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    })
  }, m = s;
  e.default = m, t.exports = e.default;
})(bn, bn.exports);
var Fv = bn.exports, gn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Xe), n = r(Ve), o = /^(\d+)e?/i, l = /\d+/i, u = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
  }, i = {
    any: [/^v/, /^n/]
  }, d = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
  }, s = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
  }, y = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
  }, v = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
  }, p = {
    narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
    any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
  }, g = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
  }, c = {
    any: {
      am: /^am/i,
      pm: /^pm/i,
      midnight: /^middernacht/i,
      noon: /^het middaguur/i,
      morning: /ochtend/i,
      afternoon: /middag/i,
      evening: /avond/i,
      night: /nacht/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: l,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: s,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: g,
      defaultMatchWidth: "any",
      parsePatterns: c,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(gn, gn.exports);
var Lv = gn.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Wv), n = r(Iv), o = r(Nv), l = r(Fv), u = r(Lv), i = {
    code: "nl",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: l.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(vn, vn.exports);
var Hv = vn.exports;
const $v = /* @__PURE__ */ pe(Hv);
var yn = { exports: {} }, Mn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "aproximadamente 1 hora",
      other: "aproximadamente {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "aproximadamente 1 semana",
      other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "aproximadamente 1 mês",
      other: "aproximadamente {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "aproximadamente 1 ano",
      other: "aproximadamente {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, a = function(l, u, i) {
    var d, s = r[l];
    return typeof s == "string" ? d = s : u === 1 ? d = s.one : d = s.other.replace("{{count}}", String(u)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "daqui a " + d : "há " + d : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Mn, Mn.exports);
var zv = Mn.exports, wn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, l = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(wn, wn.exports);
var Uv = wn.exports, _n = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: function(l) {
      var u = l.getUTCDay(), i = u === 0 || u === 6 ? "último" : "última";
      return "'" + i + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, a = function(l, u, i, d) {
    var s = r[l];
    return typeof s == "function" ? s(u) : s;
  }, n = a;
  e.default = n, t.exports = e.default;
})(_n, _n.exports);
var Yv = _n.exports, En = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["antes de Cristo", "depois de Cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, l = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, u = {
    narrow: ["d", "s", "t", "q", "q", "s", "s"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, i = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    }
  }, d = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    }
  }, s = function(p, g) {
    var c = Number(p);
    return c + "º";
  }, m = {
    ordinalNumber: s,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(p) {
        return p - 1;
      }
    }),
    month: (0, a.default)({
      values: l,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: d,
      defaultFormattingWidth: "wide"
    })
  }, y = m;
  e.default = y, t.exports = e.default;
})(En, En.exports);
var Bv = En.exports, Pn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Xe), n = r(Ve), o = /^(\d+)(º|ª)?/i, l = /\d+/i, u = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
  }, i = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
  }, d = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
  }, s = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, y = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
  }, p = {
    narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
  }, g = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
  }, c = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^meia/i,
      noon: /^meio/i,
      morning: /manh[ãa]/i,
      afternoon: /tarde/i,
      evening: /noite/i,
      night: /madrugada/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: l,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: s,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: g,
      defaultMatchWidth: "any",
      parsePatterns: c,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(Pn, Pn.exports);
var qv = Pn.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(zv), n = r(Uv), o = r(Yv), l = r(Bv), u = r(qv), i = {
    code: "pt",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: l.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(yn, yn.exports);
var Kv = yn.exports;
const Xv = /* @__PURE__ */ pe(Kv);
var xn = { exports: {} }, On = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "cerca de 1 hora",
      other: "cerca de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "cerca de 1 semana",
      other: "cerca de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "cerca de 1 mês",
      other: "cerca de {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "cerca de 1 ano",
      other: "cerca de {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, a = function(l, u, i) {
    var d, s = r[l];
    return typeof s == "string" ? d = s : u === 1 ? d = s.one : d = s.other.replace("{{count}}", String(u)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "em " + d : "há " + d : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(On, On.exports);
var Vv = On.exports, Dn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, l = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(Dn, Dn.exports);
var Qv = Dn.exports, Sn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: function(l) {
      var u = l.getUTCDay(), i = u === 0 || u === 6 ? "último" : "última";
      return "'" + i + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, a = function(l, u, i, d) {
    var s = r[l];
    return typeof s == "function" ? s(u) : s;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Sn, Sn.exports);
var Gv = Sn.exports, Tn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "depois de cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, l = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, u = {
    narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
    abbreviated: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    }
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    }
  }, s = function(p, g) {
    var c = Number(p);
    return (g == null ? void 0 : g.unit) === "week" ? c + "ª" : c + "º";
  }, m = {
    ordinalNumber: s,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(p) {
        return p - 1;
      }
    }),
    month: (0, a.default)({
      values: l,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: d,
      defaultFormattingWidth: "wide"
    })
  }, y = m;
  e.default = y, t.exports = e.default;
})(Tn, Tn.exports);
var Jv = Tn.exports, Cn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Xe), n = r(Ve), o = /^(\d+)[ºªo]?/i, l = /\d+/i, u = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
  }, i = {
    any: [/^ac/i, /^dc/i],
    wide: [/^antes de cristo/i, /^depois de cristo/i]
  }, d = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, s = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, y = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
  }, v = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
  }, p = {
    short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
  }, g = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
  }, c = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn|^meia[-\s]noite/i,
      noon: /^md|^meio[-\s]dia/i,
      morning: /manhã/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noite/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: l,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: s,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: g,
      defaultMatchWidth: "any",
      parsePatterns: c,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(Cn, Cn.exports);
var Zv = Cn.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Vv), n = r(Qv), o = r(Gv), l = r(Jv), u = r(Zv), i = {
    code: "pt-BR",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: l.default,
    match: u.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(xn, xn.exports);
var em = xn.exports;
const tm = /* @__PURE__ */ pe(em);
var kn = { exports: {} }, Rn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "mindre än en sekund",
      other: "mindre än {{count}} sekunder"
    },
    xSeconds: {
      one: "en sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
      one: "mindre än en minut",
      other: "mindre än {{count}} minuter"
    },
    xMinutes: {
      one: "en minut",
      other: "{{count}} minuter"
    },
    aboutXHours: {
      one: "ungefär en timme",
      other: "ungefär {{count}} timmar"
    },
    xHours: {
      one: "en timme",
      other: "{{count}} timmar"
    },
    xDays: {
      one: "en dag",
      other: "{{count}} dagar"
    },
    aboutXWeeks: {
      one: "ungefär en vecka",
      other: "ungefär {{count}} vecka"
    },
    xWeeks: {
      one: "en vecka",
      other: "{{count}} vecka"
    },
    aboutXMonths: {
      one: "ungefär en månad",
      other: "ungefär {{count}} månader"
    },
    xMonths: {
      one: "en månad",
      other: "{{count}} månader"
    },
    aboutXYears: {
      one: "ungefär ett år",
      other: "ungefär {{count}} år"
    },
    xYears: {
      one: "ett år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "över ett år",
      other: "över {{count}} år"
    },
    almostXYears: {
      one: "nästan ett år",
      other: "nästan {{count}} år"
    }
  }, a = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], n = function(u, i, d) {
    var s, m = r[u];
    return typeof m == "string" ? s = m : i === 1 ? s = m.one : d && d.onlyNumeric ? s = m.other.replace("{{count}}", String(i)) : s = m.other.replace("{{count}}", i < 13 ? a[i] : String(i)), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "om " + s : s + " sedan" : s;
  }, o = n;
  e.default = o, t.exports = e.default;
})(Rn, Rn.exports);
var rm = Rn.exports, jn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ee), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
  }, o = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, l = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, u = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, i = u;
  e.default = i, t.exports = e.default;
})(jn, jn.exports);
var am = jn.exports, An = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'igår kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
  }, a = function(l, u, i, d) {
    return r[l];
  }, n = a;
  e.default = n, t.exports = e.default;
})(An, An.exports);
var nm = An.exports, Wn = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = {
    narrow: ["f.Kr.", "e.Kr."],
    abbreviated: ["f.Kr.", "e.Kr."],
    wide: ["före Kristus", "efter Kristus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
  }, l = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
  }, u = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
    abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
    wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
  }, i = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "morg.",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    abbreviated: {
      am: "f.m.",
      pm: "e.m.",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    wide: {
      am: "förmiddag",
      pm: "eftermiddag",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "eftermiddag",
      evening: "kväll",
      night: "natt"
    }
  }, d = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    abbreviated: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    wide: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morgonen",
      afternoon: "på eftermiddagen",
      evening: "på kvällen",
      night: "på natten"
    }
  }, s = function(p, g) {
    var c = Number(p), b = c % 100;
    if (b > 20 || b < 10)
      switch (b % 10) {
        case 1:
        case 2:
          return c + ":a";
      }
    return c + ":e";
  }, m = {
    ordinalNumber: s,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(p) {
        return p - 1;
      }
    }),
    month: (0, a.default)({
      values: l,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: d,
      defaultFormattingWidth: "wide"
    })
  }, y = m;
  e.default = y, t.exports = e.default;
})(Wn, Wn.exports);
var im = Wn.exports, In = { exports: {} };
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Xe), n = r(Ve), o = /^(\d+)(:a|:e)?/i, l = /\d+/i, u = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
  }, i = {
    any: [/^f/i, /^[ev]/i]
  }, d = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
  }, s = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
  }, y = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
  }, p = {
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, g = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
  }, c = {
    any: {
      am: /^f/i,
      pm: /^e/i,
      midnight: /^midn/i,
      noon: /^midd/i,
      morning: /morgon/i,
      afternoon: /eftermiddag/i,
      evening: /kväll/i,
      night: /natt/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: l,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: s,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: g,
      defaultMatchWidth: "any",
      parsePatterns: c,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(In, In.exports);
var om = In.exports;
(function(t, e) {
  var r = I.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(rm), n = r(am), o = r(nm), l = r(im), u = r(om), i = {
    code: "sv",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: l.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, d = i;
  e.default = d, t.exports = e.default;
})(kn, kn.exports);
var um = kn.exports;
const lm = /* @__PURE__ */ pe(um), ce = {
  da: Hc,
  de: Kc,
  enAU: Qc,
  enCA: ev,
  enGB: av,
  enIN: ov,
  enNZ: dv,
  enUS: Zf,
  enZA: cv,
  es: yv,
  fr: Ov,
  it: Av,
  nl: $v,
  pt: Xv,
  ptBR: tm,
  sv: lm
}, tt = {
  AU: {
    countryCode: "AU",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: ce.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-AU",
    name: "AU"
  },
  BR: {
    countryCode: "BR",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "HH:mm a",
        timeDateFull: "d 'de' MMM yyyy, HH:mm",
        timeDateShort: "d 'de' MMM, HH:mm",
        timeDayDateShort: "EEE, d 'de' MMM, HH:mm"
      },
      locale: ce.ptBR,
      timezone: "America/Sao_Paulo",
      today: "Hoje"
    },
    locale: "pt-BR",
    name: "BR"
  },
  CA: {
    countryCode: "CA",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm a",
        timeDateFull: "MMMM d, yyyy, h:mm a",
        timeDateShort: "MMM d, h:mm a",
        timeDayDateShort: "EEE, MMM d, h:mm a"
      },
      locale: ce.enCA,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-CA",
    name: "CA"
  },
  CO: {
    countryCode: "CO",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.es,
      timezone: "America/Bogota",
      today: "Hoy"
    },
    locale: "es-CO",
    name: "CO"
  },
  CX: {
    countryCode: "CX",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: ce.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-CX",
    name: "CX"
  },
  DE: {
    countryCode: "DE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE, d. MMM, HH:mm"
      },
      locale: ce.de,
      timezone: "Europe/Berlin",
      today: "Heute"
    },
    locale: "de-DE",
    name: "DE"
  },
  DK: {
    countryCode: "DK",
    dateProperties: {
      format: {
        dateFull: "EEEE 'den' d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE 'den' d. MMM, HH:mm"
      },
      locale: ce.da,
      timezone: "Europe/Copenhagen",
      today: "I dag"
    },
    locale: "da-DK",
    name: "DK"
  },
  ES: {
    countryCode: "ES",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.es,
      timezone: "Europe/Madrid",
      today: "Hoy"
    },
    locale: "es-ES",
    name: "ES"
  },
  FR: {
    countryCode: "FR",
    dateProperties: {
      format: {
        dateFull: "EEEE d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.fr,
      timezone: "Europe/Paris",
      today: "Aujourd'hui"
    },
    locale: "fr-FR",
    name: "FR"
  },
  GZ: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "GZ"
  },
  IN: {
    countryCode: "IN",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enIN,
      timezone: "Asia/Kolkata",
      today: "Today"
    },
    locale: "en-IN",
    name: "IN"
  },
  IT: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "IT"
  },
  KE: {
    countryCode: "KE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enGB,
      timezone: "Africa/Nairobi",
      today: "Today"
    },
    locale: "en-KE",
    name: "KE"
  },
  NG: {
    countryCode: "NG",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enGB,
      timezone: "Africa/Lagos",
      today: "Today"
    },
    locale: "en-NG",
    name: "NG"
  },
  NL: {
    countryCode: "NL",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.nl,
      timezone: "Europe/Amsterdam",
      today: "Vandaag"
    },
    locale: "nl-NL",
    name: "NL"
  },
  NZ: {
    countryCode: "NZ",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enNZ,
      timezone: "Pacific/Auckland",
      today: "Today"
    },
    locale: "en-NZ",
    name: "NZ"
  },
  OC: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: ce.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "OC"
  },
  PT: {
    countryCode: "PT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.pt,
      timezone: "Europe/Lisbon",
      today: "Hoje"
    },
    locale: "pt-PT",
    name: "PT"
  },
  SE: {
    countryCode: "SE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.sv,
      timezone: "Europe/Stockholm",
      today: "Idag"
    },
    locale: "sv-SE",
    name: "SE"
  },
  SM: {
    countryCode: "SM",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.it,
      timezone: "Europe/San_Marino",
      today: "Oggi"
    },
    locale: "it-SM",
    name: "SM"
  },
  US: {
    countryCode: "US",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm aa zzz",
        timeDateFull: "MMMM d, yyyy, h:mm aa zzz",
        timeDateShort: "MM/dd h:mm aa",
        timeDayDateShort: "EEE MMM d, h:mm aa zzz"
      },
      locale: ce.enUS,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-US",
    name: "US"
  },
  WS: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: ce.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "WS"
  },
  XX: {
    countryCode: "XX",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enUS,
      // Placeholder locale
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "xx-XX",
    name: "XX"
  },
  ZA: {
    countryCode: "ZA",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enZA,
      timezone: "Africa/Johannesburg",
      today: "Today"
    },
    locale: "en-ZA",
    name: "ZA"
  }
}, dm = [tt.IT.name, tt.ES.name, tt.BR.name], wu = [
  { id: 18, name: "AMERICAN FOOTBALL", translationFile: "american_football" },
  { id: 11, name: "ATHLETICS", translationFile: "athletics" },
  { id: 23, name: "AUSSIE RULES", translationFile: "aussie_rules" },
  { id: 32, name: "BADMINTON", translationFile: "badminton" },
  { id: 48, name: "BANDY", translationFile: "bandy" },
  { id: 46, name: "BASEBALL", translationFile: "baseball" },
  { id: 47, name: "BASKETBALL", translationFile: "basketball" },
  { id: 28, name: "BETTYPE", translationFile: "bettype" },
  { id: 31, name: "BOWLS", translationFile: "bowls" },
  { id: 10, name: "BOXING", translationFile: "boxing" },
  { id: 76, name: "CASINO", translationFile: "casino" },
  { id: 19, name: "CRICKET", translationFile: "cricket" },
  { id: 14, name: "CYCLING", translationFile: "cycling" },
  { id: 21, name: "DARTS", translationFile: "dart" },
  { id: 49, name: "DUMMY", translationFile: "dummy" },
  { id: 33, name: "EQUESTRIAN", translationFile: "equestrian" },
  { id: 34, name: "FINANCIAL", translationFile: "financial" },
  { id: 29, name: "FLOORBALL", translationFile: "floorball" },
  { id: 2, name: "FOOTBALL", translationFile: "football" },
  { id: 24, name: "GAELIC SPORTS", translationFile: "gaelic_sports" },
  { id: 6, name: "GOLF", translationFile: "golf" },
  { id: 5, name: "GREYHOUNDS", translationFile: "greyhounds" },
  { id: 35, name: "HANDBALL", translationFile: "handball" },
  { id: 74, name: "HARNESS RACING", translationFile: "harness_racing" },
  { id: 36, name: "HOCKEY", translationFile: "hockey" },
  { id: 3, name: "HORSE RACING", translationFile: "horse_racing" },
  { id: 45, name: "ICE HOCKEY", translationFile: "ice_hockey" },
  { id: 0, name: "LABEL", translationFile: "label" },
  { id: 27, name: "MENU", translationFile: "menu" },
  { id: 17, name: "MOTOR SPORT", translationFile: "motor_sport" },
  { id: 37, name: "NETBALL", translationFile: "netball" },
  { id: 62, name: "OLYMPICS", translationFile: "olympics" },
  { id: 26, name: "OTHER SPORTS", translationFile: "other_sports" },
  { id: 25, name: "POKER", translationFile: "poker" },
  { id: 68, name: "POLITICS", translationFile: "politics" },
  { id: 20, name: "POOL", translationFile: "pool" },
  { id: 22, name: "ROWING", translationFile: "rowing" },
  { id: 30, name: "RUGBY LEAGUE", translationFile: "rugby_league" },
  { id: 9, name: "RUGBY UNION", translationFile: "rugby_union" },
  { id: 8, name: "SNOOKER", translationFile: "snooker" },
  { id: 15, name: "SPECIALS", translationFile: "specials" },
  { id: 38, name: "SWIMMING", translationFile: "swimming" },
  { id: 39, name: "TABLE TENNIS", translationFile: "table_tennis" },
  { id: 7, name: "TENNIS", translationFile: "tennis" },
  { id: 40, name: "TROTTING", translationFile: "trotting" },
  { id: 71, name: "TV", translationFile: "tv" },
  { id: 61, name: "VIRTUAL FOOTBALL", translationFile: "virtual_football" },
  { id: 58, name: "VIRTUAL MOTORSPORT", translationFile: "virtual_motorsport" },
  { id: 41, name: "VOLLEYBALL", translationFile: "volleyball" },
  { id: 42, name: "WATER POLO", translationFile: "water_polo" },
  { id: 43, name: "WINTER SPORTS", translationFile: "winter_sports" },
  { id: 44, name: "YACHTING", translationFile: "yachting" }
], sm = (t) => {
  var e;
  return (e = wu.find((r) => r.id === t)) == null ? void 0 : e.translationFile;
};
/*! js-cookie v3.0.5 | MIT */
function rr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var a in r)
      t[a] = r[a];
  }
  return t;
}
var fm = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Nn(t, e) {
  function r(n, o, l) {
    if (!(typeof document > "u")) {
      l = rr({}, e, l), typeof l.expires == "number" && (l.expires = new Date(Date.now() + l.expires * 864e5)), l.expires && (l.expires = l.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var u = "";
      for (var i in l)
        l[i] && (u += "; " + i, l[i] !== !0 && (u += "=" + l[i].split(";")[0]));
      return document.cookie = n + "=" + t.write(o, n) + u;
    }
  }
  function a(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], l = {}, u = 0; u < o.length; u++) {
        var i = o[u].split("="), d = i.slice(1).join("=");
        try {
          var s = decodeURIComponent(i[0]);
          if (l[s] = t.read(d, s), n === s)
            break;
        } catch {
        }
      }
      return n ? l[n] : l;
    }
  }
  return Object.create(
    {
      set: r,
      get: a,
      remove: function(n, o) {
        r(
          n,
          "",
          rr({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return Nn(this.converter, rr({}, this.attributes, n));
      },
      withConverter: function(n) {
        return Nn(rr({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
Nn(fm, { path: "/" });
it({});
const cm = () => `${typeof window < "u" ? window.location.origin : ""}/api/cx/sports-catalogue`;
function Zi(t) {
  const e = [" v ", " at "];
  for (const r of e) {
    const a = t.split(r);
    if (a.length === 2) {
      const [n, o] = a.map((l) => l.trim());
      return r === " v " ? { away: o, first: n, home: n, second: o, separator: r, success: !0 } : { away: n, first: n, home: o, second: o, separator: r, success: !0 };
    }
  }
  return {
    away: "",
    first: "",
    home: "",
    second: "",
    separator: "",
    success: !1
  };
}
const vm = [
  // GTM/Google Debug
  "gtm_debug",
  "debug",
  // Cache bypass
  "nocache",
  // Google Ads/Analytics
  "gclid",
  "gclsrc",
  "_gl",
  // UTM Campaign Tracking
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id"
];
function _u(t, e) {
  if (!e && typeof window > "u")
    return t;
  try {
    const r = new URL(e || window.location.href), a = new URLSearchParams(r.search), n = [];
    for (const u of vm) {
      const i = a.get(u);
      i !== null && n.push([u, i]);
    }
    if (n.length === 0)
      return t;
    const o = t.startsWith("http://") || t.startsWith("https://"), l = o ? new URL(t) : new URL(t, r.origin);
    for (const [u, i] of n)
      l.searchParams.has(u) || l.searchParams.set(u, i);
    return o ? l.toString() : l.pathname + l.search + l.hash;
  } catch {
    return t;
  }
}
const mm = "application/json", Eu = "Content-Type", Mt = Symbol(), Pu = Symbol();
function eo(t = {}) {
  var e;
  const r = t instanceof Array ? Object.fromEntries(t) : t;
  return (e = Object.entries(r).find(([a]) => a.toLowerCase() === Eu.toLowerCase())) === null || e === void 0 ? void 0 : e[1];
}
function to(t) {
  return /^application\/.*json.*/.test(t);
}
const ft = function(t, e, r = !1) {
  return Object.entries(e).reduce((a, [n, o]) => {
    const l = t[n];
    return Array.isArray(l) && Array.isArray(o) ? a[n] = r ? [...l, ...o] : o : typeof l == "object" && typeof o == "object" ? a[n] = ft(l, o, r) : a[n] = o, a;
  }, { ...t });
}, Tt = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(t, e = !0, r = !1, ...a) {
    const n = this.polyfills[t] || (typeof self < "u" ? self[t] : null) || (typeof global < "u" ? global[t] : null);
    if (e && !n)
      throw new Error(t + " is not defined");
    return r && n ? new n(...a) : n;
  }
};
function hm(t, e = !1) {
  Tt.options = e ? t : ft(Tt.options, t);
}
function pm(t, e = !1) {
  Tt.polyfills = e ? t : ft(Tt.polyfills, t);
}
function bm(t) {
  Tt.errorType = t;
}
const gm = (t) => (e) => t.reduceRight((r, a) => a(r), e) || e;
class xu extends Error {
}
const ym = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  t = t._addons.reduce((h, f) => f.beforeRequest && f.beforeRequest(h, t._options, e) || h, t);
  const { _url: r, _options: a, _config: n, _catchers: o, _resolvers: l, _middlewares: u, _addons: i } = t, d = new Map(o), s = ft(n.options, a);
  let m = r;
  const y = gm(u)((h, f) => (m = h, n.polyfill("fetch")(h, f)))(r, s), v = new Error(), p = y.catch((h) => {
    throw { [Mt]: h };
  }).then((h) => {
    var f;
    if (!h.ok) {
      const w = new xu();
      if (w.cause = v, w.stack = w.stack + `
CAUSE: ` + v.stack, w.response = h, w.status = h.status, w.url = m, h.type === "opaque")
        throw w;
      const _ = n.errorType === "json" || ((f = h.headers.get("Content-Type")) === null || f === void 0 ? void 0 : f.split(";")[0]) === "application/json";
      return (n.errorType ? _ ? h.text() : h[n.errorType]() : Promise.resolve(h.body)).then((T) => {
        throw w.message = typeof T == "string" ? T : h.statusText, T && (_ && typeof T == "string" ? (w.text = T, w.json = JSON.parse(T)) : w[n.errorType] = T), w;
      });
    }
    return h;
  }), g = (h) => h.catch((f) => {
    const w = Object.prototype.hasOwnProperty.call(f, Mt), _ = w ? f[Mt] : f, x = (_ == null ? void 0 : _.status) && d.get(_.status) || d.get(_ == null ? void 0 : _.name) || w && d.has(Mt) && d.get(Mt);
    if (x)
      return x(_, t);
    const T = d.get(Pu);
    if (T)
      return T(_, t);
    throw _;
  }), c = (h) => (f) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ g(h ? p.then((w) => w && w[h]()).then((w) => f ? f(w) : w) : p.then((w) => f ? f(w) : w)), b = {
    _wretchReq: t,
    _fetchReq: y,
    _sharedState: e,
    res: c(null),
    json: c("json"),
    blob: c("blob"),
    formData: c("formData"),
    arrayBuffer: c("arrayBuffer"),
    text: c("text"),
    error(h, f) {
      return d.set(h, f), this;
    },
    badRequest(h) {
      return this.error(400, h);
    },
    unauthorized(h) {
      return this.error(401, h);
    },
    forbidden(h) {
      return this.error(403, h);
    },
    notFound(h) {
      return this.error(404, h);
    },
    timeout(h) {
      return this.error(408, h);
    },
    internalError(h) {
      return this.error(500, h);
    },
    fetchError(h) {
      return this.error(Mt, h);
    }
  }, M = i.reduce((h, f) => ({
    ...h,
    ...typeof f.resolver == "function" ? f.resolver(h) : f.resolver
  }), b);
  return l.reduce((h, f) => f(h, t), M);
}, Mm = {
  _url: "",
  _options: {},
  _config: Tt,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(t) {
    return { ...this, _addons: [...this._addons, t], ...t.wretch };
  },
  errorType(t) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: t
      }
    };
  },
  polyfills(t, e = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: e ? t : ft(this._config.polyfills, t)
      }
    };
  },
  url(t, e = !1) {
    if (e)
      return { ...this, _url: t };
    const r = this._url.split("?");
    return {
      ...this,
      _url: r.length > 1 ? r[0] + t + "?" + r[1] : this._url + t
    };
  },
  options(t, e = !1) {
    return { ...this, _options: e ? t : ft(this._options, t) };
  },
  headers(t) {
    const e = t ? Array.isArray(t) ? Object.fromEntries(t) : "entries" in t ? Object.fromEntries(t.entries()) : t : {};
    return { ...this, _options: ft(this._options, { headers: e }) };
  },
  accept(t) {
    return this.headers({ Accept: t });
  },
  content(t) {
    return this.headers({ [Eu]: t });
  },
  auth(t) {
    return this.headers({ Authorization: t });
  },
  catcher(t, e) {
    const r = new Map(this._catchers);
    return r.set(t, e), { ...this, _catchers: r };
  },
  catcherFallback(t) {
    return this.catcher(Pu, t);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(t, e = !1) {
    return { ...this, _resolvers: e ? [t] : [...this._resolvers, t] };
  },
  defer(t, e = !1) {
    return {
      ...this,
      _deferred: e ? [t] : [...this._deferred, t]
    };
  },
  middlewares(t, e = !1) {
    return {
      ...this,
      _middlewares: e ? t : [...this._middlewares, ...t]
    };
  },
  fetch(t = this._options.method, e = "", r = null) {
    let a = this.url(e).options({ method: t });
    const n = eo(a._options.headers), o = this._config.polyfill("FormData", !1), l = typeof r == "object" && !(o && r instanceof o) && (!a._options.headers || !n || to(n));
    return a = r ? l ? a.json(r, n) : a.body(r) : a, ym(a._deferred.reduce((u, i) => i(u, u._url, u._options), a));
  },
  get(t = "") {
    return this.fetch("GET", t);
  },
  delete(t = "") {
    return this.fetch("DELETE", t);
  },
  put(t, e = "") {
    return this.fetch("PUT", e, t);
  },
  post(t, e = "") {
    return this.fetch("POST", e, t);
  },
  patch(t, e = "") {
    return this.fetch("PATCH", e, t);
  },
  head(t = "") {
    return this.fetch("HEAD", t);
  },
  opts(t = "") {
    return this.fetch("OPTIONS", t);
  },
  body(t) {
    return { ...this, _options: { ...this._options, body: t } };
  },
  json(t, e) {
    const r = eo(this._options.headers);
    return this.content(e || to(r) && r || mm).body(JSON.stringify(t));
  }
};
function Ze(t = "", e = {}) {
  return { ...Mm, _url: t, _options: e };
}
Ze.default = Ze;
Ze.options = hm;
Ze.errorType = bm;
Ze.polyfills = pm;
Ze.WretchError = xu;
class wm extends Error {
  constructor(r, a, n, o, l) {
    super(r);
    Qe(this, "statusCode");
    Qe(this, "endpoint");
    Qe(this, "args");
    Qe(this, "response");
    this.name = "ApiError", this.statusCode = a, this.endpoint = n, this.args = o, this.response = l;
  }
}
class ai extends wm {
  constructor(e, r, a, n) {
    super(`Client error ${e} occurred while fetching ${r}`, e, r, a, n), this.name = "Api4xxError";
  }
}
class _m extends ai {
  constructor(e, r, a) {
    super(404, e, r, a), this.name = "Api404Error";
  }
}
class Em extends ai {
  constructor(e, r, a) {
    super(400, e, r, a), this.name = "Api400Error";
  }
}
class Pm {
  constructor(e = {}) {
    Qe(this, "logger");
    Qe(this, "notFoundLogLevel");
    Qe(this, "badRequestLogLevel");
    Qe(this, "other4xxLogLevel");
    this.logger = e.logger, this.notFoundLogLevel = e.notFoundLogLevel || "info", this.badRequestLogLevel = e.badRequestLogLevel || "warn", this.other4xxLogLevel = e.other4xxLogLevel || "warn";
  }
  log(e, r, a) {
    this.logger && this.logger[e](r, a);
  }
  async handleApiError(e, r, a) {
    if (!(e instanceof Response))
      throw e;
    const { status: n } = e;
    if (n === 404) {
      const o = new _m(r, a, e);
      return this.log(this.notFoundLogLevel, o.message, {
        args: a,
        endpoint: r,
        statusCode: n
      }), null;
    }
    if (n === 400) {
      const o = new Em(r, a, e);
      return this.log(this.badRequestLogLevel, o.message, {
        args: a,
        endpoint: r,
        statusCode: n
      }), null;
    }
    if (n >= 400 && n < 500) {
      const o = new ai(n, r, a, e);
      return this.log(this.other4xxLogLevel, o.message, {
        args: a,
        endpoint: r,
        statusCode: n
      }), null;
    }
    throw e;
  }
}
const xm = (t, e) => {
  const r = new Pm(e);
  return t.catcher(404, async (a) => (await r.handleApiError(a.response, a.url), null)).catcher(400, async (a) => (await r.handleApiError(a.response, a.url), null)).catcher(401, async (a) => (await r.handleApiError(a.response, a.url), null)).catcher(403, async (a) => (await r.handleApiError(a.response, a.url), null)).catcherFallback(async (a) => {
    if (a.status >= 400 && a.status < 500)
      return await r.handleApiError(a.response, a.url), null;
    throw a;
  });
}, Ou = async (t = cm(), e, r) => {
  const { repub: a, subeventId: n } = e, o = new URL(`${t}/v1/subevent-header/${n}`);
  return xm(
    Ze(o.toString(), {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        repub: a,
        ...(r == null ? void 0 : r.nocache) && { "Cache-Control": "no-cache" }
      }
    }),
    r
  ).get().json();
}, Du = ({ repub: t, subeventId: e }) => [
  "subevent-header",
  t,
  e
], Om = () => /* @__PURE__ */ q(
  "svg",
  {
    fill: "currentColor",
    height: "100%",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 24 24",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ q(
      "path",
      {
        d: "M12 10.545l5.818-5.818c.402-.401 1.053-.401 1.455 0 .401.402.401 1.053 0 1.455L13.455 12l5.818 5.818c.401.402.401 1.053 0 1.455-.402.401-1.053.401-1.455 0L12 13.455l-5.818 5.818c-.402.401-1.053.401-1.455 0-.401-.402-.401-1.053 0-1.455L10.545 12 4.727 6.182c-.401-.402-.401-1.053 0-1.455.402-.401 1.053-.401 1.455 0L12 10.545z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  }
), Dm = "_dropdownPillButton_g7z5b_1", Sm = "_dropdownPillIconWrapper_g7z5b_22", Tm = "_dropdownPanel_g7z5b_31", Cm = "_dropdownTitleWrapper_g7z5b_41", km = "_dropdownTitle_g7z5b_41", Rm = "_dropdownItem_g7z5b_56", jm = "_dropdownItemActive_g7z5b_68", Am = "_dropdownCloseButton_g7z5b_77", Wm = "_dropdownMenuSeparator_g7z5b_84", ze = {
  dropdownPillButton: Dm,
  dropdownPillIconWrapper: Sm,
  dropdownPanel: Tm,
  dropdownTitleWrapper: Cm,
  dropdownTitle: km,
  dropdownItem: Rm,
  dropdownItemActive: jm,
  dropdownCloseButton: Am,
  dropdownMenuSeparator: Wm
}, Su = uo(
  ({ disclosure: t, menu: e, menuItems: r, menuProps: a, title: n, ...o }, l) => {
    const u = () => /* @__PURE__ */ q(bf, { ref: l, ...e, ...o, ...t.props, children: (s) => hr(t, {
      ...s,
      id: "menu-button",
      key: "menu-button"
    }) }), i = /* @__PURE__ */ je(ni, { children: [
      /* @__PURE__ */ je("div", { className: ze.dropdownTitleWrapper, children: [
        /* @__PURE__ */ q("h4", { className: ze.dropdownTitle, "data-testid": "dropdown-title", children: n }),
        /* @__PURE__ */ q("button", { className: ze.dropdownCloseButton, onClick: e.toggle, children: /* @__PURE__ */ q(Om, {}) })
      ] }),
      /* @__PURE__ */ q($i, { className: ze.dropdownMenuSeparator })
    ] }), d = () => /* @__PURE__ */ je(vf, { ...e, ...a, ref: l, children: [
      i,
      r.map((s, m) => s.type === $i ? hr(s, {
        ...e,
        ...s.props,
        id: "menu-separator",
        key: `menu-separator-${m}`
      }) : /* @__PURE__ */ He(xf, { ...e, ...s.props, id: m, key: s.key || m, ref: l }, (y) => hr(s, {
        ...y,
        id: `menu-item-${m}`,
        key: `menu-item-${m}`
      })))
    ] });
    return /* @__PURE__ */ je(ni, { children: [
      u(),
      d()
    ] });
  }
);
Su.displayName = "Dropdown";
const Im = (t) => {
  const e = re(!0);
  oe(() => {
    if (e.current) {
      e.current = !1;
      return;
    }
    t();
  }, [t]);
};
var Nm = typeof Te == "object" && Te && Te.Object === Object && Te, Fm = typeof self == "object" && self && self.Object === Object && self;
Nm || Fm || Function("return this")();
it({
  pageUrl: ""
});
function ro({
  ariaLabel: t,
  baseId: e,
  button: r,
  buttonText: a,
  items: n,
  onClick: o,
  onHide: l,
  onShow: u,
  placement: i,
  renderItem: d,
  title: s
}) {
  const m = Sf({
    baseId: e || void 0,
    gutter: 7,
    placement: i || "bottom"
  }), { visible: y } = m, v = F(() => {
    y && u ? u() : !y && l && l();
  }, [l, u, y]);
  Im(v);
  const p = Le(() => r || /* @__PURE__ */ q("button", { className: ze.dropdownPillButton, children: a }), [r, a]), g = Le(() => n.map((b, M) => {
    const h = M === 0, f = {
      ...h ? {} : { onClick: () => o(b) }
    };
    return (
      // Key is applied by Reakit in <Dropdown /> component so we can
      // ignore here:
      // eslint-disable-next-line react/jsx-key
      /* @__PURE__ */ q(
        "div",
        {
          className: `${ze.dropdownItem}${h ? ` ${ze.dropdownItemActive}` : ""}`,
          ...f,
          "data-testid": "dropdown-item",
          children: d(b, M)
        }
      )
    );
  }), [n, o, d]);
  return /* @__PURE__ */ q(
    Su,
    {
      "data-testid": "dropdown-menu",
      disclosure: p,
      menu: m,
      menuItems: g,
      menuProps: {
        "aria-label": t,
        className: ze.dropdownPanel
      },
      title: s
    }
  );
}
const Or = () => /* @__PURE__ */ q(
  "svg",
  {
    fill: "currentColor",
    height: "100%",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 6 12",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ q(
      "path",
      {
        clipRule: "evenodd",
        d: "M0.409017 6.69364C0.0361104 6.30639 0.0361104 5.6936 0.409017 5.30635L4.4669 1.09239C4.69078 0.859913 5.06296 0.859913 5.28683 1.09239C5.49907 1.31279 5.49907 1.66156 5.28683 1.88196L1.32131 6L5.28683 10.118C5.49907 10.3384 5.49907 10.6872 5.28683 10.9076C5.06296 11.1401 4.69078 11.1401 4.4669 10.9076L0.409017 6.69364Z",
        fillRule: "evenodd"
      }
    )
  }
), Lm = "_subeventHeaderWrapper_d5nb7_1", Hm = "_subeventHeaderInnerWrapper_d5nb7_6", $m = "_breadcrumbIcon_d5nb7_19", zm = "_subeventEventLinkWrapper_d5nb7_27", Um = "_subeventEventLink_d5nb7_27", Ym = "_subeventHeaderContentContainer_d5nb7_61", Bm = "_subeventTitle_d5nb7_79", qm = "_subeventTitleMobileDropdown_d5nb7_89", Km = "_subeventTitleMobile_d5nb7_89", Xm = "_dropdownButtonWrapper_d5nb7_111", Vm = "_dropdownIcon_d5nb7_118", Qm = "_subeventMenuWrapper_d5nb7_127", Gm = "_relatedSubeventContainer_d5nb7_136", Jm = "_relatedSubeventDatetime_d5nb7_142", Zm = "_relatedSubeventNameContainer_d5nb7_151", eh = "_relatedSubeventName_d5nb7_151", th = "_subeventHeaderTextWrapper_d5nb7_168", rh = "_subeventDatetime_d5nb7_190", ah = "_subeventDatetimeWrapper_d5nb7_205", nh = "_offersPresentIcon_d5nb7_216", ih = "_matchStatsNewIcon_d5nb7_223", oh = "_inPlayIcon_d5nb7_231", uh = "_menuDivider_d5nb7_247", lh = "_liveStatsHeaderFallback_d5nb7_259", dh = "_desktopOnly_d5nb7_268", sh = "_mobileOnly_d5nb7_277", me = {
  subeventHeaderWrapper: Lm,
  subeventHeaderInnerWrapper: Hm,
  breadcrumbIcon: $m,
  subeventEventLinkWrapper: zm,
  subeventEventLink: Um,
  subeventHeaderContentContainer: Ym,
  subeventTitle: Bm,
  subeventTitleMobileDropdown: qm,
  subeventTitleMobile: Km,
  dropdownButtonWrapper: Xm,
  dropdownIcon: Vm,
  subeventMenuWrapper: Qm,
  relatedSubeventContainer: Gm,
  relatedSubeventDatetime: Jm,
  relatedSubeventNameContainer: Zm,
  relatedSubeventName: eh,
  subeventHeaderTextWrapper: th,
  "change-match-dropdown": "_change-match-dropdown_d5nb7_1",
  subeventDatetime: rh,
  subeventDatetimeWrapper: ah,
  offersPresentIcon: nh,
  matchStatsNewIcon: ih,
  inPlayIcon: oh,
  menuDivider: uh,
  liveStatsHeaderFallback: lh,
  desktopOnly: dh,
  mobileOnly: sh
}, fh = ({ breadcrumb: t, categoryGroupId: e, eventName: r, requestUrl: a }) => {
  const n = sm(e), { t: o } = ei([n ?? "label"]);
  return /* @__PURE__ */ q(
    "a",
    {
      className: `${me.subeventEventLink} ogm-subevent-header__breadcrumb`,
      "data-testid": "event-name",
      href: _u(t.url, a),
      title: t.name,
      children: o(r, { ns: n })
    }
  );
}, ch = ({ dataApiEndpoint: t, i18n: e, ...r }) => {
  const { data: a } = Xu({
    queryFn: () => Ou(t, r, {
      logger: console
    }),
    queryKey: Du(r)
  }), { dropdownText: n, overrideTitle: o, repub: l, requestUrl: u, timeZone: i } = r, {
    breadcrumbs: d = [],
    eventName: s = "",
    inRunning: m = !1,
    relatedSubevents: y = [],
    subeventName: v = "",
    subeventStartTime: p = ""
  } = a || {}, g = i ?? tt[l].dateProperties.timezone, c = wu.find((L) => L.id === (a == null ? void 0 : a.categoryGroupId)), M = [(c == null ? void 0 : c.translationFile) || "", "label", "bettype"], { t: h } = ei(M), f = F(
    (L) => {
      const U = Zi(L);
      return U.success ? `${h(U.first)}${U.separator}${h(U.second)}`.trim() : h(L);
    },
    [h]
  ), w = Zi(v), _ = e == null ? void 0 : e.exists("CX_SUBEVENT_HEADER_PREFIX", { fallbackLng: [], ns: "label" }), x = w.success && _ ? h("CX_SUBEVENT_HEADER_PREFIX", { ns: "label" }) : "", T = dm.includes(l), O = o && o !== v, P = T ? f(v) : v, D = `${x} ${O ? o : P}`.trim(), S = Le(
    () => [
      {
        subeventName: v,
        subeventStartTime: p,
        subeventUrl: ""
      },
      ...y.map((L) => ({
        subeventName: L.subeventName || L.name,
        subeventStartTime: L.subeventStartTime || L.startTime,
        subeventUrl: L.subeventUrl || L.url
      }))
    ].map((L) => ({
      ...L,
      id: L.subeventName
    })),
    [y, v, p]
  ), N = d[d.length - 2], C = (L) => {
    const U = "subeventUrl" in L ? L.subeventUrl : L.url;
    window.location.href = _u(U);
  }, A = F((L) => {
    document.body.style.overflow = L ? "hidden" : "visible";
  }, []), V = F(() => {
    A(!1);
  }, [A]), Q = F(() => {
    A(!0);
  }, [A]), G = F(
    (L) => L ? Ji(L, g, tt[l].dateProperties.format.timeDateShort, {
      locale: tt[l].dateProperties.locale
    }) : "",
    [g, l]
  ), ue = F(
    (L) => L ? Ji(L, g, tt[l].dateProperties.format.timeDateFull, {
      locale: tt[l].dateProperties.locale
    }) : "",
    [g, l]
  ), ee = Le(
    () => /* @__PURE__ */ je("button", { className: ze.dropdownPillButton, "data-label": n, children: [
      n,
      /* @__PURE__ */ q("span", { className: ze.dropdownPillIconWrapper, children: /* @__PURE__ */ q(Or, {}) })
    ] }),
    [n]
  ), te = Le(
    () => /* @__PURE__ */ je("h1", { className: me.subeventTitleMobile, "data-label": n, children: [
      `${D} `,
      /* @__PURE__ */ q("span", { className: me.dropdownButtonWrapper, children: /* @__PURE__ */ q("span", { className: me.dropdownIcon, children: /* @__PURE__ */ q(Or, {}) }) })
    ] }),
    [D, n]
  ), ve = F(
    (L) => {
      const U = "subeventStartTime" in L ? L.subeventStartTime : L.startTime, J = "subeventName" in L ? L.subeventName : L.name, se = T ? f(J) : J;
      return /* @__PURE__ */ je("div", { className: me.relatedSubeventContainer, children: [
        /* @__PURE__ */ q("span", { className: me.relatedSubeventDatetime, children: G(U) }),
        /* @__PURE__ */ q("div", { className: me.relatedSubeventNameContainer, children: /* @__PURE__ */ q("span", { className: me.relatedSubeventName, children: se }) })
      ] });
    },
    [T, f, G]
  );
  return a ? /* @__PURE__ */ q(lu, { i18nInstance: e, children: /* @__PURE__ */ q(uu, { children: /* @__PURE__ */ q("div", { className: me.subeventHeaderWrapper, "data-testid": "subevent-header", children: /* @__PURE__ */ je("div", { className: me.subeventHeaderInnerWrapper, children: [
    !!N && /* @__PURE__ */ je("div", { className: me.subeventEventLinkWrapper, children: [
      /* @__PURE__ */ q("span", { className: me.breadcrumbIcon, children: /* @__PURE__ */ q(Or, {}) }),
      /* @__PURE__ */ q(
        fh,
        {
          breadcrumb: N,
          categoryGroupId: a.categoryGroupId,
          eventName: s,
          requestUrl: u
        }
      )
    ] }),
    /* @__PURE__ */ q("div", { className: me.subeventBodyWrapper, id: "subevent-header", children: /* @__PURE__ */ je("div", { className: me.subeventHeaderContentContainer, children: [
      /* @__PURE__ */ je("div", { className: `${me.subeventHeaderTextWrapper} ogm-subevent-header__title`, children: [
        /* @__PURE__ */ q("div", { className: me.desktopOnly, children: /* @__PURE__ */ je("h1", { className: me.subeventTitle, "data-testid": "subevent-title", children: [
          D,
          m && /* @__PURE__ */ q("span", { className: me.inPlayIcon, children: h("CX_MATCHES_COUPON_LIVE", { ns: "label" }) })
        ] }) }),
        /* @__PURE__ */ q("div", { className: me.desktopOnly, children: /* @__PURE__ */ q(
          ro,
          {
            ariaLabel: n,
            baseId: "change-match-dropdown-desktop",
            button: ee,
            buttonText: n,
            items: S,
            onClick: C,
            onHide: V,
            onShow: Q,
            placement: "bottom",
            renderItem: ve,
            title: s
          }
        ) }),
        /* @__PURE__ */ q("div", { className: me.mobileOnly, children: /* @__PURE__ */ q(
          ro,
          {
            ariaLabel: n,
            baseId: "change-match-dropdown-mobile",
            button: te,
            buttonText: n,
            items: S,
            onClick: C,
            onHide: V,
            onShow: Q,
            placement: "bottom-start",
            renderItem: ve,
            title: s
          }
        ) })
      ] }),
      /* @__PURE__ */ q("div", { className: me.subeventDatetimeWrapper, children: /* @__PURE__ */ q(
        "time",
        {
          className: me.subeventDatetime,
          "data-testid": "subevent-date",
          dateTime: ue(p),
          children: ue(p)
        }
      ) })
    ] }) })
  ] }) }) }) }) : null;
}, Dr = {
  desktop: 1024,
  desktopLg: 1360,
  desktopMd: 1200,
  phoneLg: 600,
  phoneSm: 320,
  tablet: 768
};
var vh = typeof Te == "object" && Te && Te.Object === Object && Te, mh = typeof self == "object" && self && self.Object === Object && self, hh = vh || mh || Function("return this")(), ao = hh.Symbol, no = ao ? ao.prototype : void 0;
no && no.toString;
var ph = typeof Te == "object" && Te && Te.Object === Object && Te, bh = typeof self == "object" && self && self.Object === Object && self, gh = ph || bh || Function("return this")(), io = gh.Symbol, oo = io ? io.prototype : void 0;
oo && oo.toString;
(function(t) {
  typeof globalThis != "object" && (this ? e() : (t.defineProperty(t.prototype, "_T_", {
    configurable: !0,
    get: e
  }), _T_));
  function e() {
    var r = this || self;
    r.globalThis = r, delete t.prototype._T_;
  }
})(Object);
const yh = (t, e) => e.skipDedupe || e.method !== "GET", Mh = (t, e) => e.method + "@" + t, wh = (t) => t.clone(), Tu = ({ skip: t = yh, key: e = Mh, resolver: r = wh } = {}) => {
  const a = /* @__PURE__ */ new Map();
  return (n) => (o, l) => {
    if (t(o, l))
      return n(o, l);
    const u = e(o, l);
    if (!a.has(u))
      a.set(u, []);
    else
      return new Promise((i, d) => {
        a.get(u).push([i, d]);
      });
    try {
      return n(o, l).then((i) => (a.get(u).forEach(([d]) => d(r(i))), a.delete(u), i)).catch((i) => {
        throw a.get(u).forEach(([, d]) => d(i)), a.delete(u), i;
      });
    } catch (i) {
      return a.delete(u), Promise.reject(i);
    }
  };
}, _h = (t, e) => e.skipCache || e.method !== "GET", Eh = (t, e) => e.method + "@" + t, Ph = () => !1, xh = () => null, Oh = (t) => t.ok, Dh = ({ throttle: t = 1e3, skip: e = _h, key: r = Eh, clear: a = Ph, invalidate: n = xh, condition: o = Oh, flagResponseOnCacheHit: l = "__cached" } = {}) => {
  const u = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Set(), s = (y) => {
    t && !d.has(y) && (d.add(y), setTimeout(() => {
      d.delete(y);
    }, t));
  }, m = (y) => (v, p) => {
    const g = r(v, p);
    let c = n(v, p);
    if (c && (c instanceof Array || (c = [c]), c.forEach((b) => {
      typeof b == "string" ? u.delete(b) : b instanceof RegExp && u.forEach((M, h) => {
        b.test(h) && u.delete(h);
      });
    })), a(v, p) && u.clear(), e(v, p))
      return y(v, p);
    if (d.has(g)) {
      if (u.has(g)) {
        const b = u.get(g).clone();
        return l && Object.defineProperty(b, l, {
          value: g,
          enumerable: !1
        }), Promise.resolve(b);
      } else if (i.has(g))
        return new Promise((b, M) => {
          i.get(g).push([b, M]);
        });
    }
    return i.has(g) || i.set(g, []), s(g), y(v, p).then((b) => (o(b.clone()) && u.set(g, b.clone()), i.get(g).forEach(([M]) => M(b.clone())), i.delete(g), b)).catch((b) => {
      throw i.get(g).forEach(([, M]) => M(b)), i.delete(g), b;
    });
  };
  return m.cacheResponse = function(y, v) {
    s(y), u.set(y, v);
  }, m.cache = u, m.inflight = i, m.throttling = d, m;
}, Sh = (t, e) => t * e, Th = (t) => t && t.ok, Cu = ({ delayTimer: t = 500, delayRamp: e = Sh, maxAttempts: r = 10, until: a = Th, onRetry: n = null, retryOnNetworkError: o = !1, resolveWithLatestResponse: l = !1, skip: u } = {}) => (i) => (d, s) => {
  let m = 0;
  if (u && u(d, s))
    return i(d, s);
  const y = (v, p) => Promise.resolve(a(v, p)).then((g) => g ? v && l ? v : p ? Promise.reject(p) : v : (m++, !r || m <= r ? new Promise((c) => {
    const b = e(t, m);
    setTimeout(() => {
      typeof n == "function" ? Promise.resolve(n({
        response: v,
        error: p,
        url: d,
        options: s
      })).then((M = {}) => {
        var h, f;
        c(i((h = M && M.url) !== null && h !== void 0 ? h : d, (f = M && M.options) !== null && f !== void 0 ? f : s));
      }) : c(i(d, s));
    }, b);
  }).then(y).catch((c) => {
    if (!o)
      throw c;
    return y(null, c);
  }) : v && l ? v : Promise.reject(p || new Error("Number of attempts exceeded."))));
  return i(d, s).then(y).catch((v) => {
    if (!o)
      throw v;
    return y(null, v);
  });
};
Ze().middlewares([
  Tu(),
  Cu({
    delayRamp: (t, e) => t * e,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  }),
  Dh({
    key: (t, e) => e.headers["X-Cache-Key"],
    throttle: 1e3 * 60 * 60 * 24 * 7
    // 7 days (max safe is ~24.8 days)
  })
]);
Ze().middlewares([
  Tu(),
  Cu({
    delayRamp: (t, e) => t * e,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  })
]);
function Ch(t = {}) {
  return new Ku.QueryClient({
    defaultOptions: {
      queries: {
        retry: 3,
        retryDelay(e) {
          return e * 100;
        }
      }
    },
    ...t
  });
}
const Lh = async (t, e) => {
  const r = Ch(), { nocache: a } = t;
  try {
    await r.prefetchQuery({
      queryFn: () => Ou(e, t, { nocache: a }),
      queryKey: Du(t)
    });
  } catch {
  }
  return {
    dehydratedState: Vu(r)
  };
}, kh = (t) => new Ju({
  defaultOptions: {
    queries: {
      gcTime: t ? 0 : void 0,
      refetchOnMount: !!t,
      staleTime: t ? 0 : 1 / 0
    }
  }
});
function Hh({ dehydratedState: t, deviceType: e, nocache: r, ...a }) {
  const [n] = de(() => {
    const u = kh(r);
    return Qu(u, t), u;
  }), o = /* @__PURE__ */ q(uu, { children: /* @__PURE__ */ q(Gu, { client: n, children: /* @__PURE__ */ q(lu, { i18nInstance: a.i18n, children: /* @__PURE__ */ q(qu, { fallback: /* @__PURE__ */ q(kf, {}), children: /* @__PURE__ */ q(ch, { ...a }) }) }) }) });
  if (typeof window < "u")
    return o;
  const l = e === "MOBILE" ? Dr.phoneSm : e === "TABLET" ? Dr.tablet : Dr.desktop;
  return /* @__PURE__ */ q(rl.Context.Provider, { value: { width: l }, children: o });
}
export {
  Hh as SubeventHeaderWithQuery,
  Lh as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
